import React from 'react';

const Trope3: React.FC = () => {
  return (
    <g
      className="prefix__trope-decor-3 prefix__trope-decor"
      transform="translate(140, 210)"
    >
      <g>
        <g>
          <g>
            <g>
              <path
                d="M1339.74,135.86c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1339.74,135.86Z"
                fill="#2f6840"
              />
              <path
                d="M1339.23,135.51c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16S1347,136.1,1346,136s-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1339.23,135.51Z"
                fill="#3ba525"
              />
              <path
                d="M1340,135.48a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1340,135.48Z"
                fill="#2f6840"
              />
              <path
                d="M1343.46,134.69a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1343.46,134.69Z"
                fill="#2f6840"
              />
              <path
                d="M1342.09,137.9a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1342.09,137.9Z"
                fill="#2f6840"
              />
              <path
                d="M1340.14,135.94c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2.07,2.07,0,0,1,1340.14,135.94Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1337.08,144.58c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,1337.08,144.58Z"
                fill="#2f6840"
              />
              <path
                d="M1336.57,144.24c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1336.57,144.24Z"
                fill="#3ba525"
              />
              <path
                d="M1337.32,144.21a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1337.32,144.21Z"
                fill="#2f6840"
              />
              <path
                d="M1340.8,143.42c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1340.8,143.42Z"
                fill="#2f6840"
              />
              <path
                d="M1339.43,146.63a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1339.43,146.63Z"
                fill="#2f6840"
              />
              <path
                d="M1337.48,144.67c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1337.48,144.67Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1331.72,139.63c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1331.72,139.63Z"
                fill="#2f6840"
              />
              <path
                d="M1331.22,139.28c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1331.22,139.28Z"
                fill="#3ba525"
              />
              <path
                d="M1332,139.25a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1332,139.25Z"
                fill="#2f6840"
              />
              <path
                d="M1335.45,138.46a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1335.45,138.46Z"
                fill="#2f6840"
              />
              <path
                d="M1334.08,141.67a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1334.08,141.67Z"
                fill="#2f6840"
              />
              <path
                d="M1332.12,139.71c-.24.06-.47.09-.69.16a4.54,4.54,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1332.12,139.71Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1323.38,136.26c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1323.38,136.26Z"
                fill="#2f6840"
              />
              <path
                d="M1322.88,135.91c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1322.88,135.91Z"
                fill="#3ba525"
              />
              <path
                d="M1323.63,135.88a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1323.63,135.88Z"
                fill="#2f6840"
              />
              <path
                d="M1327.11,135.09c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1327.11,135.09Z"
                fill="#2f6840"
              />
              <path
                d="M1325.74,138.3a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1325.74,138.3Z"
                fill="#2f6840"
              />
              <path
                d="M1323.78,136.34c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1323.78,136.34Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1338.09,151.74c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1338.09,151.74Z"
                fill="#2f6840"
              />
              <path
                d="M1337.58,151.4c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1337.58,151.4Z"
                fill="#3ba525"
              />
              <path
                d="M1338.33,151.37a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1338.33,151.37Z"
                fill="#2f6840"
              />
              <path
                d="M1341.81,150.58c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1341.81,150.58Z"
                fill="#2f6840"
              />
              <path
                d="M1340.44,153.79a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1340.44,153.79Z"
                fill="#2f6840"
              />
              <path
                d="M1338.49,151.83c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1338.49,151.83Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1324.63,146.18c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1324.63,146.18Z"
                fill="#2f6840"
              />
              <path
                d="M1324.12,145.83c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1324.12,145.83Z"
                fill="#3ba525"
              />
              <path
                d="M1324.88,145.8a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1324.88,145.8Z"
                fill="#2f6840"
              />
              <path
                d="M1328.35,145c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1328.35,145Z"
                fill="#2f6840"
              />
              <path
                d="M1327,148.22a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1327,148.22Z"
                fill="#2f6840"
              />
              <path
                d="M1325,146.26c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1325,146.26Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1352,111.57c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1352,111.57Z"
                fill="#2f6840"
              />
              <path
                d="M1351.47,111.22c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1351.47,111.22Z"
                fill="#3ba525"
              />
              <path
                d="M1352.23,111.2a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1352.23,111.2Z"
                fill="#2f6840"
              />
              <path
                d="M1355.7,110.4c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1355.7,110.4Z"
                fill="#2f6840"
              />
              <path
                d="M1354.34,113.61a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1354.34,113.61Z"
                fill="#2f6840"
              />
              <path
                d="M1352.38,111.66a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1352.38,111.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1349.32,120.3c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1349.32,120.3Z"
                fill="#2f6840"
              />
              <path
                d="M1348.81,120c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1348.81,120Z"
                fill="#3ba525"
              />
              <path
                d="M1349.57,119.93a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1349.57,119.93Z"
                fill="#2f6840"
              />
              <path
                d="M1353,119.13c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1353,119.13Z"
                fill="#2f6840"
              />
              <path
                d="M1351.68,122.34a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1351.68,122.34Z"
                fill="#2f6840"
              />
              <path
                d="M1349.72,120.38c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1349.72,120.38Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1344,115.34c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1344,115.34Z"
                fill="#2f6840"
              />
              <path
                d="M1343.46,115c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1343.46,115Z"
                fill="#3ba525"
              />
              <path
                d="M1344.21,115a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1344.21,115Z"
                fill="#2f6840"
              />
              <path
                d="M1347.69,114.17c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1347.69,114.17Z"
                fill="#2f6840"
              />
              <path
                d="M1346.32,117.38a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1346.32,117.38Z"
                fill="#2f6840"
              />
              <path
                d="M1344.37,115.43c-.25.06-.48.08-.7.15a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1344.37,115.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1335.63,112c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1335.63,112Z"
                fill="#2f6840"
              />
              <path
                d="M1335.12,111.62c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1335.12,111.62Z"
                fill="#3ba525"
              />
              <path
                d="M1335.87,111.6a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1335.87,111.6Z"
                fill="#2f6840"
              />
              <path
                d="M1339.35,110.8c-.26,0-.49,0-.72.1a3.56,3.56,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1339.35,110.8Z"
                fill="#2f6840"
              />
              <path
                d="M1338,114a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1338,114Z"
                fill="#2f6840"
              />
              <path
                d="M1336,112.05c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1336,112.05Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1350.33,127.46c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1350.33,127.46Z"
                fill="#2f6840"
              />
              <path
                d="M1349.82,127.11c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1349.82,127.11Z"
                fill="#3ba525"
              />
              <path
                d="M1350.58,127.08a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1350.58,127.08Z"
                fill="#2f6840"
              />
              <path
                d="M1354.05,126.29c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1354.05,126.29Z"
                fill="#2f6840"
              />
              <path
                d="M1352.69,129.5a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1352.69,129.5Z"
                fill="#2f6840"
              />
              <path
                d="M1350.73,127.54c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1350.73,127.54Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1336.87,121.89c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1336.87,121.89Z"
                fill="#2f6840"
              />
              <path
                d="M1336.37,121.54c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1336.37,121.54Z"
                fill="#3ba525"
              />
              <path
                d="M1337.12,121.52a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1337.12,121.52Z"
                fill="#2f6840"
              />
              <path
                d="M1340.6,120.72c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1340.6,120.72Z"
                fill="#2f6840"
              />
              <path
                d="M1339.23,123.93a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1339.23,123.93Z"
                fill="#2f6840"
              />
              <path
                d="M1337.27,122c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1337.27,122Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1343.28,85.33c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1343.28,85.33Z"
                fill="#2f6840"
              />
              <path
                d="M1342.78,85c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,1342.78,85Z"
                fill="#3ba525"
              />
              <path
                d="M1343.53,85a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1343.53,85Z"
                fill="#2f6840"
              />
              <path
                d="M1347,84.16c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1347,84.16Z"
                fill="#2f6840"
              />
              <path
                d="M1345.64,87.37a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1345.64,87.37Z"
                fill="#2f6840"
              />
              <path
                d="M1343.68,85.42a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1343.68,85.42Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1340.62,94.06c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1340.62,94.06Z"
                fill="#2f6840"
              />
              <path
                d="M1340.12,93.71c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1340.12,93.71Z"
                fill="#3ba525"
              />
              <path
                d="M1340.87,93.69a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.18,2.18,0,0,1,.47.53A1,1,0,0,1,1340.87,93.69Z"
                fill="#2f6840"
              />
              <path
                d="M1344.35,92.89c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1344.35,92.89Z"
                fill="#2f6840"
              />
              <path
                d="M1343,96.1a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1343,96.1Z"
                fill="#2f6840"
              />
              <path
                d="M1341,94.14c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1341,94.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1335.27,89.1c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1335.27,89.1Z"
                fill="#2f6840"
              />
              <path
                d="M1334.76,88.76c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1334.76,88.76Z"
                fill="#3ba525"
              />
              <path
                d="M1335.52,88.73a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1335.52,88.73Z"
                fill="#2f6840"
              />
              <path
                d="M1339,87.93c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1339,87.93Z"
                fill="#2f6840"
              />
              <path
                d="M1337.63,91.14a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1337.63,91.14Z"
                fill="#2f6840"
              />
              <path
                d="M1335.67,89.19a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1335.67,89.19Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1326.93,85.73c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1326.93,85.73Z"
                fill="#2f6840"
              />
              <path
                d="M1326.42,85.38c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1326.42,85.38Z"
                fill="#3ba525"
              />
              <path
                d="M1327.17,85.36a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1327.17,85.36Z"
                fill="#2f6840"
              />
              <path
                d="M1330.65,84.56c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,1330.65,84.56Z"
                fill="#2f6840"
              />
              <path
                d="M1329.28,87.77a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.1,2.1,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1329.28,87.77Z"
                fill="#2f6840"
              />
              <path
                d="M1327.33,85.82a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1327.33,85.82Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1341.63,101.22c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1341.63,101.22Z"
                fill="#2f6840"
              />
              <path
                d="M1341.13,100.87c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1341.13,100.87Z"
                fill="#3ba525"
              />
              <path
                d="M1341.88,100.85a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.18,2.18,0,0,1,.47.53A1,1,0,0,1,1341.88,100.85Z"
                fill="#2f6840"
              />
              <path
                d="M1345.36,100.05c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1345.36,100.05Z"
                fill="#2f6840"
              />
              <path
                d="M1344,103.26a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1344,103.26Z"
                fill="#2f6840"
              />
              <path
                d="M1342,101.3c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1342,101.3Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1328.17,95.65c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1328.17,95.65Z"
                fill="#2f6840"
              />
              <path
                d="M1327.67,95.3c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1327.67,95.3Z"
                fill="#3ba525"
              />
              <path
                d="M1328.42,95.28a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1328.42,95.28Z"
                fill="#2f6840"
              />
              <path
                d="M1331.9,94.48c-.26,0-.49,0-.72.1a3.56,3.56,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1331.9,94.48Z"
                fill="#2f6840"
              />
              <path
                d="M1330.53,97.69a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1330.53,97.69Z"
                fill="#2f6840"
              />
              <path
                d="M1328.57,95.74a7,7,0,0,0-.69.15,4.54,4.54,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1328.57,95.74Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1320.66,68.34c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1320.66,68.34Z"
                fill="#2f6840"
              />
              <path
                d="M1320.16,68c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1320.16,68Z"
                fill="#3ba525"
              />
              <path
                d="M1320.91,68a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1320.91,68Z"
                fill="#2f6840"
              />
              <path
                d="M1324.39,67.18c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1324.39,67.18Z"
                fill="#2f6840"
              />
              <path
                d="M1323,70.39a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1323,70.39Z"
                fill="#2f6840"
              />
              <path
                d="M1321.06,68.43c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1321.06,68.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1318,77.07c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1318,77.07Z"
                fill="#2f6840"
              />
              <path
                d="M1317.5,76.73c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1317.5,76.73Z"
                fill="#3ba525"
              />
              <path
                d="M1318.25,76.7a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1318.25,76.7Z"
                fill="#2f6840"
              />
              <path
                d="M1321.73,75.91c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1321.73,75.91Z"
                fill="#2f6840"
              />
              <path
                d="M1320.36,79.12a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1320.36,79.12Z"
                fill="#2f6840"
              />
              <path
                d="M1318.4,77.16c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1318.4,77.16Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1312.65,72.12c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1312.65,72.12Z"
                fill="#2f6840"
              />
              <path
                d="M1312.14,71.77c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1312.14,71.77Z"
                fill="#3ba525"
              />
              <path
                d="M1312.9,71.74a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1312.9,71.74Z"
                fill="#2f6840"
              />
              <path
                d="M1316.37,71c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.23-.86A2.07,2.07,0,0,1,1316.37,71Z"
                fill="#2f6840"
              />
              <path
                d="M1315,74.16a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1315,74.16Z"
                fill="#2f6840"
              />
              <path
                d="M1313.05,72.2c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1313.05,72.2Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1304.31,68.74c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1304.31,68.74Z"
                fill="#2f6840"
              />
              <path
                d="M1303.8,68.4c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1303.8,68.4Z"
                fill="#3ba525"
              />
              <path
                d="M1304.55,68.37a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1304.55,68.37Z"
                fill="#2f6840"
              />
              <path
                d="M1308,67.58c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1308,67.58Z"
                fill="#2f6840"
              />
              <path
                d="M1306.66,70.79a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1306.66,70.79Z"
                fill="#2f6840"
              />
              <path
                d="M1304.71,68.83c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1304.71,68.83Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1319,84.23c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1319,84.23Z"
                fill="#2f6840"
              />
              <path
                d="M1318.51,83.89c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55S1313.78,85,1314,85A14.56,14.56,0,0,1,1318.51,83.89Z"
                fill="#3ba525"
              />
              <path
                d="M1319.26,83.86a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1319.26,83.86Z"
                fill="#2f6840"
              />
              <path
                d="M1322.74,83.07c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1322.74,83.07Z"
                fill="#2f6840"
              />
              <path
                d="M1321.37,86.28a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8A2.13,2.13,0,0,1,1321,85a1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1321.37,86.28Z"
                fill="#2f6840"
              />
              <path
                d="M1319.41,84.32c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1319.41,84.32Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1305.55,78.66c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1305.55,78.66Z"
                fill="#2f6840"
              />
              <path
                d="M1305.05,78.32c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1305.05,78.32Z"
                fill="#3ba525"
              />
              <path
                d="M1305.8,78.29a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1305.8,78.29Z"
                fill="#2f6840"
              />
              <path
                d="M1309.28,77.5c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1309.28,77.5Z"
                fill="#2f6840"
              />
              <path
                d="M1307.91,80.71a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1307.91,80.71Z"
                fill="#2f6840"
              />
              <path
                d="M1306,78.75c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1306,78.75Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M1310.31,91.22l3.53,2.19a1.15,1.15,0,0,0,1.08.07l8.47-3.79a1.14,1.14,0,0,0,.28-1.91h0a1.13,1.13,0,0,0-.9-.27l-12,1.6A1.15,1.15,0,0,0,1310.31,91.22Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1316.58 82.45 1311.8 83.47 1307.59 86.7 1314.64 89.53 1323.28 85.99 1316.58 82.45"
              fill="#ffedc8"
            />
            <polygon
              points="1307.59 86.7 1307.59 89.53 1314.36 92.43 1323.47 88.73 1323.28 85.99 1314.64 89.53 1307.59 86.7"
              fill="#ccae79"
            />
            <polygon
              points="1314.64 89.53 1314.36 92.43 1323.47 88.73 1323.28 85.99 1314.64 89.53"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1309.61,87.51a1.28,1.28,0,0,1,0,1.45c.31-.46.39-1.29.53-1.24Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1312.58,88.7a4,4,0,0,0,1.78-1.81l-1.28,2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1318.21,88.07a1.29,1.29,0,0,1,.7,1.14l-.21-1.34Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1321.37,85a8.58,8.58,0,0,1-2.81,0,4,4,0,0,1-2,.14s1.5-.14,2,.37A12.31,12.31,0,0,1,1321.37,85Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1326.41,83.07l4.74,2.94a1.54,1.54,0,0,0,1.44.1L1344,81a1.54,1.54,0,0,0,.39-2.57h0a1.55,1.55,0,0,0-1.22-.36L1327,80.23A1.54,1.54,0,0,0,1326.41,83.07Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1334.83 71.3 1328.41 72.66 1322.76 77 1332.23 80.8 1343.83 76.05 1334.83 71.3"
              fill="#ffedc8"
            />
            <polygon
              points="1322.76 77 1322.76 80.8 1331.85 84.69 1344.08 79.73 1343.83 76.05 1332.23 80.8 1322.76 77"
              fill="#ccae79"
            />
            <polygon
              points="1332.23 80.8 1331.85 84.69 1344.08 79.73 1343.83 76.05 1332.23 80.8"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1325.46,78.09a1.71,1.71,0,0,1,0,2c.43-.62.53-1.74.73-1.66Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1329.46,79.69a5.43,5.43,0,0,0,2.39-2.43l-1.72,2.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1337,78.84a1.73,1.73,0,0,1,.94,1.53l-.28-1.8Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1341.26,74.69c-.12-.06-2.4.46-3.76,0a5.32,5.32,0,0,1-2.75.19s2-.19,2.75.5A16.21,16.21,0,0,1,1341.26,74.69Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1349,128.15l4,2.51a1.33,1.33,0,0,0,1.24.08l9.72-4.34a1.32,1.32,0,0,0,.32-2.2h0a1.33,1.33,0,0,0-1-.31l-13.77,1.83A1.32,1.32,0,0,0,1349,128.15Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1356.22 118.09 1350.74 119.25 1345.91 122.97 1354.01 126.21 1363.91 122.15 1356.22 118.09"
              fill="#ffedc8"
            />
            <polygon
              points="1345.91 122.97 1345.91 126.21 1353.68 129.53 1364.13 125.29 1363.91 122.15 1354.01 126.21 1345.91 122.97"
              fill="#ccae79"
            />
            <polygon
              points="1354.01 126.21 1353.68 129.53 1364.13 125.29 1363.91 122.15 1354.01 126.21"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1348.22,123.89a1.46,1.46,0,0,1,0,1.67c.37-.53.45-1.49.62-1.42Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1351.64,125.26a4.64,4.64,0,0,0,2-2.08l-1.47,2.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1358.1,124.53a1.5,1.5,0,0,1,.8,1.31l-.24-1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1361.72,121a9.35,9.35,0,0,1-3.22,0,4.67,4.67,0,0,1-2.34.17s1.72-.17,2.34.42A13.81,13.81,0,0,1,1361.72,121Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1324.05,123.8l4,2.51a1.33,1.33,0,0,0,1.24.08l9.71-4.34a1.32,1.32,0,0,0,.33-2.2h0a1.31,1.31,0,0,0-1-.31l-13.76,1.83A1.32,1.32,0,0,0,1324.05,123.8Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1331.23 113.74 1325.75 114.91 1320.92 118.61 1329.01 121.86 1338.92 117.8 1331.23 113.74"
              fill="#ffedc8"
            />
            <polygon
              points="1320.92 118.61 1320.92 121.86 1328.69 125.19 1339.14 120.94 1338.92 117.8 1329.01 121.86 1320.92 118.61"
              fill="#ccae79"
            />
            <polygon
              points="1329.01 121.86 1328.69 125.19 1339.14 120.94 1338.92 117.8 1329.01 121.86"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1323.23,119.54a1.44,1.44,0,0,1,0,1.66c.37-.52.45-1.48.62-1.41Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1326.65,120.91a4.64,4.64,0,0,0,2-2.08l-1.47,2.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1333.11,120.18a1.5,1.5,0,0,1,.8,1.31l-.24-1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1336.73,116.64a9.35,9.35,0,0,1-3.22,0,4.67,4.67,0,0,1-2.34.17s1.72-.17,2.34.42A13.81,13.81,0,0,1,1336.73,116.64Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1325.2,102.13l4.74,2.94a1.54,1.54,0,0,0,1.44.1l11.38-5.09a1.54,1.54,0,0,0,.38-2.57h0a1.52,1.52,0,0,0-1.21-.36l-16.12,2.14A1.54,1.54,0,0,0,1325.2,102.13Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1333.62 90.36 1327.2 91.72 1321.55 96.06 1331.02 99.86 1342.62 95.11 1333.62 90.36"
              fill="#ffedc8"
            />
            <polygon
              points="1321.55 96.06 1321.55 99.86 1330.64 103.76 1342.87 98.79 1342.62 95.11 1331.02 99.86 1321.55 96.06"
              fill="#ccae79"
            />
            <polygon
              points="1331.02 99.86 1330.64 103.76 1342.87 98.79 1342.62 95.11 1331.02 99.86"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1324.25,97.15a1.71,1.71,0,0,1,0,1.95c.43-.61.53-1.74.73-1.66Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1328.25,98.75a5.41,5.41,0,0,0,2.39-2.43l-1.72,2.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1335.81,97.9a1.73,1.73,0,0,1,.94,1.53l-.28-1.8Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1340.05,93.75c-.12-.06-2.4.47-3.77,0a5.37,5.37,0,0,1-2.74.2s2-.2,2.74.49A16.36,16.36,0,0,1,1340.05,93.75Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1347.51,94.26l3.53,2.19a1.13,1.13,0,0,0,1.07.07l8.48-3.78a1.15,1.15,0,0,0,.28-1.92h0a1.18,1.18,0,0,0-.9-.27l-12,1.6A1.15,1.15,0,0,0,1347.51,94.26Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1353.78 85.5 1349 86.51 1344.79 89.74 1351.84 92.57 1360.48 89.03 1353.78 85.5"
              fill="#ffedc8"
            />
            <polygon
              points="1344.79 89.74 1344.79 92.57 1351.56 95.47 1360.67 91.77 1360.48 89.03 1351.84 92.57 1344.79 89.74"
              fill="#ccae79"
            />
            <polygon
              points="1351.84 92.57 1351.56 95.47 1360.67 91.77 1360.48 89.03 1351.84 92.57"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1346.8,90.55a1.26,1.26,0,0,1,0,1.45c.32-.45.4-1.29.54-1.23S1346.8,90.55,1346.8,90.55Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1349.78,91.74a4,4,0,0,0,1.78-1.81l-1.28,2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1355.41,91.11a1.31,1.31,0,0,1,.7,1.14l-.21-1.34Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1358.57,88a8.3,8.3,0,0,1-2.81,0,4,4,0,0,1-2,.14s1.5-.14,2,.37A12.22,12.22,0,0,1,1358.57,88Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1328,134.55s1.85,3.67,4.43,4.3,6.47-1.95,5.87.17,4.85,3.07,7.19,2.49,7.48-5.58,7.45-7.17S1328,134.55,1328,134.55Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1328,131.53l.09,3,4.44,3.09,5.75-.16,1.36,2.21s4,1.86,6.62-.17a21.56,21.56,0,0,0,4.65-5.59l-.08-3Z"
              fill="#ccae79"
            />
            <path
              d="M1332.58,129.44l-4.63,2.09,4.77,3.07,5.49-.14,1.85,2.26s5.41,1.46,6.06-.16,4.66-5.65,4.66-5.65l-4.33-1.84Z"
              fill="#ffedc8"
            />
            <polygon
              points="1332.72 134.6 1332.48 137.64 1338.23 137.48 1338.21 134.46 1332.72 134.6"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1344.76,137.28s.94,2.75.08,2.94a13.21,13.21,0,0,0,6-6.29l-.08-3S1346,137.27,1344.76,137.28Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1341,137l1.09.2s-.68-.18-.51,1.09A3.08,3.08,0,0,0,1341,137Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1343.54,137.34c-.12,0,.21,0,1.19-1a6.37,6.37,0,0,0,1.34-2.08s-2.33,2.7-1.76,3.08Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1330.74,133.33a19,19,0,0,1,.06,2.18s-.13-1.64.33-1.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1339.19,129.27l2.19-.06c.16,0-1.72,0-2.16,1l0-1"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1330.28,130.48l1.15-.52s-.65.42-.39.5,1.29.5,1.69.28a1.69,1.69,0,0,1,1.1,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M1077.42,188.79c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1077.42,188.79Z"
                fill="#2f6840"
              />
              <path
                d="M1076.91,188.45c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1076.91,188.45Z"
                fill="#3ba525"
              />
              <path
                d="M1077.66,188.42a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1077.66,188.42Z"
                fill="#2f6840"
              />
              <path
                d="M1081.14,187.62c-.26,0-.49,0-.72.1a4.83,4.83,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1081.14,187.62Z"
                fill="#2f6840"
              />
              <path
                d="M1079.77,190.83a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1079.77,190.83Z"
                fill="#2f6840"
              />
              <path
                d="M1077.81,188.88a7,7,0,0,0-.69.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1077.81,188.88Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1074.76,197.52c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1074.76,197.52Z"
                fill="#2f6840"
              />
              <path
                d="M1074.25,197.18c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1074.25,197.18Z"
                fill="#3ba525"
              />
              <path
                d="M1075,197.15a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1075,197.15Z"
                fill="#2f6840"
              />
              <path
                d="M1078.48,196.35c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1078.48,196.35Z"
                fill="#2f6840"
              />
              <path
                d="M1077.11,199.56a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1077.11,199.56Z"
                fill="#2f6840"
              />
              <path
                d="M1075.15,197.61a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1075.15,197.61Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1069.4,192.56c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1069.4,192.56Z"
                fill="#2f6840"
              />
              <path
                d="M1068.9,192.22c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1068.9,192.22Z"
                fill="#3ba525"
              />
              <path
                d="M1069.65,192.19a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1069.65,192.19Z"
                fill="#2f6840"
              />
              <path
                d="M1073.13,191.39c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1073.13,191.39Z"
                fill="#2f6840"
              />
              <path
                d="M1071.76,194.6a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1071.76,194.6Z"
                fill="#2f6840"
              />
              <path
                d="M1069.8,192.65c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1069.8,192.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1061.06,189.19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1061.06,189.19Z"
                fill="#2f6840"
              />
              <path
                d="M1060.56,188.85c4.42-.26-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,1060.56,188.85Z"
                fill="#3ba525"
              />
              <path
                d="M1061.31,188.82a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.07,2.07,0,0,1,.48.54A1,1,0,0,1,1061.31,188.82Z"
                fill="#2f6840"
              />
              <path
                d="M1064.79,188c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1064.79,188Z"
                fill="#2f6840"
              />
              <path
                d="M1063.42,191.23a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1063.42,191.23Z"
                fill="#2f6840"
              />
              <path
                d="M1061.46,189.28c-.25.06-.48.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1061.46,189.28Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1075.77,204.68c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1075.77,204.68Z"
                fill="#2f6840"
              />
              <path
                d="M1075.26,204.33c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1075.26,204.33Z"
                fill="#3ba525"
              />
              <path
                d="M1076,204.31a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1076,204.31Z"
                fill="#2f6840"
              />
              <path
                d="M1079.49,203.51c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1079.49,203.51Z"
                fill="#2f6840"
              />
              <path
                d="M1078.12,206.72a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1078.12,206.72Z"
                fill="#2f6840"
              />
              <path
                d="M1076.16,204.77a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1076.16,204.77Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1062.31,199.11c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1062.31,199.11Z"
                fill="#2f6840"
              />
              <path
                d="M1061.8,198.77c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1061.8,198.77Z"
                fill="#3ba525"
              />
              <path
                d="M1062.56,198.74a2.17,2.17,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1062.56,198.74Z"
                fill="#2f6840"
              />
              <path
                d="M1066,197.94c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1066,197.94Z"
                fill="#2f6840"
              />
              <path
                d="M1064.67,201.15a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1064.67,201.15Z"
                fill="#2f6840"
              />
              <path
                d="M1062.71,199.2a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1062.71,199.2Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1091.05,171.84c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1091.05,171.84Z"
                fill="#2f6840"
              />
              <path
                d="M1090.55,171.49c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1090.55,171.49Z"
                fill="#3ba525"
              />
              <path
                d="M1091.3,171.46a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1091.3,171.46Z"
                fill="#2f6840"
              />
              <path
                d="M1094.78,170.67c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1094.78,170.67Z"
                fill="#2f6840"
              />
              <path
                d="M1093.41,173.88a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1093.41,173.88Z"
                fill="#2f6840"
              />
              <path
                d="M1091.45,171.92c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1091.45,171.92Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1088.39,180.57c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1088.39,180.57Z"
                fill="#2f6840"
              />
              <path
                d="M1087.89,180.22c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1087.89,180.22Z"
                fill="#3ba525"
              />
              <path
                d="M1088.64,180.19a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1088.64,180.19Z"
                fill="#2f6840"
              />
              <path
                d="M1092.12,179.4a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1092.12,179.4Z"
                fill="#2f6840"
              />
              <path
                d="M1090.75,182.61a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1090.75,182.61Z"
                fill="#2f6840"
              />
              <path
                d="M1088.79,180.65c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1088.79,180.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1083,175.61c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1083,175.61Z"
                fill="#2f6840"
              />
              <path
                d="M1082.54,175.26c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1082.54,175.26Z"
                fill="#3ba525"
              />
              <path
                d="M1083.29,175.24a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.48.53A1,1,0,0,1,1083.29,175.24Z"
                fill="#2f6840"
              />
              <path
                d="M1086.77,174.44c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1086.77,174.44Z"
                fill="#2f6840"
              />
              <path
                d="M1085.4,177.65a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1085.4,177.65Z"
                fill="#2f6840"
              />
              <path
                d="M1083.44,175.7a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1083.44,175.7Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1074.7,172.24c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1074.7,172.24Z"
                fill="#2f6840"
              />
              <path
                d="M1074.19,171.89c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1074.19,171.89Z"
                fill="#3ba525"
              />
              <path
                d="M1075,171.86a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1075,171.86Z"
                fill="#2f6840"
              />
              <path
                d="M1078.42,171.07c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1078.42,171.07Z"
                fill="#2f6840"
              />
              <path
                d="M1077.06,174.28a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1077.06,174.28Z"
                fill="#2f6840"
              />
              <path
                d="M1075.1,172.32c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1075.1,172.32Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1089.4,187.73c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1089.4,187.73Z"
                fill="#2f6840"
              />
              <path
                d="M1088.9,187.38c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1088.9,187.38Z"
                fill="#3ba525"
              />
              <path
                d="M1089.65,187.35a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1089.65,187.35Z"
                fill="#2f6840"
              />
              <path
                d="M1093.13,186.56a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1093.13,186.56Z"
                fill="#2f6840"
              />
              <path
                d="M1091.76,189.77a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1091.76,189.77Z"
                fill="#2f6840"
              />
              <path
                d="M1089.8,187.81c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1089.8,187.81Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1076,182.16c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1076,182.16Z"
                fill="#2f6840"
              />
              <path
                d="M1075.44,181.81c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1075.44,181.81Z"
                fill="#3ba525"
              />
              <path
                d="M1076.19,181.78a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1076.19,181.78Z"
                fill="#2f6840"
              />
              <path
                d="M1079.67,181c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1079.67,181Z"
                fill="#2f6840"
              />
              <path
                d="M1078.3,184.2a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1078.3,184.2Z"
                fill="#2f6840"
              />
              <path
                d="M1076.35,182.24c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1076.35,182.24Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1119.44,174c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1119.44,174Z"
                fill="#2f6840"
              />
              <path
                d="M1118.93,173.65c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1118.93,173.65Z"
                fill="#3ba525"
              />
              <path
                d="M1119.69,173.62a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1119.69,173.62Z"
                fill="#2f6840"
              />
              <path
                d="M1123.16,172.82c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1123.16,172.82Z"
                fill="#2f6840"
              />
              <path
                d="M1121.8,176a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1121.8,176Z"
                fill="#2f6840"
              />
              <path
                d="M1119.84,174.08c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1119.84,174.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1116.78,182.72c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1116.78,182.72Z"
                fill="#2f6840"
              />
              <path
                d="M1116.27,182.38c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1116.27,182.38Z"
                fill="#3ba525"
              />
              <path
                d="M1117,182.35a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1117,182.35Z"
                fill="#2f6840"
              />
              <path
                d="M1120.5,181.55c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1120.5,181.55Z"
                fill="#2f6840"
              />
              <path
                d="M1119.14,184.76a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1119.14,184.76Z"
                fill="#2f6840"
              />
              <path
                d="M1117.18,182.81a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1117.18,182.81Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1111.43,177.76c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1111.43,177.76Z"
                fill="#2f6840"
              />
              <path
                d="M1110.92,177.42c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1110.92,177.42Z"
                fill="#3ba525"
              />
              <path
                d="M1111.67,177.39a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1111.67,177.39Z"
                fill="#2f6840"
              />
              <path
                d="M1115.15,176.59c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1115.15,176.59Z"
                fill="#2f6840"
              />
              <path
                d="M1113.78,179.8a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1113.78,179.8Z"
                fill="#2f6840"
              />
              <path
                d="M1111.83,177.85c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,1111.83,177.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1103.08,174.39c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1103.08,174.39Z"
                fill="#2f6840"
              />
              <path
                d="M1102.58,174.05c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1102.58,174.05Z"
                fill="#3ba525"
              />
              <path
                d="M1103.33,174a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1103.33,174Z"
                fill="#2f6840"
              />
              <path
                d="M1106.81,173.22c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1106.81,173.22Z"
                fill="#2f6840"
              />
              <path
                d="M1105.44,176.43a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1105.44,176.43Z"
                fill="#2f6840"
              />
              <path
                d="M1103.48,174.48c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1103.48,174.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1117.79,189.88c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1117.79,189.88Z"
                fill="#2f6840"
              />
              <path
                d="M1117.28,189.54c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1117.28,189.54Z"
                fill="#3ba525"
              />
              <path
                d="M1118,189.51a2.17,2.17,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1118,189.51Z"
                fill="#2f6840"
              />
              <path
                d="M1121.51,188.71c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1121.51,188.71Z"
                fill="#2f6840"
              />
              <path
                d="M1120.15,191.92a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1120.15,191.92Z"
                fill="#2f6840"
              />
              <path
                d="M1118.19,190a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1118.19,190Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1104.33,184.31c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1104.33,184.31Z"
                fill="#2f6840"
              />
              <path
                d="M1103.83,184c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1103.83,184Z"
                fill="#3ba525"
              />
              <path
                d="M1104.58,183.94a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.23,2.23,0,0,1,.47.54A1,1,0,0,1,1104.58,183.94Z"
                fill="#2f6840"
              />
              <path
                d="M1108.06,183.14c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1108.06,183.14Z"
                fill="#2f6840"
              />
              <path
                d="M1106.69,186.35a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1106.69,186.35Z"
                fill="#2f6840"
              />
              <path
                d="M1104.73,184.4a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1104.73,184.4Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1146.84,167.44c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1146.84,167.44Z"
                fill="#2f6840"
              />
              <path
                d="M1146.34,167.1c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1146.34,167.1Z"
                fill="#3ba525"
              />
              <path
                d="M1147.09,167.07a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1147.09,167.07Z"
                fill="#2f6840"
              />
              <path
                d="M1150.57,166.28c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1150.57,166.28Z"
                fill="#2f6840"
              />
              <path
                d="M1149.2,169.49a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1149.2,169.49Z"
                fill="#2f6840"
              />
              <path
                d="M1147.24,167.53c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1147.24,167.53Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1144.19,176.17c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1144.19,176.17Z"
                fill="#2f6840"
              />
              <path
                d="M1143.68,175.83c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1143.68,175.83Z"
                fill="#3ba525"
              />
              <path
                d="M1144.43,175.8a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1144.43,175.8Z"
                fill="#2f6840"
              />
              <path
                d="M1147.91,175c-.26,0-.49.05-.72.1a3.77,3.77,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1147.91,175Z"
                fill="#2f6840"
              />
              <path
                d="M1146.54,178.21a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1146.54,178.21Z"
                fill="#2f6840"
              />
              <path
                d="M1144.58,176.26c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1144.58,176.26Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1138.83,171.21c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1138.83,171.21Z"
                fill="#2f6840"
              />
              <path
                d="M1138.33,170.87c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1138.33,170.87Z"
                fill="#3ba525"
              />
              <path
                d="M1139.08,170.84a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1139.08,170.84Z"
                fill="#2f6840"
              />
              <path
                d="M1142.56,170.05c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1142.56,170.05Z"
                fill="#2f6840"
              />
              <path
                d="M1141.19,173.26a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1141.19,173.26Z"
                fill="#2f6840"
              />
              <path
                d="M1139.23,171.3c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1139.23,171.3Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1130.49,167.84c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1130.49,167.84Z"
                fill="#2f6840"
              />
              <path
                d="M1130,167.5c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1130,167.5Z"
                fill="#3ba525"
              />
              <path
                d="M1130.74,167.47a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1130.74,167.47Z"
                fill="#2f6840"
              />
              <path
                d="M1134.21,166.67c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1134.21,166.67Z"
                fill="#2f6840"
              />
              <path
                d="M1132.85,169.88a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1132.85,169.88Z"
                fill="#2f6840"
              />
              <path
                d="M1130.89,167.93c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1130.89,167.93Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1145.19,183.33c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1145.19,183.33Z"
                fill="#2f6840"
              />
              <path
                d="M1144.69,183c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1144.69,183Z"
                fill="#3ba525"
              />
              <path
                d="M1145.44,183a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1145.44,183Z"
                fill="#2f6840"
              />
              <path
                d="M1148.92,182.16c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1148.92,182.16Z"
                fill="#2f6840"
              />
              <path
                d="M1147.55,185.37a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1147.55,185.37Z"
                fill="#2f6840"
              />
              <path
                d="M1145.59,183.42c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1145.59,183.42Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1131.74,177.76c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1131.74,177.76Z"
                fill="#2f6840"
              />
              <path
                d="M1131.23,177.42c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1131.23,177.42Z"
                fill="#3ba525"
              />
              <path
                d="M1132,177.39a2.24,2.24,0,0,0-.8-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1132,177.39Z"
                fill="#2f6840"
              />
              <path
                d="M1135.46,176.59c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,1135.46,176.59Z"
                fill="#2f6840"
              />
              <path
                d="M1134.09,179.8a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1134.09,179.8Z"
                fill="#2f6840"
              />
              <path
                d="M1132.14,177.85c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1132.14,177.85Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1174.26,160.24c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1174.26,160.24Z"
                fill="#2f6840"
              />
              <path
                d="M1173.76,159.89c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S1169,161,1169.21,161A14.65,14.65,0,0,1,1173.76,159.89Z"
                fill="#3ba525"
              />
              <path
                d="M1174.51,159.86a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1174.51,159.86Z"
                fill="#2f6840"
              />
              <path
                d="M1178,159.07c-.26,0-.49,0-.72.1a3.56,3.56,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1178,159.07Z"
                fill="#2f6840"
              />
              <path
                d="M1176.62,162.28a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1176.62,162.28Z"
                fill="#2f6840"
              />
              <path
                d="M1174.66,160.32c-.24.06-.47.09-.69.16a4.54,4.54,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1174.66,160.32Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1171.61,169c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1171.61,169Z"
                fill="#2f6840"
              />
              <path
                d="M1171.1,168.62c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1171.1,168.62Z"
                fill="#3ba525"
              />
              <path
                d="M1171.85,168.59a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1171.85,168.59Z"
                fill="#2f6840"
              />
              <path
                d="M1175.33,167.8a5.21,5.21,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1175.33,167.8Z"
                fill="#2f6840"
              />
              <path
                d="M1174,171a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1174,171Z"
                fill="#2f6840"
              />
              <path
                d="M1172,169.05c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1172,169.05Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1166.25,164c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1166.25,164Z"
                fill="#2f6840"
              />
              <path
                d="M1165.75,163.66c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1165.75,163.66Z"
                fill="#3ba525"
              />
              <path
                d="M1166.5,163.64a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1166.5,163.64Z"
                fill="#2f6840"
              />
              <path
                d="M1170,162.84c-.26,0-.49,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1170,162.84Z"
                fill="#2f6840"
              />
              <path
                d="M1168.61,166.05a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1168.61,166.05Z"
                fill="#2f6840"
              />
              <path
                d="M1166.65,164.1c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1166.65,164.1Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1157.91,160.64c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1157.91,160.64Z"
                fill="#2f6840"
              />
              <path
                d="M1157.4,160.29c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1157.4,160.29Z"
                fill="#3ba525"
              />
              <path
                d="M1158.16,160.26a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1158.16,160.26Z"
                fill="#2f6840"
              />
              <path
                d="M1161.64,159.47c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1161.64,159.47Z"
                fill="#2f6840"
              />
              <path
                d="M1160.27,162.68a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1160.27,162.68Z"
                fill="#2f6840"
              />
              <path
                d="M1158.31,160.72c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1158.31,160.72Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1172.62,176.13c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1172.62,176.13Z"
                fill="#2f6840"
              />
              <path
                d="M1172.11,175.78c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1172.11,175.78Z"
                fill="#3ba525"
              />
              <path
                d="M1172.86,175.75a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1172.86,175.75Z"
                fill="#2f6840"
              />
              <path
                d="M1176.34,175a5.21,5.21,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1176.34,175Z"
                fill="#2f6840"
              />
              <path
                d="M1175,178.17a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1175,178.17Z"
                fill="#2f6840"
              />
              <path
                d="M1173,176.21c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1173,176.21Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1159.16,170.56c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1159.16,170.56Z"
                fill="#2f6840"
              />
              <path
                d="M1158.65,170.21c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1158.65,170.21Z"
                fill="#3ba525"
              />
              <path
                d="M1159.41,170.18a2.21,2.21,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1159.41,170.18Z"
                fill="#2f6840"
              />
              <path
                d="M1162.88,169.39c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,12.94,12.94,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1162.88,169.39Z"
                fill="#2f6840"
              />
              <path
                d="M1161.52,172.6a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1161.52,172.6Z"
                fill="#2f6840"
              />
              <path
                d="M1159.56,170.64c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1159.56,170.64Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M1172.37,399.51c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1172.37,399.51Z"
                fill="#2f6840"
              />
              <path
                d="M1171.87,399.17c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1171.87,399.17Z"
                fill="#3ba525"
              />
              <path
                d="M1172.62,399.14a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,2,2,0,0,1,.47.53A1,1,0,0,1,1172.62,399.14Z"
                fill="#2f6840"
              />
              <path
                d="M1176.1,398.34c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1176.1,398.34Z"
                fill="#2f6840"
              />
              <path
                d="M1174.73,401.55a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1174.73,401.55Z"
                fill="#2f6840"
              />
              <path
                d="M1172.77,399.6c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1172.77,399.6Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1169.71,408.24c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.46,14.46,0,0,1,1169.71,408.24Z"
                fill="#2f6840"
              />
              <path
                d="M1169.21,407.9c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1169.21,407.9Z"
                fill="#3ba525"
              />
              <path
                d="M1170,407.87a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1170,407.87Z"
                fill="#2f6840"
              />
              <path
                d="M1173.44,407.07c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1173.44,407.07Z"
                fill="#2f6840"
              />
              <path
                d="M1172.07,410.28a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1172.07,410.28Z"
                fill="#2f6840"
              />
              <path
                d="M1170.11,408.33a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1170.11,408.33Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1164.36,403.28c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1164.36,403.28Z"
                fill="#2f6840"
              />
              <path
                d="M1163.85,402.94c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1163.85,402.94Z"
                fill="#3ba525"
              />
              <path
                d="M1164.61,402.91a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1164.61,402.91Z"
                fill="#2f6840"
              />
              <path
                d="M1168.08,402.11c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1168.08,402.11Z"
                fill="#2f6840"
              />
              <path
                d="M1166.72,405.32a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1166.72,405.32Z"
                fill="#2f6840"
              />
              <path
                d="M1164.76,403.37c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1164.76,403.37Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1156,399.91c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1156,399.91Z"
                fill="#2f6840"
              />
              <path
                d="M1155.51,399.57c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1155.51,399.57Z"
                fill="#3ba525"
              />
              <path
                d="M1156.26,399.54a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1156.26,399.54Z"
                fill="#2f6840"
              />
              <path
                d="M1159.74,398.74c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1159.74,398.74Z"
                fill="#2f6840"
              />
              <path
                d="M1158.37,402a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1158.37,402Z"
                fill="#2f6840"
              />
              <path
                d="M1156.42,400a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1156.42,400Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1170.72,415.4c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1170.72,415.4Z"
                fill="#2f6840"
              />
              <path
                d="M1170.22,415.06c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1170.22,415.06Z"
                fill="#3ba525"
              />
              <path
                d="M1171,415a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.23,2.23,0,0,1,.47.54A1,1,0,0,1,1171,415Z"
                fill="#2f6840"
              />
              <path
                d="M1174.45,414.23c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1174.45,414.23Z"
                fill="#2f6840"
              />
              <path
                d="M1173.08,417.44a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1173.08,417.44Z"
                fill="#2f6840"
              />
              <path
                d="M1171.12,415.49c-.25.06-.48.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1171.12,415.49Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1157.27,409.83c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1157.27,409.83Z"
                fill="#2f6840"
              />
              <path
                d="M1156.76,409.49c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1156.76,409.49Z"
                fill="#3ba525"
              />
              <path
                d="M1157.51,409.46a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1157.51,409.46Z"
                fill="#2f6840"
              />
              <path
                d="M1161,408.66c-.26,0-.49,0-.72.1a4.51,4.51,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1161,408.66Z"
                fill="#2f6840"
              />
              <path
                d="M1159.62,411.87a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1159.62,411.87Z"
                fill="#2f6840"
              />
              <path
                d="M1157.66,409.92a7,7,0,0,0-.69.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1157.66,409.92Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1198.37,388.06c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1198.37,388.06Z"
                fill="#2f6840"
              />
              <path
                d="M1197.86,387.72c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1197.86,387.72Z"
                fill="#3ba525"
              />
              <path
                d="M1198.61,387.69a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1198.61,387.69Z"
                fill="#2f6840"
              />
              <path
                d="M1202.09,386.9c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1202.09,386.9Z"
                fill="#2f6840"
              />
              <path
                d="M1200.72,390.11a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1200.72,390.11Z"
                fill="#2f6840"
              />
              <path
                d="M1198.76,388.15c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1198.76,388.15Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1195.71,396.79c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1195.71,396.79Z"
                fill="#2f6840"
              />
              <path
                d="M1195.2,396.45c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1195.2,396.45Z"
                fill="#3ba525"
              />
              <path
                d="M1196,396.42a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1196,396.42Z"
                fill="#2f6840"
              />
              <path
                d="M1199.43,395.62c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1199.43,395.62Z"
                fill="#2f6840"
              />
              <path
                d="M1198.06,398.83a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1198.06,398.83Z"
                fill="#2f6840"
              />
              <path
                d="M1196.11,396.88c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1196.11,396.88Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1190.35,391.83c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1190.35,391.83Z"
                fill="#2f6840"
              />
              <path
                d="M1189.85,391.49c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1189.85,391.49Z"
                fill="#3ba525"
              />
              <path
                d="M1190.6,391.46a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1190.6,391.46Z"
                fill="#2f6840"
              />
              <path
                d="M1194.08,390.67c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1194.08,390.67Z"
                fill="#2f6840"
              />
              <path
                d="M1192.71,393.88a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1192.71,393.88Z"
                fill="#2f6840"
              />
              <path
                d="M1190.75,391.92c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1190.75,391.92Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1182,388.46c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1182,388.46Z"
                fill="#2f6840"
              />
              <path
                d="M1181.51,388.12c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72S1182,389,1182,389s-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1181.51,388.12Z"
                fill="#3ba525"
              />
              <path
                d="M1182.26,388.09a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1182.26,388.09Z"
                fill="#2f6840"
              />
              <path
                d="M1185.74,387.29c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1185.74,387.29Z"
                fill="#2f6840"
              />
              <path
                d="M1184.37,390.5a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1184.37,390.5Z"
                fill="#2f6840"
              />
              <path
                d="M1182.41,388.55c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1182.41,388.55Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1196.72,404c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1196.72,404Z"
                fill="#2f6840"
              />
              <path
                d="M1196.21,403.61c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1196.21,403.61Z"
                fill="#3ba525"
              />
              <path
                d="M1197,403.58a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1197,403.58Z"
                fill="#2f6840"
              />
              <path
                d="M1200.44,402.78c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1200.44,402.78Z"
                fill="#2f6840"
              />
              <path
                d="M1199.07,406a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1199.07,406Z"
                fill="#2f6840"
              />
              <path
                d="M1197.12,404c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1197.12,404Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1183.26,398.38c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1183.26,398.38Z"
                fill="#2f6840"
              />
              <path
                d="M1182.75,398c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1182.75,398Z"
                fill="#3ba525"
              />
              <path
                d="M1183.51,398a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1183.51,398Z"
                fill="#2f6840"
              />
              <path
                d="M1187,397.21c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1187,397.21Z"
                fill="#2f6840"
              />
              <path
                d="M1185.62,400.42a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1185.62,400.42Z"
                fill="#2f6840"
              />
              <path
                d="M1183.66,398.47c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1183.66,398.47Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1224.48,376.65c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1224.48,376.65Z"
                fill="#2f6840"
              />
              <path
                d="M1224,376.31c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1224,376.31Z"
                fill="#3ba525"
              />
              <path
                d="M1224.72,376.28a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1224.72,376.28Z"
                fill="#2f6840"
              />
              <path
                d="M1228.2,375.49c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1228.2,375.49Z"
                fill="#2f6840"
              />
              <path
                d="M1226.83,378.7a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1226.83,378.7Z"
                fill="#2f6840"
              />
              <path
                d="M1224.88,376.74c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1224.88,376.74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1221.82,385.38c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1221.82,385.38Z"
                fill="#2f6840"
              />
              <path
                d="M1221.31,385c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1221.31,385Z"
                fill="#3ba525"
              />
              <path
                d="M1222.06,385a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.23,2.23,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1222.06,385Z"
                fill="#2f6840"
              />
              <path
                d="M1225.54,384.21c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1225.54,384.21Z"
                fill="#2f6840"
              />
              <path
                d="M1224.17,387.42a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1224.17,387.42Z"
                fill="#2f6840"
              />
              <path
                d="M1222.22,385.47c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1222.22,385.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1216.46,380.42c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.86,14.86,0,0,1,1216.46,380.42Z"
                fill="#2f6840"
              />
              <path
                d="M1216,380.08c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1216,380.08Z"
                fill="#3ba525"
              />
              <path
                d="M1216.71,380.05a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1216.71,380.05Z"
                fill="#2f6840"
              />
              <path
                d="M1220.19,379.26c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1220.19,379.26Z"
                fill="#2f6840"
              />
              <path
                d="M1218.82,382.47a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1218.82,382.47Z"
                fill="#2f6840"
              />
              <path
                d="M1216.86,380.51c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1216.86,380.51Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1208.12,377.05c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.08-2.37A14.65,14.65,0,0,1,1208.12,377.05Z"
                fill="#2f6840"
              />
              <path
                d="M1207.62,376.71c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1207.62,376.71Z"
                fill="#3ba525"
              />
              <path
                d="M1208.37,376.68a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1208.37,376.68Z"
                fill="#2f6840"
              />
              <path
                d="M1211.85,375.88c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1211.85,375.88Z"
                fill="#2f6840"
              />
              <path
                d="M1210.48,379.09a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1210.48,379.09Z"
                fill="#2f6840"
              />
              <path
                d="M1208.52,377.14c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1208.52,377.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1222.83,392.54c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1222.83,392.54Z"
                fill="#2f6840"
              />
              <path
                d="M1222.32,392.2c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1222.32,392.2Z"
                fill="#3ba525"
              />
              <path
                d="M1223.07,392.17a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1223.07,392.17Z"
                fill="#2f6840"
              />
              <path
                d="M1226.55,391.37c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1226.55,391.37Z"
                fill="#2f6840"
              />
              <path
                d="M1225.18,394.58a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1225.18,394.58Z"
                fill="#2f6840"
              />
              <path
                d="M1223.23,392.63c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1223.23,392.63Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1209.37,387c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1209.37,387Z"
                fill="#2f6840"
              />
              <path
                d="M1208.86,386.63c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1208.86,386.63Z"
                fill="#3ba525"
              />
              <path
                d="M1209.62,386.6a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1209.62,386.6Z"
                fill="#2f6840"
              />
              <path
                d="M1213.09,385.8c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1213.09,385.8Z"
                fill="#2f6840"
              />
              <path
                d="M1211.73,389a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1211.73,389Z"
                fill="#2f6840"
              />
              <path
                d="M1209.77,387.06c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1209.77,387.06Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1246.87,360.31c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1246.87,360.31Z"
                fill="#2f6840"
              />
              <path
                d="M1246.36,360c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1246.36,360Z"
                fill="#3ba525"
              />
              <path
                d="M1247.11,359.94a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1247.11,359.94Z"
                fill="#2f6840"
              />
              <path
                d="M1250.59,359.14c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1250.59,359.14Z"
                fill="#2f6840"
              />
              <path
                d="M1249.22,362.35a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1249.22,362.35Z"
                fill="#2f6840"
              />
              <path
                d="M1247.27,360.4c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1247.27,360.4Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1244.21,369c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1244.21,369Z"
                fill="#2f6840"
              />
              <path
                d="M1243.7,368.7c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1243.7,368.7Z"
                fill="#3ba525"
              />
              <path
                d="M1244.45,368.67a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1244.45,368.67Z"
                fill="#2f6840"
              />
              <path
                d="M1247.93,367.87c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1247.93,367.87Z"
                fill="#2f6840"
              />
              <path
                d="M1246.56,371.08a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1246.56,371.08Z"
                fill="#2f6840"
              />
              <path
                d="M1244.61,369.13c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1244.61,369.13Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1238.85,364.08c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1238.85,364.08Z"
                fill="#2f6840"
              />
              <path
                d="M1238.35,363.74c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1238.35,363.74Z"
                fill="#3ba525"
              />
              <path
                d="M1239.1,363.71a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1239.1,363.71Z"
                fill="#2f6840"
              />
              <path
                d="M1242.58,362.92c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1242.58,362.92Z"
                fill="#2f6840"
              />
              <path
                d="M1241.21,366.13a1.88,1.88,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1241.21,366.13Z"
                fill="#2f6840"
              />
              <path
                d="M1239.25,364.17c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1239.25,364.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1230.51,360.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1230.51,360.71Z"
                fill="#2f6840"
              />
              <path
                d="M1230,360.37c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1230,360.37Z"
                fill="#3ba525"
              />
              <path
                d="M1230.76,360.34a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1230.76,360.34Z"
                fill="#2f6840"
              />
              <path
                d="M1234.24,359.54c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1234.24,359.54Z"
                fill="#2f6840"
              />
              <path
                d="M1232.87,362.75a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1232.87,362.75Z"
                fill="#2f6840"
              />
              <path
                d="M1230.91,360.8c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1230.91,360.8Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1245.22,376.2c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1245.22,376.2Z"
                fill="#2f6840"
              />
              <path
                d="M1244.71,375.86c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1244.71,375.86Z"
                fill="#3ba525"
              />
              <path
                d="M1245.46,375.83a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1245.46,375.83Z"
                fill="#2f6840"
              />
              <path
                d="M1248.94,375c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1248.94,375Z"
                fill="#2f6840"
              />
              <path
                d="M1247.57,378.24a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1247.57,378.24Z"
                fill="#2f6840"
              />
              <path
                d="M1245.62,376.29c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,1245.62,376.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1231.76,370.63c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1231.76,370.63Z"
                fill="#2f6840"
              />
              <path
                d="M1231.25,370.29c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1231.25,370.29Z"
                fill="#3ba525"
              />
              <path
                d="M1232,370.26a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1232,370.26Z"
                fill="#2f6840"
              />
              <path
                d="M1235.48,369.46c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1235.48,369.46Z"
                fill="#2f6840"
              />
              <path
                d="M1234.12,372.67a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1234.12,372.67Z"
                fill="#2f6840"
              />
              <path
                d="M1232.16,370.72c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,1232.16,370.72Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1246.48,332.17c4.42-.26-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71S1247,333,1247,333s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,1246.48,332.17Z"
                fill="#2f6840"
              />
              <path
                d="M1246,331.82c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1246,331.82Z"
                fill="#3ba525"
              />
              <path
                d="M1246.72,331.79a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1246.72,331.79Z"
                fill="#2f6840"
              />
              <path
                d="M1250.2,331c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.48,2.48,0,0,1,1.24-.86A2.07,2.07,0,0,1,1250.2,331Z"
                fill="#2f6840"
              />
              <path
                d="M1248.83,334.21a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1248.83,334.21Z"
                fill="#2f6840"
              />
              <path
                d="M1246.88,332.25c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2.07,2.07,0,0,1,1246.88,332.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1243.82,340.89c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1243.82,340.89Z"
                fill="#2f6840"
              />
              <path
                d="M1243.31,340.55c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1243.31,340.55Z"
                fill="#3ba525"
              />
              <path
                d="M1244.06,340.52a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1244.06,340.52Z"
                fill="#2f6840"
              />
              <path
                d="M1247.54,339.73c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1247.54,339.73Z"
                fill="#2f6840"
              />
              <path
                d="M1246.17,342.94a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1246.17,342.94Z"
                fill="#2f6840"
              />
              <path
                d="M1244.22,341c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1244.22,341Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1238.46,335.94c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1238.46,335.94Z"
                fill="#2f6840"
              />
              <path
                d="M1238,335.59c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1238,335.59Z"
                fill="#3ba525"
              />
              <path
                d="M1238.71,335.56a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1238.71,335.56Z"
                fill="#2f6840"
              />
              <path
                d="M1242.19,334.77a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1242.19,334.77Z"
                fill="#2f6840"
              />
              <path
                d="M1240.82,338a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1240.82,338Z"
                fill="#2f6840"
              />
              <path
                d="M1238.86,336c-.24.06-.47.09-.69.16a3.58,3.58,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1238.86,336Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1230.12,332.56c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1230.12,332.56Z"
                fill="#2f6840"
              />
              <path
                d="M1229.62,332.22c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1229.62,332.22Z"
                fill="#3ba525"
              />
              <path
                d="M1230.37,332.19a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1230.37,332.19Z"
                fill="#2f6840"
              />
              <path
                d="M1233.85,331.4c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1233.85,331.4Z"
                fill="#2f6840"
              />
              <path
                d="M1232.48,334.61a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1232.48,334.61Z"
                fill="#2f6840"
              />
              <path
                d="M1230.52,332.65c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1230.52,332.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1244.83,348.05c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1244.83,348.05Z"
                fill="#2f6840"
              />
              <path
                d="M1244.32,347.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1244.32,347.71Z"
                fill="#3ba525"
              />
              <path
                d="M1245.07,347.68a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1245.07,347.68Z"
                fill="#2f6840"
              />
              <path
                d="M1248.55,346.89c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1248.55,346.89Z"
                fill="#2f6840"
              />
              <path
                d="M1247.18,350.1a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1247.18,350.1Z"
                fill="#2f6840"
              />
              <path
                d="M1245.23,348.14c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1245.23,348.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1231.37,342.48c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1231.37,342.48Z"
                fill="#2f6840"
              />
              <path
                d="M1230.86,342.14c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1230.86,342.14Z"
                fill="#3ba525"
              />
              <path
                d="M1231.62,342.11a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1231.62,342.11Z"
                fill="#2f6840"
              />
              <path
                d="M1235.09,341.32c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1235.09,341.32Z"
                fill="#2f6840"
              />
              <path
                d="M1233.73,344.53a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1233.73,344.53Z"
                fill="#2f6840"
              />
              <path
                d="M1231.77,342.57c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1231.77,342.57Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1239.85,304.75c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1239.85,304.75Z"
                fill="#2f6840"
              />
              <path
                d="M1239.34,304.4c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1239.34,304.4Z"
                fill="#3ba525"
              />
              <path
                d="M1240.1,304.38a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1240.1,304.38Z"
                fill="#2f6840"
              />
              <path
                d="M1243.57,303.58c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1243.57,303.58Z"
                fill="#2f6840"
              />
              <path
                d="M1242.21,306.79a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1242.21,306.79Z"
                fill="#2f6840"
              />
              <path
                d="M1240.25,304.83c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1240.25,304.83Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1237.19,313.48c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1237.19,313.48Z"
                fill="#2f6840"
              />
              <path
                d="M1236.68,313.13c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1236.68,313.13Z"
                fill="#3ba525"
              />
              <path
                d="M1237.44,313.1a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1237.44,313.1Z"
                fill="#2f6840"
              />
              <path
                d="M1240.91,312.31a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1240.91,312.31Z"
                fill="#2f6840"
              />
              <path
                d="M1239.55,315.52a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1239.55,315.52Z"
                fill="#2f6840"
              />
              <path
                d="M1237.59,313.56c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1237.59,313.56Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1231.84,308.52c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1231.84,308.52Z"
                fill="#2f6840"
              />
              <path
                d="M1231.33,308.17c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1231.33,308.17Z"
                fill="#3ba525"
              />
              <path
                d="M1232.08,308.15a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1232.08,308.15Z"
                fill="#2f6840"
              />
              <path
                d="M1235.56,307.35c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,1235.56,307.35Z"
                fill="#2f6840"
              />
              <path
                d="M1234.19,310.56a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1234.19,310.56Z"
                fill="#2f6840"
              />
              <path
                d="M1232.24,308.61a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1232.24,308.61Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1223.5,305.15c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71S1224,306,1224,306s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1223.5,305.15Z"
                fill="#2f6840"
              />
              <path
                d="M1223,304.8c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1223,304.8Z"
                fill="#3ba525"
              />
              <path
                d="M1223.74,304.77a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1223.74,304.77Z"
                fill="#2f6840"
              />
              <path
                d="M1227.22,304c-.26,0-.49,0-.72.1a3,3,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1227.22,304Z"
                fill="#2f6840"
              />
              <path
                d="M1225.85,307.19a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1225.85,307.19Z"
                fill="#2f6840"
              />
              <path
                d="M1223.89,305.23c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1223.89,305.23Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1238.2,320.64c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1238.2,320.64Z"
                fill="#2f6840"
              />
              <path
                d="M1237.69,320.29c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1237.69,320.29Z"
                fill="#3ba525"
              />
              <path
                d="M1238.45,320.26a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1238.45,320.26Z"
                fill="#2f6840"
              />
              <path
                d="M1241.92,319.47a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1241.92,319.47Z"
                fill="#2f6840"
              />
              <path
                d="M1240.56,322.68a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1240.56,322.68Z"
                fill="#2f6840"
              />
              <path
                d="M1238.6,320.72c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1238.6,320.72Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1224.74,315.07c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1224.74,315.07Z"
                fill="#2f6840"
              />
              <path
                d="M1224.24,314.72c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1224.24,314.72Z"
                fill="#3ba525"
              />
              <path
                d="M1225,314.69a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1225,314.69Z"
                fill="#2f6840"
              />
              <path
                d="M1228.47,313.9c-.26,0-.49,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1228.47,313.9Z"
                fill="#2f6840"
              />
              <path
                d="M1227.1,317.11a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1227.1,317.11Z"
                fill="#2f6840"
              />
              <path
                d="M1225.14,315.15c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1225.14,315.15Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1212.75,299.61c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1212.75,299.61Z"
                fill="#2f6840"
              />
              <path
                d="M1212.24,299.27c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1212.24,299.27Z"
                fill="#3ba525"
              />
              <path
                d="M1213,299.24a2.24,2.24,0,0,0-.8-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1213,299.24Z"
                fill="#2f6840"
              />
              <path
                d="M1216.47,298.45c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1216.47,298.45Z"
                fill="#2f6840"
              />
              <path
                d="M1215.1,301.66a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1215.1,301.66Z"
                fill="#2f6840"
              />
              <path
                d="M1213.15,299.7c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1213.15,299.7Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1210.09,308.34c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1210.09,308.34Z"
                fill="#2f6840"
              />
              <path
                d="M1209.58,308c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1209.58,308Z"
                fill="#3ba525"
              />
              <path
                d="M1210.34,308a2.17,2.17,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1210.34,308Z"
                fill="#2f6840"
              />
              <path
                d="M1213.81,307.17c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1213.81,307.17Z"
                fill="#2f6840"
              />
              <path
                d="M1212.45,310.38a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1212.45,310.38Z"
                fill="#2f6840"
              />
              <path
                d="M1210.49,308.43c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.31,8.31,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1210.49,308.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1204.74,303.38c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1204.74,303.38Z"
                fill="#2f6840"
              />
              <path
                d="M1204.23,303c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1204.23,303Z"
                fill="#3ba525"
              />
              <path
                d="M1205,303a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1205,303Z"
                fill="#2f6840"
              />
              <path
                d="M1208.46,302.22c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1208.46,302.22Z"
                fill="#2f6840"
              />
              <path
                d="M1207.09,305.43a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1207.09,305.43Z"
                fill="#2f6840"
              />
              <path
                d="M1205.14,303.47c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1205.14,303.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1196.39,300c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1196.39,300Z"
                fill="#2f6840"
              />
              <path
                d="M1195.89,299.67c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1195.89,299.67Z"
                fill="#3ba525"
              />
              <path
                d="M1196.64,299.64a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1196.64,299.64Z"
                fill="#2f6840"
              />
              <path
                d="M1200.12,298.84c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1200.12,298.84Z"
                fill="#2f6840"
              />
              <path
                d="M1198.75,302.05a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1198.75,302.05Z"
                fill="#2f6840"
              />
              <path
                d="M1196.79,300.1c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1196.79,300.1Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1211.1,315.5c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1211.1,315.5Z"
                fill="#2f6840"
              />
              <path
                d="M1210.59,315.16c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1210.59,315.16Z"
                fill="#3ba525"
              />
              <path
                d="M1211.35,315.13a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1211.35,315.13Z"
                fill="#2f6840"
              />
              <path
                d="M1214.82,314.33c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1214.82,314.33Z"
                fill="#2f6840"
              />
              <path
                d="M1213.46,317.54a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1213.46,317.54Z"
                fill="#2f6840"
              />
              <path
                d="M1211.5,315.59c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1211.5,315.59Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1197.64,309.93c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1197.64,309.93Z"
                fill="#2f6840"
              />
              <path
                d="M1197.14,309.59c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1197.14,309.59Z"
                fill="#3ba525"
              />
              <path
                d="M1197.89,309.56a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1197.89,309.56Z"
                fill="#2f6840"
              />
              <path
                d="M1201.37,308.76c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1201.37,308.76Z"
                fill="#2f6840"
              />
              <path
                d="M1200,312a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1200,312Z"
                fill="#2f6840"
              />
              <path
                d="M1198,310c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1198,310Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1184.27,298.66c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1184.27,298.66Z"
                fill="#2f6840"
              />
              <path
                d="M1183.76,298.32c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1183.76,298.32Z"
                fill="#3ba525"
              />
              <path
                d="M1184.52,298.29a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1184.52,298.29Z"
                fill="#2f6840"
              />
              <path
                d="M1188,297.49c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1188,297.49Z"
                fill="#2f6840"
              />
              <path
                d="M1186.63,300.7a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1186.63,300.7Z"
                fill="#2f6840"
              />
              <path
                d="M1184.67,298.75c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.8,8.8,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1184.67,298.75Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1181.61,307.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1181.61,307.39Z"
                fill="#2f6840"
              />
              <path
                d="M1181.1,307.05c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1181.1,307.05Z"
                fill="#3ba525"
              />
              <path
                d="M1181.86,307a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1181.86,307Z"
                fill="#2f6840"
              />
              <path
                d="M1185.33,306.22c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1185.33,306.22Z"
                fill="#2f6840"
              />
              <path
                d="M1184,309.43a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1184,309.43Z"
                fill="#2f6840"
              />
              <path
                d="M1182,307.48c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1182,307.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1176.26,302.43c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1176.26,302.43Z"
                fill="#2f6840"
              />
              <path
                d="M1175.75,302.09c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1175.75,302.09Z"
                fill="#3ba525"
              />
              <path
                d="M1176.5,302.06a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1176.5,302.06Z"
                fill="#2f6840"
              />
              <path
                d="M1180,301.26c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,1180,301.26Z"
                fill="#2f6840"
              />
              <path
                d="M1178.61,304.47a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1178.61,304.47Z"
                fill="#2f6840"
              />
              <path
                d="M1176.66,302.52c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1176.66,302.52Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1167.92,299.06c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1167.92,299.06Z"
                fill="#2f6840"
              />
              <path
                d="M1167.41,298.72c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1167.41,298.72Z"
                fill="#3ba525"
              />
              <path
                d="M1168.16,298.69a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1168.16,298.69Z"
                fill="#2f6840"
              />
              <path
                d="M1171.64,297.89c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1171.64,297.89Z"
                fill="#2f6840"
              />
              <path
                d="M1170.27,301.1a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1170.27,301.1Z"
                fill="#2f6840"
              />
              <path
                d="M1168.31,299.15c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1168.31,299.15Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1182.62,314.55c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1182.62,314.55Z"
                fill="#2f6840"
              />
              <path
                d="M1182.11,314.21c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1182.11,314.21Z"
                fill="#3ba525"
              />
              <path
                d="M1182.87,314.18a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1182.87,314.18Z"
                fill="#2f6840"
              />
              <path
                d="M1186.34,313.38c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1186.34,313.38Z"
                fill="#2f6840"
              />
              <path
                d="M1185,316.59a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1185,316.59Z"
                fill="#2f6840"
              />
              <path
                d="M1183,314.64c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1183,314.64Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1169.16,309c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1169.16,309Z"
                fill="#2f6840"
              />
              <path
                d="M1168.66,308.64c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1168.66,308.64Z"
                fill="#3ba525"
              />
              <path
                d="M1169.41,308.61a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1169.41,308.61Z"
                fill="#2f6840"
              />
              <path
                d="M1172.89,307.81c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1172.89,307.81Z"
                fill="#2f6840"
              />
              <path
                d="M1171.52,311a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1171.52,311Z"
                fill="#2f6840"
              />
              <path
                d="M1169.56,309.07c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1169.56,309.07Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1161.92,286c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1161.92,286Z"
                fill="#2f6840"
              />
              <path
                d="M1161.41,285.69c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1161.41,285.69Z"
                fill="#3ba525"
              />
              <path
                d="M1162.16,285.66a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1162.16,285.66Z"
                fill="#2f6840"
              />
              <path
                d="M1165.64,284.87c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1165.64,284.87Z"
                fill="#2f6840"
              />
              <path
                d="M1164.27,288.08a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1164.27,288.08Z"
                fill="#2f6840"
              />
              <path
                d="M1162.32,286.12c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1162.32,286.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1159.26,294.77c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1159.26,294.77Z"
                fill="#2f6840"
              />
              <path
                d="M1158.75,294.42c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1158.75,294.42Z"
                fill="#3ba525"
              />
              <path
                d="M1159.5,294.39a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1159.5,294.39Z"
                fill="#2f6840"
              />
              <path
                d="M1163,293.6a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12.12,12.12,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1163,293.6Z"
                fill="#2f6840"
              />
              <path
                d="M1161.61,296.81a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1161.61,296.81Z"
                fill="#2f6840"
              />
              <path
                d="M1159.66,294.85c-.25.06-.48.09-.7.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1159.66,294.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1153.91,289.81c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1153.91,289.81Z"
                fill="#2f6840"
              />
              <path
                d="M1153.4,289.46c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1153.4,289.46Z"
                fill="#3ba525"
              />
              <path
                d="M1154.15,289.44a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1154.15,289.44Z"
                fill="#2f6840"
              />
              <path
                d="M1157.63,288.64c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1157.63,288.64Z"
                fill="#2f6840"
              />
              <path
                d="M1156.26,291.85a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.22.55,1.9,1.9,0,0,1,.4.56A1,1,0,0,1,1156.26,291.85Z"
                fill="#2f6840"
              />
              <path
                d="M1154.3,289.89c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1154.3,289.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1145.56,286.44c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1145.56,286.44Z"
                fill="#2f6840"
              />
              <path
                d="M1145.06,286.09c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1145.06,286.09Z"
                fill="#3ba525"
              />
              <path
                d="M1145.81,286.06a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1145.81,286.06Z"
                fill="#2f6840"
              />
              <path
                d="M1149.29,285.27a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1149.29,285.27Z"
                fill="#2f6840"
              />
              <path
                d="M1147.92,288.48a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1147.92,288.48Z"
                fill="#2f6840"
              />
              <path
                d="M1146,286.52c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1146,286.52Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1160.27,301.93c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1160.27,301.93Z"
                fill="#2f6840"
              />
              <path
                d="M1159.76,301.58c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1159.76,301.58Z"
                fill="#3ba525"
              />
              <path
                d="M1160.51,301.55a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1160.51,301.55Z"
                fill="#2f6840"
              />
              <path
                d="M1164,300.76a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12.12,12.12,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1164,300.76Z"
                fill="#2f6840"
              />
              <path
                d="M1162.62,304a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1162.62,304Z"
                fill="#2f6840"
              />
              <path
                d="M1160.67,302c-.25.06-.48.09-.7.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1160.67,302Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1146.81,296.36c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1146.81,296.36Z"
                fill="#2f6840"
              />
              <path
                d="M1146.3,296c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1146.3,296Z"
                fill="#3ba525"
              />
              <path
                d="M1147.06,296a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1147.06,296Z"
                fill="#2f6840"
              />
              <path
                d="M1150.54,295.19a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1150.54,295.19Z"
                fill="#2f6840"
              />
              <path
                d="M1149.17,298.4a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1149.17,298.4Z"
                fill="#2f6840"
              />
              <path
                d="M1147.21,296.44c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1147.21,296.44Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1174.05,270.87c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1174.05,270.87Z"
                fill="#2f6840"
              />
              <path
                d="M1173.54,270.53c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1173.54,270.53Z"
                fill="#3ba525"
              />
              <path
                d="M1174.29,270.5a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1174.29,270.5Z"
                fill="#2f6840"
              />
              <path
                d="M1177.77,269.7c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1177.77,269.7Z"
                fill="#2f6840"
              />
              <path
                d="M1176.4,272.91a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1176.4,272.91Z"
                fill="#2f6840"
              />
              <path
                d="M1174.45,271c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1174.45,271Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1171.39,279.6c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1171.39,279.6Z"
                fill="#2f6840"
              />
              <path
                d="M1170.88,279.26c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1170.88,279.26Z"
                fill="#3ba525"
              />
              <path
                d="M1171.63,279.23a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1171.63,279.23Z"
                fill="#2f6840"
              />
              <path
                d="M1175.11,278.43c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1175.11,278.43Z"
                fill="#2f6840"
              />
              <path
                d="M1173.74,281.64a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1173.74,281.64Z"
                fill="#2f6840"
              />
              <path
                d="M1171.79,279.69a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1171.79,279.69Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1166,274.64c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1166,274.64Z"
                fill="#2f6840"
              />
              <path
                d="M1165.53,274.3c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1165.53,274.3Z"
                fill="#3ba525"
              />
              <path
                d="M1166.28,274.27a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1166.28,274.27Z"
                fill="#2f6840"
              />
              <path
                d="M1169.76,273.47c-.26,0-.49,0-.72.1a3.77,3.77,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1169.76,273.47Z"
                fill="#2f6840"
              />
              <path
                d="M1168.39,276.68a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1168.39,276.68Z"
                fill="#2f6840"
              />
              <path
                d="M1166.43,274.73c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1166.43,274.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1157.69,271.27c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1157.69,271.27Z"
                fill="#2f6840"
              />
              <path
                d="M1157.19,270.93c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1157.19,270.93Z"
                fill="#3ba525"
              />
              <path
                d="M1157.94,270.9a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1157.94,270.9Z"
                fill="#2f6840"
              />
              <path
                d="M1161.42,270.1c-.26,0-.49,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1161.42,270.1Z"
                fill="#2f6840"
              />
              <path
                d="M1160.05,273.31a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1160.05,273.31Z"
                fill="#2f6840"
              />
              <path
                d="M1158.09,271.36a7.18,7.18,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1158.09,271.36Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1172.4,286.76c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1172.4,286.76Z"
                fill="#2f6840"
              />
              <path
                d="M1171.89,286.42c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1171.89,286.42Z"
                fill="#3ba525"
              />
              <path
                d="M1172.64,286.39a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1172.64,286.39Z"
                fill="#2f6840"
              />
              <path
                d="M1176.12,285.59c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1176.12,285.59Z"
                fill="#2f6840"
              />
              <path
                d="M1174.75,288.8a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1174.75,288.8Z"
                fill="#2f6840"
              />
              <path
                d="M1172.8,286.85a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1172.8,286.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1158.94,281.19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1158.94,281.19Z"
                fill="#2f6840"
              />
              <path
                d="M1158.43,280.85c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1158.43,280.85Z"
                fill="#3ba525"
              />
              <path
                d="M1159.19,280.82a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.07,2.07,0,0,1,.48.54A1,1,0,0,1,1159.19,280.82Z"
                fill="#2f6840"
              />
              <path
                d="M1162.67,280c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1162.67,280Z"
                fill="#2f6840"
              />
              <path
                d="M1161.3,283.23a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1161.3,283.23Z"
                fill="#2f6840"
              />
              <path
                d="M1159.34,281.28a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1159.34,281.28Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1202.51,270.43c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1202.51,270.43Z"
                fill="#2f6840"
              />
              <path
                d="M1202,270.09c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1202,270.09Z"
                fill="#3ba525"
              />
              <path
                d="M1202.76,270.06a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1202.76,270.06Z"
                fill="#2f6840"
              />
              <path
                d="M1206.24,269.26c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1206.24,269.26Z"
                fill="#2f6840"
              />
              <path
                d="M1204.87,272.47a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1204.87,272.47Z"
                fill="#2f6840"
              />
              <path
                d="M1202.91,270.52c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1202.91,270.52Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1199.85,279.16c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1199.85,279.16Z"
                fill="#2f6840"
              />
              <path
                d="M1199.35,278.82c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1199.35,278.82Z"
                fill="#3ba525"
              />
              <path
                d="M1200.1,278.79a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1200.1,278.79Z"
                fill="#2f6840"
              />
              <path
                d="M1203.58,278c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1203.58,278Z"
                fill="#2f6840"
              />
              <path
                d="M1202.21,281.2a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1202.21,281.2Z"
                fill="#2f6840"
              />
              <path
                d="M1200.25,279.25c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1200.25,279.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1194.5,274.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1194.5,274.2Z"
                fill="#2f6840"
              />
              <path
                d="M1194,273.86c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1194,273.86Z"
                fill="#3ba525"
              />
              <path
                d="M1194.75,273.83a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1194.75,273.83Z"
                fill="#2f6840"
              />
              <path
                d="M1198.23,273c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1198.23,273Z"
                fill="#2f6840"
              />
              <path
                d="M1196.86,276.25a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1196.86,276.25Z"
                fill="#2f6840"
              />
              <path
                d="M1194.9,274.29c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1194.9,274.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1186.16,270.83c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1186.16,270.83Z"
                fill="#2f6840"
              />
              <path
                d="M1185.65,270.49c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1185.65,270.49Z"
                fill="#3ba525"
              />
              <path
                d="M1186.41,270.46a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1186.41,270.46Z"
                fill="#2f6840"
              />
              <path
                d="M1189.88,269.66c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1189.88,269.66Z"
                fill="#2f6840"
              />
              <path
                d="M1188.52,272.87a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1188.52,272.87Z"
                fill="#2f6840"
              />
              <path
                d="M1186.56,270.92c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,1186.56,270.92Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1200.86,286.32c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1200.86,286.32Z"
                fill="#2f6840"
              />
              <path
                d="M1200.36,286c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1200.36,286Z"
                fill="#3ba525"
              />
              <path
                d="M1201.11,286a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1201.11,286Z"
                fill="#2f6840"
              />
              <path
                d="M1204.59,285.15c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1204.59,285.15Z"
                fill="#2f6840"
              />
              <path
                d="M1203.22,288.36a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1203.22,288.36Z"
                fill="#2f6840"
              />
              <path
                d="M1201.26,286.41c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1201.26,286.41Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1187.41,280.75c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1187.41,280.75Z"
                fill="#2f6840"
              />
              <path
                d="M1186.9,280.41c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1186.9,280.41Z"
                fill="#3ba525"
              />
              <path
                d="M1187.65,280.38a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1187.65,280.38Z"
                fill="#2f6840"
              />
              <path
                d="M1191.13,279.58c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1191.13,279.58Z"
                fill="#2f6840"
              />
              <path
                d="M1189.76,282.79a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1189.76,282.79Z"
                fill="#2f6840"
              />
              <path
                d="M1187.81,280.84c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1187.81,280.84Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1221.85,259.29c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1221.85,259.29Z"
                fill="#2f6840"
              />
              <path
                d="M1221.34,258.94c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1221.34,258.94Z"
                fill="#3ba525"
              />
              <path
                d="M1222.1,258.91a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1222.1,258.91Z"
                fill="#2f6840"
              />
              <path
                d="M1225.57,258.12a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1225.57,258.12Z"
                fill="#2f6840"
              />
              <path
                d="M1224.21,261.33a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1224.21,261.33Z"
                fill="#2f6840"
              />
              <path
                d="M1222.25,259.37c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1222.25,259.37Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1219.19,268c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1219.19,268Z"
                fill="#2f6840"
              />
              <path
                d="M1218.68,267.67c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1218.68,267.67Z"
                fill="#3ba525"
              />
              <path
                d="M1219.44,267.64a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1219.44,267.64Z"
                fill="#2f6840"
              />
              <path
                d="M1222.91,266.85c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1222.91,266.85Z"
                fill="#2f6840"
              />
              <path
                d="M1221.55,270.06a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1221.55,270.06Z"
                fill="#2f6840"
              />
              <path
                d="M1219.59,268.1c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1219.59,268.1Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1213.84,263.06c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1213.84,263.06Z"
                fill="#2f6840"
              />
              <path
                d="M1213.33,262.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1213.33,262.71Z"
                fill="#3ba525"
              />
              <path
                d="M1214.08,262.68a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1214.08,262.68Z"
                fill="#2f6840"
              />
              <path
                d="M1217.56,261.89a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12.12,12.12,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1217.56,261.89Z"
                fill="#2f6840"
              />
              <path
                d="M1216.19,265.1a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1216.19,265.1Z"
                fill="#2f6840"
              />
              <path
                d="M1214.24,263.14c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1214.24,263.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1205.49,259.69c4.43-.26-4.32.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.24,14.24,0,0,1,1205.49,259.69Z"
                fill="#2f6840"
              />
              <path
                d="M1205,259.34c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1205,259.34Z"
                fill="#3ba525"
              />
              <path
                d="M1205.74,259.31a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1205.74,259.31Z"
                fill="#2f6840"
              />
              <path
                d="M1209.22,258.52c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1209.22,258.52Z"
                fill="#2f6840"
              />
              <path
                d="M1207.85,261.73a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1207.85,261.73Z"
                fill="#2f6840"
              />
              <path
                d="M1205.89,259.77c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1205.89,259.77Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1220.2,275.17c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1220.2,275.17Z"
                fill="#2f6840"
              />
              <path
                d="M1219.69,274.83c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1219.69,274.83Z"
                fill="#3ba525"
              />
              <path
                d="M1220.45,274.8a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1220.45,274.8Z"
                fill="#2f6840"
              />
              <path
                d="M1223.92,274c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1223.92,274Z"
                fill="#2f6840"
              />
              <path
                d="M1222.56,277.22a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1222.56,277.22Z"
                fill="#2f6840"
              />
              <path
                d="M1220.6,275.26c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1220.6,275.26Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1206.74,269.61c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1206.74,269.61Z"
                fill="#2f6840"
              />
              <path
                d="M1206.24,269.26c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1206.24,269.26Z"
                fill="#3ba525"
              />
              <path
                d="M1207,269.23a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1207,269.23Z"
                fill="#2f6840"
              />
              <path
                d="M1210.47,268.44c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1210.47,268.44Z"
                fill="#2f6840"
              />
              <path
                d="M1209.1,271.65a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1209.1,271.65Z"
                fill="#2f6840"
              />
              <path
                d="M1207.14,269.69c-.24.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1207.14,269.69Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1203.1,237.86c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1203.1,237.86Z"
                fill="#2f6840"
              />
              <path
                d="M1202.6,237.51c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1202.6,237.51Z"
                fill="#3ba525"
              />
              <path
                d="M1203.35,237.48a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1203.35,237.48Z"
                fill="#2f6840"
              />
              <path
                d="M1206.83,236.69c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1206.83,236.69Z"
                fill="#2f6840"
              />
              <path
                d="M1205.46,239.9a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1205.46,239.9Z"
                fill="#2f6840"
              />
              <path
                d="M1203.5,237.94c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1203.5,237.94Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1200.45,246.58c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1200.45,246.58Z"
                fill="#2f6840"
              />
              <path
                d="M1199.94,246.24c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1199.94,246.24Z"
                fill="#3ba525"
              />
              <path
                d="M1200.69,246.21a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1200.69,246.21Z"
                fill="#2f6840"
              />
              <path
                d="M1204.17,245.42c-.26,0-.49,0-.72.09a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1204.17,245.42Z"
                fill="#2f6840"
              />
              <path
                d="M1202.8,248.63a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1202.8,248.63Z"
                fill="#2f6840"
              />
              <path
                d="M1200.84,246.67c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1200.84,246.67Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1195.09,241.63c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1195.09,241.63Z"
                fill="#2f6840"
              />
              <path
                d="M1194.59,241.28c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1194.59,241.28Z"
                fill="#3ba525"
              />
              <path
                d="M1195.34,241.25a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1195.34,241.25Z"
                fill="#2f6840"
              />
              <path
                d="M1198.82,240.46a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1198.82,240.46Z"
                fill="#2f6840"
              />
              <path
                d="M1197.45,243.67a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1197.45,243.67Z"
                fill="#2f6840"
              />
              <path
                d="M1195.49,241.71c-.24.06-.47.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1195.49,241.71Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1186.75,238.25c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1186.75,238.25Z"
                fill="#2f6840"
              />
              <path
                d="M1186.24,237.91c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1186.24,237.91Z"
                fill="#3ba525"
              />
              <path
                d="M1187,237.88a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1187,237.88Z"
                fill="#2f6840"
              />
              <path
                d="M1190.47,237.09c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52A2.39,2.39,0,0,1,1189,237,2.07,2.07,0,0,1,1190.47,237.09Z"
                fill="#2f6840"
              />
              <path
                d="M1189.11,240.3a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1189.11,240.3Z"
                fill="#2f6840"
              />
              <path
                d="M1187.15,238.34c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1187.15,238.34Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1201.45,253.74c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.86,14.86,0,0,1,1201.45,253.74Z"
                fill="#2f6840"
              />
              <path
                d="M1201,253.4c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1201,253.4Z"
                fill="#3ba525"
              />
              <path
                d="M1201.7,253.37a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1201.7,253.37Z"
                fill="#2f6840"
              />
              <path
                d="M1205.18,252.58c-.26,0-.49,0-.72.09a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1205.18,252.58Z"
                fill="#2f6840"
              />
              <path
                d="M1203.81,255.79a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1203.81,255.79Z"
                fill="#2f6840"
              />
              <path
                d="M1201.85,253.83c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1201.85,253.83Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1188,248.17c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1188,248.17Z"
                fill="#2f6840"
              />
              <path
                d="M1187.49,247.83c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1187.49,247.83Z"
                fill="#3ba525"
              />
              <path
                d="M1188.25,247.8a2.15,2.15,0,0,0-.8-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1188.25,247.8Z"
                fill="#2f6840"
              />
              <path
                d="M1191.72,247c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1191.72,247Z"
                fill="#2f6840"
              />
              <path
                d="M1190.35,250.22a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1190.35,250.22Z"
                fill="#2f6840"
              />
              <path
                d="M1188.4,248.26c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1188.4,248.26Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1183.41,217.27c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1183.41,217.27Z"
                fill="#2f6840"
              />
              <path
                d="M1182.91,216.93c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1182.91,216.93Z"
                fill="#3ba525"
              />
              <path
                d="M1183.66,216.9a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1183.66,216.9Z"
                fill="#2f6840"
              />
              <path
                d="M1187.14,216.11c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1187.14,216.11Z"
                fill="#2f6840"
              />
              <path
                d="M1185.77,219.32a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1185.77,219.32Z"
                fill="#2f6840"
              />
              <path
                d="M1183.81,217.36c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1183.81,217.36Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1180.75,226c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1180.75,226Z"
                fill="#2f6840"
              />
              <path
                d="M1180.25,225.66c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1180.25,225.66Z"
                fill="#3ba525"
              />
              <path
                d="M1181,225.63a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1181,225.63Z"
                fill="#2f6840"
              />
              <path
                d="M1184.48,224.84c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1184.48,224.84Z"
                fill="#2f6840"
              />
              <path
                d="M1183.11,228.05a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1183.11,228.05Z"
                fill="#2f6840"
              />
              <path
                d="M1181.15,226.09c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1181.15,226.09Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1175.4,221.05c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1175.4,221.05Z"
                fill="#2f6840"
              />
              <path
                d="M1174.89,220.7c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1174.89,220.7Z"
                fill="#3ba525"
              />
              <path
                d="M1175.65,220.67a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1175.65,220.67Z"
                fill="#2f6840"
              />
              <path
                d="M1179.12,219.88c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1179.12,219.88Z"
                fill="#2f6840"
              />
              <path
                d="M1177.76,223.09a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1177.76,223.09Z"
                fill="#2f6840"
              />
              <path
                d="M1175.8,221.13c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1175.8,221.13Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1167.06,217.67c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1167.06,217.67Z"
                fill="#2f6840"
              />
              <path
                d="M1166.55,217.33c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1166.55,217.33Z"
                fill="#3ba525"
              />
              <path
                d="M1167.3,217.3a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1167.3,217.3Z"
                fill="#2f6840"
              />
              <path
                d="M1170.78,216.51c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1170.78,216.51Z"
                fill="#2f6840"
              />
              <path
                d="M1169.41,219.72a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1169.41,219.72Z"
                fill="#2f6840"
              />
              <path
                d="M1167.46,217.76c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1167.46,217.76Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1181.76,233.16c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1181.76,233.16Z"
                fill="#2f6840"
              />
              <path
                d="M1181.26,232.82c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1181.26,232.82Z"
                fill="#3ba525"
              />
              <path
                d="M1182,232.79a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1182,232.79Z"
                fill="#2f6840"
              />
              <path
                d="M1185.49,232c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1185.49,232Z"
                fill="#2f6840"
              />
              <path
                d="M1184.12,235.21a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1184.12,235.21Z"
                fill="#2f6840"
              />
              <path
                d="M1182.16,233.25c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1182.16,233.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1168.3,227.59c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1168.3,227.59Z"
                fill="#2f6840"
              />
              <path
                d="M1167.8,227.25c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1167.8,227.25Z"
                fill="#3ba525"
              />
              <path
                d="M1168.55,227.22a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1168.55,227.22Z"
                fill="#2f6840"
              />
              <path
                d="M1172,226.43c-.26,0-.49,0-.72.09a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1172,226.43Z"
                fill="#2f6840"
              />
              <path
                d="M1170.66,229.64a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1170.66,229.64Z"
                fill="#2f6840"
              />
              <path
                d="M1168.7,227.68c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1168.7,227.68Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1157.64,207c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1157.64,207Z"
                fill="#2f6840"
              />
              <path
                d="M1157.13,206.69c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1157.13,206.69Z"
                fill="#3ba525"
              />
              <path
                d="M1157.88,206.66a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1157.88,206.66Z"
                fill="#2f6840"
              />
              <path
                d="M1161.36,205.86c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1161.36,205.86Z"
                fill="#2f6840"
              />
              <path
                d="M1160,209.07a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1160,209.07Z"
                fill="#2f6840"
              />
              <path
                d="M1158,207.12c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1158,207.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1155,215.76c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1155,215.76Z"
                fill="#2f6840"
              />
              <path
                d="M1154.47,215.42c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1154.47,215.42Z"
                fill="#3ba525"
              />
              <path
                d="M1155.22,215.39a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1155.22,215.39Z"
                fill="#2f6840"
              />
              <path
                d="M1158.7,214.59c-.26,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1158.7,214.59Z"
                fill="#2f6840"
              />
              <path
                d="M1157.33,217.8a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1157.33,217.8Z"
                fill="#2f6840"
              />
              <path
                d="M1155.37,215.85a7,7,0,0,0-.69.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1155.37,215.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1149.62,210.8c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1149.62,210.8Z"
                fill="#2f6840"
              />
              <path
                d="M1149.12,210.46c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1149.12,210.46Z"
                fill="#3ba525"
              />
              <path
                d="M1149.87,210.43a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1149.87,210.43Z"
                fill="#2f6840"
              />
              <path
                d="M1153.35,209.63c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1153.35,209.63Z"
                fill="#2f6840"
              />
              <path
                d="M1152,212.84a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1152,212.84Z"
                fill="#2f6840"
              />
              <path
                d="M1150,210.89c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1150,210.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1141.28,207.43c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1141.28,207.43Z"
                fill="#2f6840"
              />
              <path
                d="M1140.78,207.09c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1140.78,207.09Z"
                fill="#3ba525"
              />
              <path
                d="M1141.53,207.06a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.07,2.07,0,0,1,.48.54A1,1,0,0,1,1141.53,207.06Z"
                fill="#2f6840"
              />
              <path
                d="M1145,206.26c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1145,206.26Z"
                fill="#2f6840"
              />
              <path
                d="M1143.64,209.47a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1143.64,209.47Z"
                fill="#2f6840"
              />
              <path
                d="M1141.68,207.52a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1141.68,207.52Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1156,222.92c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1156,222.92Z"
                fill="#2f6840"
              />
              <path
                d="M1155.48,222.58c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1155.48,222.58Z"
                fill="#3ba525"
              />
              <path
                d="M1156.23,222.55a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.54A1,1,0,0,1,1156.23,222.55Z"
                fill="#2f6840"
              />
              <path
                d="M1159.71,221.75c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1159.71,221.75Z"
                fill="#2f6840"
              />
              <path
                d="M1158.34,225a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1158.34,225Z"
                fill="#2f6840"
              />
              <path
                d="M1156.38,223c-.24.06-.47.08-.69.15a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1156.38,223Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1142.53,217.35c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1142.53,217.35Z"
                fill="#2f6840"
              />
              <path
                d="M1142,217c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1142,217Z"
                fill="#3ba525"
              />
              <path
                d="M1142.78,217a2.17,2.17,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1142.78,217Z"
                fill="#2f6840"
              />
              <path
                d="M1146.25,216.18c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1146.25,216.18Z"
                fill="#2f6840"
              />
              <path
                d="M1144.89,219.39a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1144.89,219.39Z"
                fill="#2f6840"
              />
              <path
                d="M1142.93,217.44a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1142.93,217.44Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1131.9,217.8c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1131.9,217.8Z"
                fill="#2f6840"
              />
              <path
                d="M1131.39,217.46c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1131.39,217.46Z"
                fill="#3ba525"
              />
              <path
                d="M1132.14,217.43a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1132.14,217.43Z"
                fill="#2f6840"
              />
              <path
                d="M1135.62,216.63c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1135.62,216.63Z"
                fill="#2f6840"
              />
              <path
                d="M1134.25,219.84a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1134.25,219.84Z"
                fill="#2f6840"
              />
              <path
                d="M1132.3,217.89c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,1132.3,217.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1129.24,226.53c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1129.24,226.53Z"
                fill="#2f6840"
              />
              <path
                d="M1128.73,226.19c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1128.73,226.19Z"
                fill="#3ba525"
              />
              <path
                d="M1129.48,226.16a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1129.48,226.16Z"
                fill="#2f6840"
              />
              <path
                d="M1133,225.36c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1133,225.36Z"
                fill="#2f6840"
              />
              <path
                d="M1131.59,228.57a1.94,1.94,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1131.59,228.57Z"
                fill="#2f6840"
              />
              <path
                d="M1129.64,226.62a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1129.64,226.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1123.88,221.57c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1123.88,221.57Z"
                fill="#2f6840"
              />
              <path
                d="M1123.38,221.23c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1123.38,221.23Z"
                fill="#3ba525"
              />
              <path
                d="M1124.13,221.2a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1124.13,221.2Z"
                fill="#2f6840"
              />
              <path
                d="M1127.61,220.4c-.26,0-.49,0-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1127.61,220.4Z"
                fill="#2f6840"
              />
              <path
                d="M1126.24,223.61a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1126.24,223.61Z"
                fill="#2f6840"
              />
              <path
                d="M1124.28,221.66c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1124.28,221.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1115.54,218.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1115.54,218.2Z"
                fill="#2f6840"
              />
              <path
                d="M1115,217.86c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1115,217.86Z"
                fill="#3ba525"
              />
              <path
                d="M1115.79,217.83a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1115.79,217.83Z"
                fill="#2f6840"
              />
              <path
                d="M1119.27,217c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1119.27,217Z"
                fill="#2f6840"
              />
              <path
                d="M1117.9,220.24a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1117.9,220.24Z"
                fill="#2f6840"
              />
              <path
                d="M1115.94,218.29c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1115.94,218.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1130.25,233.69c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1130.25,233.69Z"
                fill="#2f6840"
              />
              <path
                d="M1129.74,233.35c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1129.74,233.35Z"
                fill="#3ba525"
              />
              <path
                d="M1130.49,233.32a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1130.49,233.32Z"
                fill="#2f6840"
              />
              <path
                d="M1134,232.52c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1134,232.52Z"
                fill="#2f6840"
              />
              <path
                d="M1132.6,235.73a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1132.6,235.73Z"
                fill="#2f6840"
              />
              <path
                d="M1130.65,233.78a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1130.65,233.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1116.79,228.12c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1116.79,228.12Z"
                fill="#2f6840"
              />
              <path
                d="M1116.28,227.78c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1116.28,227.78Z"
                fill="#3ba525"
              />
              <path
                d="M1117,227.75a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1117,227.75Z"
                fill="#2f6840"
              />
              <path
                d="M1120.51,227c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1120.51,227Z"
                fill="#2f6840"
              />
              <path
                d="M1119.15,230.16a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1119.15,230.16Z"
                fill="#2f6840"
              />
              <path
                d="M1117.19,228.21c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1117.19,228.21Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1105.22,226.4c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,1105.22,226.4Z"
                fill="#2f6840"
              />
              <path
                d="M1104.71,226.06c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1104.71,226.06Z"
                fill="#3ba525"
              />
              <path
                d="M1105.46,226a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1105.46,226Z"
                fill="#2f6840"
              />
              <path
                d="M1108.94,225.24c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1108.94,225.24Z"
                fill="#2f6840"
              />
              <path
                d="M1107.57,228.45a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,2,2,0,0,1,.4.57A1,1,0,0,1,1107.57,228.45Z"
                fill="#2f6840"
              />
              <path
                d="M1105.61,226.49c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1105.61,226.49Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1102.56,235.13c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1102.56,235.13Z"
                fill="#2f6840"
              />
              <path
                d="M1102.05,234.79c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1102.05,234.79Z"
                fill="#3ba525"
              />
              <path
                d="M1102.8,234.76a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1102.8,234.76Z"
                fill="#2f6840"
              />
              <path
                d="M1106.28,234c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1106.28,234Z"
                fill="#2f6840"
              />
              <path
                d="M1104.91,237.18a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1104.91,237.18Z"
                fill="#2f6840"
              />
              <path
                d="M1103,235.22c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1103,235.22Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1097.2,230.18c4.43-.26-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1097.2,230.18Z"
                fill="#2f6840"
              />
              <path
                d="M1096.7,229.83c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1096.7,229.83Z"
                fill="#3ba525"
              />
              <path
                d="M1097.45,229.8a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1097.45,229.8Z"
                fill="#2f6840"
              />
              <path
                d="M1100.93,229c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,10.33,10.33,0,0,0-1.34.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1100.93,229Z"
                fill="#2f6840"
              />
              <path
                d="M1099.56,232.22a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1099.56,232.22Z"
                fill="#2f6840"
              />
              <path
                d="M1097.6,230.26c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1097.6,230.26Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1088.86,226.8c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1088.86,226.8Z"
                fill="#2f6840"
              />
              <path
                d="M1088.36,226.46c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1088.36,226.46Z"
                fill="#3ba525"
              />
              <path
                d="M1089.11,226.43a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1089.11,226.43Z"
                fill="#2f6840"
              />
              <path
                d="M1092.59,225.64c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1092.59,225.64Z"
                fill="#2f6840"
              />
              <path
                d="M1091.22,228.85a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1091.22,228.85Z"
                fill="#2f6840"
              />
              <path
                d="M1089.26,226.89c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1089.26,226.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1103.57,242.29c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1103.57,242.29Z"
                fill="#2f6840"
              />
              <path
                d="M1103.06,242c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1103.06,242Z"
                fill="#3ba525"
              />
              <path
                d="M1103.81,241.92a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1103.81,241.92Z"
                fill="#2f6840"
              />
              <path
                d="M1107.29,241.13c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1107.29,241.13Z"
                fill="#2f6840"
              />
              <path
                d="M1105.92,244.34a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1105.92,244.34Z"
                fill="#2f6840"
              />
              <path
                d="M1104,242.38c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1104,242.38Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1090.11,236.72c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1090.11,236.72Z"
                fill="#2f6840"
              />
              <path
                d="M1089.6,236.38c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1089.6,236.38Z"
                fill="#3ba525"
              />
              <path
                d="M1090.36,236.35a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1090.36,236.35Z"
                fill="#2f6840"
              />
              <path
                d="M1093.83,235.56c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1093.83,235.56Z"
                fill="#2f6840"
              />
              <path
                d="M1092.47,238.77a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1092.47,238.77Z"
                fill="#2f6840"
              />
              <path
                d="M1090.51,236.81c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.34,9.34,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1090.51,236.81Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1086.88,210c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1086.88,210Z"
                fill="#2f6840"
              />
              <path
                d="M1086.37,209.62c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1086.37,209.62Z"
                fill="#3ba525"
              />
              <path
                d="M1087.13,209.59a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1087.13,209.59Z"
                fill="#2f6840"
              />
              <path
                d="M1090.6,208.8c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1090.6,208.8Z"
                fill="#2f6840"
              />
              <path
                d="M1089.24,212a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1089.24,212Z"
                fill="#2f6840"
              />
              <path
                d="M1087.28,210.05c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1087.28,210.05Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1084.22,218.69c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1084.22,218.69Z"
                fill="#2f6840"
              />
              <path
                d="M1083.71,218.35c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1083.71,218.35Z"
                fill="#3ba525"
              />
              <path
                d="M1084.47,218.32a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1084.47,218.32Z"
                fill="#2f6840"
              />
              <path
                d="M1087.94,217.53c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1087.94,217.53Z"
                fill="#2f6840"
              />
              <path
                d="M1086.58,220.74a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1086.58,220.74Z"
                fill="#2f6840"
              />
              <path
                d="M1084.62,218.78c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1084.62,218.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1078.87,213.74c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1078.87,213.74Z"
                fill="#2f6840"
              />
              <path
                d="M1078.36,213.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1078.36,213.39Z"
                fill="#3ba525"
              />
              <path
                d="M1079.11,213.36a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1079.11,213.36Z"
                fill="#2f6840"
              />
              <path
                d="M1082.59,212.57a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.45,10.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1082.59,212.57Z"
                fill="#2f6840"
              />
              <path
                d="M1081.22,215.78a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1081.22,215.78Z"
                fill="#2f6840"
              />
              <path
                d="M1079.27,213.82c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1079.27,213.82Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1070.53,210.36c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1070.53,210.36Z"
                fill="#2f6840"
              />
              <path
                d="M1070,210c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1070,210Z"
                fill="#3ba525"
              />
              <path
                d="M1070.77,210a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1070.77,210Z"
                fill="#2f6840"
              />
              <path
                d="M1074.25,209.2c-.26,0-.49,0-.72.09a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1074.25,209.2Z"
                fill="#2f6840"
              />
              <path
                d="M1072.88,212.41a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1072.88,212.41Z"
                fill="#2f6840"
              />
              <path
                d="M1070.92,210.45c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1070.92,210.45Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1085.23,225.85c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1085.23,225.85Z"
                fill="#2f6840"
              />
              <path
                d="M1084.72,225.51c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1084.72,225.51Z"
                fill="#3ba525"
              />
              <path
                d="M1085.48,225.48a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1085.48,225.48Z"
                fill="#2f6840"
              />
              <path
                d="M1089,224.69c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1089,224.69Z"
                fill="#2f6840"
              />
              <path
                d="M1087.59,227.9a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1087.59,227.9Z"
                fill="#2f6840"
              />
              <path
                d="M1085.63,225.94c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1085.63,225.94Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1071.77,220.28c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1071.77,220.28Z"
                fill="#2f6840"
              />
              <path
                d="M1071.27,219.94c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1071.27,219.94Z"
                fill="#3ba525"
              />
              <path
                d="M1072,219.91a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1072,219.91Z"
                fill="#2f6840"
              />
              <path
                d="M1075.5,219.12c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1075.5,219.12Z"
                fill="#2f6840"
              />
              <path
                d="M1074.13,222.33a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1074.13,222.33Z"
                fill="#2f6840"
              />
              <path
                d="M1072.17,220.37c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1072.17,220.37Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1076.07,183.91c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.23-2.77,2.92-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1076.07,183.91Z"
                fill="#2f6840"
              />
              <path
                d="M1075.56,183.57c4.43-.26-4.32.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1075.56,183.57Z"
                fill="#3ba525"
              />
              <path
                d="M1076.32,183.54a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1076.32,183.54Z"
                fill="#2f6840"
              />
              <path
                d="M1079.8,182.74c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1079.8,182.74Z"
                fill="#2f6840"
              />
              <path
                d="M1078.43,186a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1078.43,186Z"
                fill="#2f6840"
              />
              <path
                d="M1076.47,184a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1076.47,184Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1073.41,192.64c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1073.41,192.64Z"
                fill="#2f6840"
              />
              <path
                d="M1072.91,192.29c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1072.91,192.29Z"
                fill="#3ba525"
              />
              <path
                d="M1073.66,192.27a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.48.53A1,1,0,0,1,1073.66,192.27Z"
                fill="#2f6840"
              />
              <path
                d="M1077.14,191.47c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1077.14,191.47Z"
                fill="#2f6840"
              />
              <path
                d="M1075.77,194.68a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1075.77,194.68Z"
                fill="#2f6840"
              />
              <path
                d="M1073.81,192.73a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1073.81,192.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1068.06,187.68c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1068.06,187.68Z"
                fill="#2f6840"
              />
              <path
                d="M1067.55,187.34c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1067.55,187.34Z"
                fill="#3ba525"
              />
              <path
                d="M1068.31,187.31a2.24,2.24,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1068.31,187.31Z"
                fill="#2f6840"
              />
              <path
                d="M1071.78,186.51c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1071.78,186.51Z"
                fill="#2f6840"
              />
              <path
                d="M1070.42,189.72a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A1,1,0,0,1,1070.42,189.72Z"
                fill="#2f6840"
              />
              <path
                d="M1068.46,187.77a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1068.46,187.77Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1059.72,184.31c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1059.72,184.31Z"
                fill="#2f6840"
              />
              <path
                d="M1059.21,184c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1059.21,184Z"
                fill="#3ba525"
              />
              <path
                d="M1060,183.94a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1060,183.94Z"
                fill="#2f6840"
              />
              <path
                d="M1063.44,183.14c-.26,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1063.44,183.14Z"
                fill="#2f6840"
              />
              <path
                d="M1062.07,186.35a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.13,2.13,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1062.07,186.35Z"
                fill="#2f6840"
              />
              <path
                d="M1060.11,184.4a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1060.11,184.4Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1074.42,199.8c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1074.42,199.8Z"
                fill="#2f6840"
              />
              <path
                d="M1073.92,199.45c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1073.92,199.45Z"
                fill="#3ba525"
              />
              <path
                d="M1074.67,199.43a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.48.53A1,1,0,0,1,1074.67,199.43Z"
                fill="#2f6840"
              />
              <path
                d="M1078.15,198.63c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1078.15,198.63Z"
                fill="#2f6840"
              />
              <path
                d="M1076.78,201.84a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1076.78,201.84Z"
                fill="#2f6840"
              />
              <path
                d="M1074.82,199.88c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1074.82,199.88Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1061,194.23c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1061,194.23Z"
                fill="#2f6840"
              />
              <path
                d="M1060.46,193.88c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1060.46,193.88Z"
                fill="#3ba525"
              />
              <path
                d="M1061.21,193.86a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1061.21,193.86Z"
                fill="#2f6840"
              />
              <path
                d="M1064.69,193.06c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1064.69,193.06Z"
                fill="#2f6840"
              />
              <path
                d="M1063.32,196.27a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1063.32,196.27Z"
                fill="#2f6840"
              />
              <path
                d="M1061.36,194.32c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1061.36,194.32Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M1153.53,176.78l3,1.85a1,1,0,0,0,.91.06l7.17-3.2a1,1,0,0,0,.24-1.62h0a1,1,0,0,0-.77-.23L1153.91,175A1,1,0,0,0,1153.53,176.78Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1158.83 169.37 1154.79 170.22 1151.23 172.96 1157.19 175.35 1164.5 172.36 1158.83 169.37"
              fill="#ffedc8"
            />
            <polygon
              points="1151.23 172.96 1151.23 175.35 1156.95 177.8 1164.65 174.68 1164.5 172.36 1157.19 175.35 1151.23 172.96"
              fill="#ccae79"
            />
            <polygon
              points="1157.19 175.35 1156.95 177.8 1164.65 174.68 1164.5 172.36 1157.19 175.35"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1152.93,173.64a1.09,1.09,0,0,1,0,1.23c.27-.39.33-1.1.46-1.05Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1155.45,174.65a3.39,3.39,0,0,0,1.5-1.53l-1.08,1.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1160.21,174.11a1.11,1.11,0,0,1,.59,1l-.18-1.14Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1162.88,171.5a6.82,6.82,0,0,1-2.37,0,3.5,3.5,0,0,1-1.73.13s1.27-.13,1.73.31A10.09,10.09,0,0,1,1162.88,171.5Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1076.64,237.56l6.43,4a2.11,2.11,0,0,0,2,.13l15.43-6.9a2.08,2.08,0,0,0,.52-3.48h0a2.11,2.11,0,0,0-1.65-.5l-21.85,2.91A2.09,2.09,0,0,0,1076.64,237.56Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1088.05 221.6 1079.35 223.44 1071.69 229.33 1084.53 234.48 1100.26 228.04 1088.05 221.6"
              fill="#ffedc8"
            />
            <polygon
              points="1071.69 229.33 1071.69 234.48 1084.01 239.76 1100.6 233.03 1100.26 228.04 1084.53 234.48 1071.69 229.33"
              fill="#ccae79"
            />
            <polygon
              points="1084.53 234.48 1084.01 239.76 1100.6 233.03 1100.26 228.04 1084.53 234.48"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1075.35,230.8a2.31,2.31,0,0,1,0,2.64c.58-.82.72-2.35,1-2.24S1075.35,230.8,1075.35,230.8Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1080.77,233a7.28,7.28,0,0,0,3.24-3.29l-2.33,3.66Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1091,231.82a2.37,2.37,0,0,1,1.28,2.08l-.38-2.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1096.77,226.2c-.16-.09-3.25.63-5.1,0a7.35,7.35,0,0,1-3.73.26s2.73-.26,3.73.67A21.78,21.78,0,0,1,1096.77,226.2Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1123.67,233l2.22,1.38a.72.72,0,0,0,.68,0l5.34-2.38a.73.73,0,0,0,.17-1.21h0a.68.68,0,0,0-.56-.17l-7.56,1A.72.72,0,0,0,1123.67,233Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1127.62 227.48 1124.61 228.11 1121.96 230.15 1126.4 231.93 1131.84 229.7 1127.62 227.48"
              fill="#ffedc8"
            />
            <polygon
              points="1121.96 230.15 1121.96 231.93 1126.22 233.76 1131.95 231.43 1131.84 229.7 1126.4 231.93 1121.96 230.15"
              fill="#ccae79"
            />
            <polygon
              points="1126.4 231.93 1126.22 233.76 1131.95 231.43 1131.84 229.7 1126.4 231.93"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1123.23,230.66a.81.81,0,0,1,0,.91c.2-.28.24-.81.33-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1125.1,231.41a2.55,2.55,0,0,0,1.12-1.14l-.81,1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1128.64,231a.82.82,0,0,1,.45.72l-.14-.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1130.63,229.07a5.41,5.41,0,0,1-1.76,0,2.56,2.56,0,0,1-1.29.09s.94-.09,1.29.23A7.23,7.23,0,0,1,1130.63,229.07Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1107.73,237.36l2.22,1.38a.75.75,0,0,0,.68,0l5.34-2.39a.72.72,0,0,0,.18-1.2h0a.71.71,0,0,0-.57-.17l-7.56,1A.72.72,0,0,0,1107.73,237.36Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1111.68 231.84 1108.67 232.48 1106.02 234.52 1110.46 236.3 1115.9 234.07 1111.68 231.84"
              fill="#ffedc8"
            />
            <polygon
              points="1106.02 234.52 1106.02 236.3 1110.28 238.12 1116.02 235.8 1115.9 234.07 1110.46 236.3 1106.02 234.52"
              fill="#ccae79"
            />
            <polygon
              points="1110.46 236.3 1110.28 238.12 1116.02 235.8 1115.9 234.07 1110.46 236.3"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1107.29,235a.81.81,0,0,1,0,.91c.2-.29.24-.82.34-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1109.16,235.78a2.55,2.55,0,0,0,1.12-1.14l-.81,1.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1112.71,235.38a.82.82,0,0,1,.44.72l-.13-.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1114.69,233.43a5.13,5.13,0,0,1-1.76,0,2.56,2.56,0,0,1-1.29.09s.95-.09,1.29.23A7.78,7.78,0,0,1,1114.69,233.43Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1123.24,221l2.22,1.38a.75.75,0,0,0,.68,0l5.33-2.39a.71.71,0,0,0,.18-1.2h0a.69.69,0,0,0-.57-.17l-7.55,1A.72.72,0,0,0,1123.24,221Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1127.18 215.47 1124.18 216.11 1121.53 218.15 1125.97 219.93 1131.41 217.7 1127.18 215.47"
              fill="#ffedc8"
            />
            <polygon
              points="1121.53 218.15 1121.53 219.93 1125.79 221.75 1131.52 219.43 1131.41 217.7 1125.97 219.93 1121.53 218.15"
              fill="#ccae79"
            />
            <polygon
              points="1125.97 219.93 1125.79 221.75 1131.52 219.43 1131.41 217.7 1125.97 219.93"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1122.79,218.65a.81.81,0,0,1,0,.92c.2-.29.25-.82.34-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1124.67,219.41a2.6,2.6,0,0,0,1.12-1.14l-.81,1.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1128.21,219a.84.84,0,0,1,.45.72l-.14-.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1130.2,217.06a5.14,5.14,0,0,1-1.76,0,2.56,2.56,0,0,1-1.29.09s.94-.09,1.29.23A7.78,7.78,0,0,1,1130.2,217.06Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1159.22,222.54l4.71,2.92a1.54,1.54,0,0,0,1.43.1l11.3-5.06A1.52,1.52,0,0,0,1177,218h0a1.51,1.51,0,0,0-1.2-.36l-16,2.13A1.53,1.53,0,0,0,1159.22,222.54Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1167.58 210.85 1161.21 212.2 1155.59 216.51 1165 220.28 1176.52 215.56 1167.58 210.85"
              fill="#ffedc8"
            />
            <polygon
              points="1155.59 216.51 1155.59 220.28 1164.62 224.15 1176.77 219.22 1176.52 215.56 1165 220.28 1155.59 216.51"
              fill="#ccae79"
            />
            <polygon
              points="1165 220.28 1164.62 224.15 1176.77 219.22 1176.52 215.56 1165 220.28"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1158.28,217.59a1.7,1.7,0,0,1,0,1.93c.42-.6.52-1.72.72-1.64Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1162.25,219.18a5.34,5.34,0,0,0,2.37-2.41l-1.71,2.68Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1169.76,218.33a1.75,1.75,0,0,1,.94,1.53l-.29-1.8Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1174,214.22c-.12-.07-2.38.45-3.74,0a5.38,5.38,0,0,1-2.73.19s2-.2,2.73.49A15.91,15.91,0,0,1,1174,214.22Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1182.56,226.63l4.65,2.89a1.5,1.5,0,0,0,1.41.09l11.17-5a1.51,1.51,0,0,0,.38-2.52h0a1.48,1.48,0,0,0-1.19-.36l-15.82,2.1A1.52,1.52,0,0,0,1182.56,226.63Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1190.82 215.08 1184.52 216.41 1178.97 220.68 1188.27 224.4 1199.65 219.74 1190.82 215.08"
              fill="#ffedc8"
            />
            <polygon
              points="1178.97 220.68 1178.97 224.4 1187.89 228.22 1199.9 223.35 1199.65 219.74 1188.27 224.4 1178.97 220.68"
              fill="#ccae79"
            />
            <polygon
              points="1188.27 224.4 1187.89 228.22 1199.9 223.35 1199.65 219.74 1188.27 224.4"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1181.63,221.74a1.69,1.69,0,0,1,0,1.91c.42-.6.51-1.7.71-1.63Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1185.55,223.31a5.27,5.27,0,0,0,2.34-2.38l-1.68,2.64Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1193,222.48a1.69,1.69,0,0,1,.92,1.5l-.27-1.77Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1197.13,218.41c-.12-.06-2.35.45-3.7,0a5.36,5.36,0,0,1-2.69.19s2-.2,2.69.48A16,16,0,0,1,1197.13,218.41Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1204.48,243.91l-4,2.46a1.31,1.31,0,0,1-1.2.08l-9.51-4.25a1.29,1.29,0,0,1-.32-2.15h0a1.33,1.33,0,0,1,1-.31l13.48,1.8A1.29,1.29,0,0,1,1204.48,243.91Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1197.44 234.07 1202.81 235.21 1207.53 238.84 1199.61 242.01 1189.92 238.04 1197.44 234.07"
              fill="#ffedc8"
            />
            <polygon
              points="1207.53 238.84 1207.53 242.01 1199.93 245.27 1189.71 241.12 1189.92 238.04 1199.61 242.01 1207.53 238.84"
              fill="#ccae79"
            />
            <polygon
              points="1199.61 242.01 1199.93 245.27 1189.71 241.12 1189.92 238.04 1199.61 242.01"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1205.27,239.74a1.44,1.44,0,0,0,0,1.63c-.36-.51-.44-1.45-.61-1.38Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1201.93,241.08a4.52,4.52,0,0,1-2-2l1.44,2.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1195.61,240.37a1.47,1.47,0,0,0-.79,1.28l.24-1.51Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1192.07,236.91a9.7,9.7,0,0,0,3.14,0,4.57,4.57,0,0,0,2.3.16s-1.69-.17-2.3.41A13.29,13.29,0,0,0,1192.07,236.91Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1194.48,254.63l3,1.88a1,1,0,0,0,.92.06l7.28-3.25a1,1,0,0,0,.24-1.64h0a.94.94,0,0,0-.77-.23l-10.31,1.37A1,1,0,0,0,1194.48,254.63Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1199.86 247.1 1195.76 247.97 1192.14 250.75 1198.2 253.18 1205.62 250.14 1199.86 247.1"
              fill="#ffedc8"
            />
            <polygon
              points="1192.14 250.75 1192.14 253.18 1197.96 255.67 1205.78 252.5 1205.62 250.14 1198.2 253.18 1192.14 250.75"
              fill="#ccae79"
            />
            <polygon
              points="1198.2 253.18 1197.96 255.67 1205.78 252.5 1205.62 250.14 1198.2 253.18"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1193.87,251.44a1.1,1.1,0,0,1,0,1.25c.28-.39.34-1.11.47-1.06Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1196.43,252.47a3.47,3.47,0,0,0,1.53-1.55l-1.1,1.72Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1201.26,251.92a1.15,1.15,0,0,1,.61,1l-.18-1.16Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1204,249.27a7,7,0,0,1-2.4,0,3.47,3.47,0,0,1-1.76.13s1.29-.13,1.76.31A10.35,10.35,0,0,1,1204,249.27Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1179,279.15l3.82,2.37a1.23,1.23,0,0,0,1.16.08l9.17-4.1a1.24,1.24,0,0,0,.3-2.07h0a1.23,1.23,0,0,0-1-.29l-13,1.73A1.24,1.24,0,0,0,1179,279.15Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1185.77 269.67 1180.6 270.77 1176.05 274.27 1183.68 277.32 1193.02 273.5 1185.77 269.67"
              fill="#ffedc8"
            />
            <polygon
              points="1176.05 274.27 1176.05 277.32 1183.37 280.46 1193.22 276.46 1193.02 273.5 1183.68 277.32 1176.05 274.27"
              fill="#ccae79"
            />
            <polygon
              points="1183.68 277.32 1183.37 280.46 1193.22 276.46 1193.02 273.5 1183.68 277.32"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1178.23,275.14a1.38,1.38,0,0,1,0,1.57c.34-.49.42-1.4.58-1.34Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1181.45,276.43a4.36,4.36,0,0,0,1.92-2l-1.38,2.18Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1187.54,275.74a1.42,1.42,0,0,1,.76,1.24l-.23-1.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1191,272.41a9.33,9.33,0,0,1-3,0,4.41,4.41,0,0,1-2.21.15s1.62-.16,2.21.4A13.14,13.14,0,0,1,1191,272.41Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1169.3,274.46l2.25,1.4a.73.73,0,0,0,.69,0l5.42-2.42a.73.73,0,0,0,.18-1.22h0a.76.76,0,0,0-.58-.18l-7.67,1A.73.73,0,0,0,1169.3,274.46Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1173.3 268.85 1170.25 269.5 1167.56 271.57 1172.07 273.38 1177.59 271.11 1173.3 268.85"
              fill="#ffedc8"
            />
            <polygon
              points="1167.56 271.57 1167.56 273.38 1171.88 275.23 1177.71 272.87 1177.59 271.11 1172.07 273.38 1167.56 271.57"
              fill="#ccae79"
            />
            <polygon
              points="1172.07 273.38 1171.88 275.23 1177.71 272.87 1177.59 271.11 1172.07 273.38"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1168.84,272.08a.81.81,0,0,1,0,.93c.21-.29.26-.83.35-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1170.75,272.85a2.58,2.58,0,0,0,1.13-1.16l-.81,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1174.35,272.44a.84.84,0,0,1,.45.73l-.14-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1176.37,270.47a5.37,5.37,0,0,1-1.8,0,2.6,2.6,0,0,1-1.3.09s1-.09,1.3.23A8.1,8.1,0,0,1,1176.37,270.47Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1152.88,304.72l5.23,3.25a1.69,1.69,0,0,0,1.59.11l12.56-5.62a1.69,1.69,0,0,0,.42-2.83h0a1.68,1.68,0,0,0-1.34-.4l-17.79,2.36A1.7,1.7,0,0,0,1152.88,304.72Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1162.16 291.73 1155.09 293.23 1148.85 298.03 1159.3 302.22 1172.1 296.98 1162.16 291.73"
              fill="#ffedc8"
            />
            <polygon
              points="1148.85 298.03 1148.85 302.22 1158.88 306.52 1172.38 301.04 1172.1 296.98 1159.3 302.22 1148.85 298.03"
              fill="#ccae79"
            />
            <polygon
              points="1159.3 302.22 1158.88 306.52 1172.38 301.04 1172.1 296.98 1159.3 302.22"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1151.83,299.22a1.88,1.88,0,0,1,0,2.15c.47-.67.58-1.91.8-1.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1156.24,301a6,6,0,0,0,2.64-2.68l-1.9,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1164.59,300.05a1.94,1.94,0,0,1,1,1.7l-.31-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1169.26,295.48c-.13-.07-2.64.51-4.15,0a6,6,0,0,1-3,.21s2.22-.22,3,.54A17.87,17.87,0,0,1,1169.26,295.48Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1204.22,389.82l5,3.08a1.62,1.62,0,0,0,1.51.1l11.91-5.33a1.61,1.61,0,0,0,.4-2.69h0a1.63,1.63,0,0,0-1.27-.38l-16.87,2.25A1.61,1.61,0,0,0,1204.22,389.82Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1213.03 377.49 1206.31 378.92 1200.39 383.46 1210.31 387.44 1222.45 382.47 1213.03 377.49"
              fill="#ffedc8"
            />
            <polygon
              points="1200.39 383.46 1200.39 387.44 1209.91 391.52 1222.71 386.32 1222.45 382.47 1210.31 387.44 1200.39 383.46"
              fill="#ccae79"
            />
            <polygon
              points="1210.31 387.44 1209.91 391.52 1222.71 386.32 1222.45 382.47 1210.31 387.44"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1203.22,384.6a1.78,1.78,0,0,1,0,2c.45-.64.55-1.82.76-1.74Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1207.41,386.28a5.65,5.65,0,0,0,2.5-2.55l-1.8,2.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1215.32,385.39a1.83,1.83,0,0,1,1,1.6l-.29-1.89Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1219.76,381.05c-.13-.07-2.51.48-3.94,0a5.73,5.73,0,0,1-2.87.2s2.1-.21,2.87.51A17,17,0,0,1,1219.76,381.05Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1201.42,398.1l2.26,1.4a.76.76,0,0,0,.69,0l5.41-2.42a.73.73,0,0,0,.19-1.22h0a.76.76,0,0,0-.58-.18l-7.68,1A.74.74,0,0,0,1201.42,398.1Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1205.43 392.49 1202.37 393.14 1199.68 395.21 1204.19 397.01 1209.72 394.75 1205.43 392.49"
              fill="#ffedc8"
            />
            <polygon
              points="1199.68 395.21 1199.68 397.01 1204.01 398.87 1209.84 396.5 1209.72 394.75 1204.19 397.01 1199.68 395.21"
              fill="#ccae79"
            />
            <polygon
              points="1204.19 397.01 1204.01 398.87 1209.84 396.5 1209.72 394.75 1204.19 397.01"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1201,395.72a.82.82,0,0,1,0,.93c.2-.29.25-.83.34-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1202.87,396.49a2.57,2.57,0,0,0,1.14-1.16l-.82,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1206.47,396.08a.83.83,0,0,1,.45.73l-.13-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1208.49,394.11a5.32,5.32,0,0,1-1.79,0,2.64,2.64,0,0,1-1.31.09s1-.1,1.31.23A8,8,0,0,1,1208.49,394.11Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1184.17,407.66l2.25,1.4a.74.74,0,0,0,.69.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.72.72,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1184.17,407.66Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1188.17 402.06 1185.12 402.7 1182.43 404.77 1186.94 406.58 1192.46 404.32 1188.17 402.06"
              fill="#ffedc8"
            />
            <polygon
              points="1182.43 404.77 1182.43 406.58 1186.76 408.43 1192.58 406.07 1192.46 404.32 1186.94 406.58 1182.43 404.77"
              fill="#ccae79"
            />
            <polygon
              points="1186.94 406.58 1186.76 408.43 1192.58 406.07 1192.46 404.32 1186.94 406.58"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1183.71,405.29a.8.8,0,0,1,0,.93c.21-.3.26-.83.35-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1185.62,406.05a2.62,2.62,0,0,0,1.14-1.16l-.82,1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1189.22,405.65a.83.83,0,0,1,.45.73l-.14-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1191.24,403.67a5.37,5.37,0,0,1-1.8,0,2.47,2.47,0,0,1-1.3.09s1-.09,1.3.24A7.8,7.8,0,0,1,1191.24,403.67Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1168.85,409.4l2.26,1.4a.71.71,0,0,0,.68.05l5.42-2.43a.73.73,0,0,0,.18-1.22h0a.71.71,0,0,0-.57-.17l-7.68,1A.73.73,0,0,0,1168.85,409.4Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1172.86 403.79 1169.8 404.44 1167.11 406.51 1171.62 408.32 1177.14 406.06 1172.86 403.79"
              fill="#ffedc8"
            />
            <polygon
              points="1167.11 406.51 1167.11 408.32 1171.44 410.17 1177.26 407.81 1177.14 406.06 1171.62 408.32 1167.11 406.51"
              fill="#ccae79"
            />
            <polygon
              points="1171.62 408.32 1171.44 410.17 1177.26 407.81 1177.14 406.06 1171.62 408.32"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1168.4,407a.81.81,0,0,1,0,.92c.2-.29.25-.82.34-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1170.3,407.79a2.57,2.57,0,0,0,1.14-1.16l-.82,1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1173.9,407.38a.84.84,0,0,1,.45.73l-.13-.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1175.92,405.41a5.32,5.32,0,0,1-1.79,0,2.51,2.51,0,0,1-1.31.09s1-.09,1.31.24A7.66,7.66,0,0,1,1175.92,405.41Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1169.09,400.93l5.23,3.24a1.69,1.69,0,0,0,1.59.11l12.55-5.61a1.71,1.71,0,0,0,.42-2.84h0a1.76,1.76,0,0,0-1.34-.4l-17.78,2.37A1.7,1.7,0,0,0,1169.09,400.93Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1178.37 387.95 1171.29 389.45 1165.06 394.24 1175.51 398.42 1188.3 393.19 1178.37 387.95"
              fill="#ffedc8"
            />
            <polygon
              points="1165.06 394.24 1165.06 398.42 1175.09 402.72 1188.58 397.25 1188.3 393.19 1175.51 398.42 1165.06 394.24"
              fill="#ccae79"
            />
            <polygon
              points="1175.51 398.42 1175.09 402.72 1188.58 397.25 1188.3 393.19 1175.51 398.42"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1168,395.43a1.88,1.88,0,0,1,0,2.15c.47-.67.58-1.91.8-1.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1172.45,397.2a5.92,5.92,0,0,0,2.63-2.68l-1.89,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1180.79,396.26a1.93,1.93,0,0,1,1,1.69l-.31-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1185.46,391.69c-.13-.07-2.64.51-4.15,0a6,6,0,0,1-3,.21s2.22-.21,3,.54A17.87,17.87,0,0,1,1185.46,391.69Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1155,409.6l2.26,1.4a.71.71,0,0,0,.68.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.76.76,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1155,409.6Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1158.99 404 1155.94 404.65 1153.25 406.71 1157.76 408.52 1163.28 406.26 1158.99 404"
              fill="#ffedc8"
            />
            <polygon
              points="1153.25 406.71 1153.25 408.52 1157.58 410.38 1163.4 408.01 1163.28 406.26 1157.76 408.52 1153.25 406.71"
              fill="#ccae79"
            />
            <polygon
              points="1157.76 408.52 1157.58 410.38 1163.4 408.01 1163.28 406.26 1157.76 408.52"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1154.54,407.23a.82.82,0,0,1,0,.93c.2-.29.25-.83.34-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1156.44,408a2.57,2.57,0,0,0,1.14-1.15l-.82,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1160,407.59a.83.83,0,0,1,.45.73l-.14-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1162.06,405.61a5.32,5.32,0,0,1-1.79,0,2.59,2.59,0,0,1-1.31.1s1-.1,1.31.23A7.66,7.66,0,0,1,1162.06,405.61Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1156.84,420l-2.26,1.4a.73.73,0,0,1-.69,0l-5.42-2.42a.73.73,0,0,1-.18-1.22h0a.76.76,0,0,1,.58-.18l7.68,1A.74.74,0,0,1,1156.84,420Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1152.83 414.39 1155.88 415.04 1158.58 417.11 1154.07 418.92 1148.54 416.65 1152.83 414.39"
              fill="#ffedc8"
            />
            <polygon
              points="1158.58 417.11 1158.58 418.92 1154.25 420.77 1148.42 418.41 1148.54 416.65 1154.07 418.92 1158.58 417.11"
              fill="#ccae79"
            />
            <polygon
              points="1154.07 418.92 1154.25 420.77 1148.42 418.41 1148.54 416.65 1154.07 418.92"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1157.29,417.62a.82.82,0,0,0,0,.93c-.21-.29-.25-.83-.35-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1155.39,418.39a2.57,2.57,0,0,1-1.14-1.16l.82,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1151.78,418a.82.82,0,0,0-.44.73l.13-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1149.77,416a5.31,5.31,0,0,0,1.79,0,2.64,2.64,0,0,0,1.31.09s-1-.09-1.31.23A8,8,0,0,0,1149.77,416Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1142.34,285.11l2.26,1.4a.71.71,0,0,0,.68.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.74.74,0,0,0-.57-.17l-7.68,1A.73.73,0,0,0,1142.34,285.11Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1146.35 279.51 1143.29 280.16 1140.6 282.22 1145.11 284.03 1150.63 281.77 1146.35 279.51"
              fill="#ffedc8"
            />
            <polygon
              points="1140.6 282.22 1140.6 284.03 1144.93 285.89 1150.75 283.52 1150.63 281.77 1145.11 284.03 1140.6 282.22"
              fill="#ccae79"
            />
            <polygon
              points="1145.11 284.03 1144.93 285.89 1150.75 283.52 1150.63 281.77 1145.11 284.03"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1141.89,282.74a.82.82,0,0,1,0,.93c.2-.29.25-.83.34-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1143.79,283.5a2.57,2.57,0,0,0,1.14-1.15l-.82,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1147.39,283.1a.83.83,0,0,1,.45.73l-.13-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1149.41,281.12a5.32,5.32,0,0,1-1.79,0,2.51,2.51,0,0,1-1.31.09s1-.09,1.31.24A7.66,7.66,0,0,1,1149.41,281.12Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1195.35,309.52l6.06,3.76a2,2,0,0,0,1.84.12l14.55-6.5a2,2,0,0,0,.48-3.29h0a1.94,1.94,0,0,0-1.55-.46l-20.6,2.74A2,2,0,0,0,1195.35,309.52Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1206.1 294.47 1197.9 296.21 1190.67 301.76 1202.78 306.61 1217.61 300.54 1206.1 294.47"
              fill="#ffedc8"
            />
            <polygon
              points="1190.67 301.76 1190.67 306.61 1202.29 311.59 1217.93 305.25 1217.61 300.54 1202.78 306.61 1190.67 301.76"
              fill="#ccae79"
            />
            <polygon
              points="1202.78 306.61 1202.29 311.59 1217.93 305.25 1217.61 300.54 1202.78 306.61"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1194.13,303.15a2.18,2.18,0,0,1,0,2.49c.55-.78.67-2.23.93-2.12Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1199.24,305.19a6.82,6.82,0,0,0,3-3.1l-2.19,3.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1208.91,304.11a2.22,2.22,0,0,1,1.2,2l-.36-2.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1214.33,298.81c-.16-.09-3.07.59-4.82,0a6.88,6.88,0,0,1-3.51.24s2.58-.25,3.51.63A20.61,20.61,0,0,1,1214.33,298.81Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1225.31,327.91l6.06,3.76a1.94,1.94,0,0,0,1.84.13l14.55-6.5a2,2,0,0,0,.49-3.29h0a2,2,0,0,0-1.55-.47l-20.61,2.75A2,2,0,0,0,1225.31,327.91Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1236.07 312.86 1227.86 314.6 1220.63 320.16 1232.74 325.01 1247.58 318.94 1236.07 312.86"
              fill="#ffedc8"
            />
            <polygon
              points="1220.63 320.16 1220.63 325.01 1232.26 329.99 1247.9 323.64 1247.58 318.94 1232.74 325.01 1220.63 320.16"
              fill="#ccae79"
            />
            <polygon
              points="1232.74 325.01 1232.26 329.99 1247.9 323.64 1247.58 318.94 1232.74 325.01"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1224.09,321.54a2.18,2.18,0,0,1,0,2.49c.55-.78.68-2.22.93-2.12Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1229.2,323.59a6.87,6.87,0,0,0,3.06-3.1l-2.2,3.44Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1238.87,322.5a2.26,2.26,0,0,1,1.21,2l-.36-2.3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1244.29,317.2c-.15-.08-3.06.59-4.81,0a7,7,0,0,1-3.51.25s2.57-.25,3.51.63A20.66,20.66,0,0,1,1244.29,317.2Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1237,337.81l3.31,1.59a1.31,1.31,0,0,0,1,.05l7.94-2.74c.72-.25.86-1,.26-1.39h0a1.33,1.33,0,0,0-.84-.19l-11.25,1.15C1236.45,336.39,1236.16,337.4,1237,337.81Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1242.89 331.47 1238.42 332.2 1234.47 334.54 1241.08 336.59 1249.18 334.03 1242.89 331.47"
              fill="#ffedc8"
            />
            <polygon
              points="1234.47 334.54 1234.47 336.59 1240.82 338.69 1249.35 336.01 1249.18 334.03 1241.08 336.59 1234.47 334.54"
              fill="#ccae79"
            />
            <polygon
              points="1241.08 336.59 1240.82 338.69 1249.35 336.01 1249.18 334.03 1241.08 336.59"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1236.36,335.13a.76.76,0,0,1,0,1.05c.3-.33.37-.94.5-.9Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1239.15,336a3.54,3.54,0,0,0,1.66-1.31l-1.19,1.46Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1244.42,335.53s.72.29.66.83l-.19-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1247.38,333.3a10.26,10.26,0,0,1-2.62,0,5,5,0,0,1-1.92.1,4,4,0,0,1,1.92.27A14.21,14.21,0,0,1,1247.38,333.3Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1228,347.56l3.3,1.59a1.41,1.41,0,0,0,1,.05l7.94-2.74c.72-.25.86-1,.27-1.39h0a1.3,1.3,0,0,0-.85-.19L1228.37,346C1227.37,346.13,1227.09,347.15,1228,347.56Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1233.82 341.21 1229.34 341.95 1225.4 344.29 1232.01 346.34 1240.1 343.77 1233.82 341.21"
              fill="#ffedc8"
            />
            <polygon
              points="1225.4 344.29 1225.4 346.34 1231.74 348.44 1240.28 345.76 1240.1 343.77 1232.01 346.34 1225.4 344.29"
              fill="#ccae79"
            />
            <polygon
              points="1232.01 346.34 1231.74 348.44 1240.28 345.76 1240.1 343.77 1232.01 346.34"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1227.28,344.87a.76.76,0,0,1,0,1.06c.3-.33.37-.94.51-.9Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1230.07,345.74a3.54,3.54,0,0,0,1.67-1.31l-1.2,1.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1235.35,345.28s.72.29.66.83l-.2-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1238.31,343a9.88,9.88,0,0,1-2.63,0,4.82,4.82,0,0,1-1.91.11,4,4,0,0,1,1.91.26A14.39,14.39,0,0,1,1238.31,343Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1152.6,289.4l4.68,2.91a1.54,1.54,0,0,0,1.43.1l11.24-5a1.52,1.52,0,0,0,.38-2.54h0a1.51,1.51,0,0,0-1.2-.36l-15.93,2.12A1.52,1.52,0,0,0,1152.6,289.4Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1160.91 277.77 1154.57 279.12 1148.99 283.41 1158.35 287.16 1169.81 282.47 1160.91 277.77"
              fill="#ffedc8"
            />
            <polygon
              points="1148.99 283.41 1148.99 287.16 1157.97 291.01 1170.06 286.1 1169.81 282.47 1158.35 287.16 1148.99 283.41"
              fill="#ccae79"
            />
            <polygon
              points="1158.35 287.16 1157.97 291.01 1170.06 286.1 1169.81 282.47 1158.35 287.16"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1151.66,284.48a1.68,1.68,0,0,1,0,1.92c.42-.6.52-1.71.72-1.63Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1155.61,286.06a5.36,5.36,0,0,0,2.36-2.4l-1.7,2.67Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1163.08,285.22a1.74,1.74,0,0,1,.93,1.52l-.28-1.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1167.27,281.13c-.12-.07-2.37.45-3.72,0a5.44,5.44,0,0,1-2.71.19s2-.2,2.71.48A16.08,16.08,0,0,1,1167.27,281.13Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1138.08,214.27l5.72,3.55a1.87,1.87,0,0,0,1.75.12l13.75-6.15a1.86,1.86,0,0,0,.46-3.1h0a1.88,1.88,0,0,0-1.47-.44l-19.48,2.59A1.86,1.86,0,0,0,1138.08,214.27Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1148.24 200.04 1140.49 201.69 1133.66 206.93 1145.11 211.52 1159.12 205.78 1148.24 200.04"
              fill="#ffedc8"
            />
            <polygon
              points="1133.66 206.93 1133.66 211.52 1144.64 216.23 1159.43 210.23 1159.12 205.78 1145.11 211.52 1133.66 206.93"
              fill="#ccae79"
            />
            <polygon
              points="1145.11 211.52 1144.64 216.23 1159.43 210.23 1159.12 205.78 1145.11 211.52"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1136.93,208.24a2.07,2.07,0,0,1,0,2.36c.51-.74.63-2.1.87-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1141.76,210.18a6.52,6.52,0,0,0,2.88-2.93l-2.07,3.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1150.89,209.15A2.15,2.15,0,0,1,1152,211l-.35-2.19Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1156,204.14c-.15-.07-2.9.56-4.55,0a6.47,6.47,0,0,1-3.32.23s2.43-.23,3.32.6A19.88,19.88,0,0,1,1156,204.14Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1139,177.29l2.23,1.38a.72.72,0,0,0,.67.05l5.34-2.39a.73.73,0,0,0,.18-1.21h0a.79.79,0,0,0-.57-.17l-7.56,1A.72.72,0,0,0,1139,177.29Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1142.95 171.77 1139.94 172.41 1137.29 174.45 1141.73 176.23 1147.17 174 1142.95 171.77"
              fill="#ffedc8"
            />
            <polygon
              points="1137.29 174.45 1137.29 176.23 1141.55 178.05 1147.29 175.72 1147.17 174 1141.73 176.23 1137.29 174.45"
              fill="#ccae79"
            />
            <polygon
              points="1141.73 176.23 1141.55 178.05 1147.29 175.72 1147.17 174 1141.73 176.23"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1138.56,175a.81.81,0,0,1,0,.92c.2-.29.25-.82.34-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1140.43,175.71a2.55,2.55,0,0,0,1.12-1.14l-.8,1.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1144,175.31a.82.82,0,0,1,.44.72l-.13-.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1146,173.36a5.2,5.2,0,0,1-1.77,0,2.56,2.56,0,0,1-1.29.09s.95-.09,1.29.23A7.83,7.83,0,0,1,1146,173.36Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1119.24,174.48l3,1.86a1,1,0,0,0,.91.06l7.17-3.21a1,1,0,0,0,.24-1.62h0a1,1,0,0,0-.77-.22l-10.15,1.35A1,1,0,0,0,1119.24,174.48Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1124.54 167.07 1120.5 167.93 1116.94 170.66 1122.9 173.05 1130.21 170.06 1124.54 167.07"
              fill="#ffedc8"
            />
            <polygon
              points="1116.94 170.66 1116.94 173.05 1122.66 175.51 1130.36 172.38 1130.21 170.06 1122.9 173.05 1116.94 170.66"
              fill="#ccae79"
            />
            <polygon
              points="1122.9 173.05 1122.66 175.51 1130.36 172.38 1130.21 170.06 1122.9 173.05"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1118.64,171.34a1.09,1.09,0,0,1,0,1.23c.27-.38.33-1.09.46-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1121.16,172.35a3.39,3.39,0,0,0,1.5-1.53l-1.08,1.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1125.92,171.82a1.09,1.09,0,0,1,.59,1l-.18-1.13Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1128.59,169.21a7.09,7.09,0,0,1-2.37,0,3.41,3.41,0,0,1-1.73.12s1.27-.12,1.73.31A9.83,9.83,0,0,1,1128.59,169.21Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1091.6,207.42l5.14,3.19a1.66,1.66,0,0,0,1.57.11l12.36-5.53a1.67,1.67,0,0,0,.42-2.79h0a1.68,1.68,0,0,0-1.32-.39l-17.51,2.33A1.67,1.67,0,0,0,1091.6,207.42Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1100.73 194.63 1093.77 196.11 1087.63 200.83 1097.91 204.95 1110.52 199.79 1100.73 194.63"
              fill="#ffedc8"
            />
            <polygon
              points="1087.63 200.83 1087.63 204.95 1097.5 209.18 1110.79 203.79 1110.52 199.79 1097.91 204.95 1087.63 200.83"
              fill="#ccae79"
            />
            <polygon
              points="1097.91 204.95 1097.5 209.18 1110.79 203.79 1110.52 199.79 1097.91 204.95"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1090.56,202a1.87,1.87,0,0,1,0,2.12c.47-.66.58-1.89.79-1.8Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1094.9,203.74a5.86,5.86,0,0,0,2.6-2.63l-1.87,2.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1103.12,202.82a1.9,1.9,0,0,1,1,1.67l-.3-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1107.72,198.32c-.13-.07-2.6.5-4.09,0a6,6,0,0,1-3,.21s2.19-.22,3,.53A17.73,17.73,0,0,1,1107.72,198.32Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1070.71,194.07l5.29,3.28a1.71,1.71,0,0,0,1.6.11l12.69-5.67a1.72,1.72,0,0,0,.43-2.87h0a1.75,1.75,0,0,0-1.35-.41l-18,2.4A1.72,1.72,0,0,0,1070.71,194.07Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1080.09 180.94 1072.94 182.46 1066.64 187.3 1077.2 191.54 1090.13 186.24 1080.09 180.94"
              fill="#ffedc8"
            />
            <polygon
              points="1066.64 187.3 1066.64 191.54 1076.77 195.88 1090.41 190.34 1090.13 186.24 1077.2 191.54 1066.64 187.3"
              fill="#ccae79"
            />
            <polygon
              points="1077.2 191.54 1076.77 195.88 1090.41 190.34 1090.13 186.24 1077.2 191.54"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1069.65,188.51a1.92,1.92,0,0,1,0,2.18c.48-.69.59-1.94.81-1.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1074.11,190.3a6,6,0,0,0,2.66-2.71l-1.91,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1082.54,189.35a2,2,0,0,1,1,1.71l-.31-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1087.27,184.73c-.14-.07-2.67.51-4.2,0a6,6,0,0,1-3.06.21s2.24-.22,3.06.55A18.43,18.43,0,0,1,1087.27,184.73Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1101.54,179.92l2.87,1.78a.92.92,0,0,0,.87.06l6.87-3.07a.93.93,0,0,0,.23-1.56h0a1,1,0,0,0-.73-.22l-9.74,1.3A.93.93,0,0,0,1101.54,179.92Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1106.63 172.81 1102.75 173.63 1099.33 176.25 1105.06 178.55 1112.07 175.68 1106.63 172.81"
              fill="#ffedc8"
            />
            <polygon
              points="1099.33 176.25 1099.33 178.55 1104.83 180.91 1112.22 177.9 1112.07 175.68 1105.06 178.55 1099.33 176.25"
              fill="#ccae79"
            />
            <polygon
              points="1105.06 178.55 1104.83 180.91 1112.22 177.9 1112.07 175.68 1105.06 178.55"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1101,176.91a1,1,0,0,1,0,1.18c.25-.37.31-1.05.43-1S1101,176.91,1101,176.91Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1103.38,177.88a3.3,3.3,0,0,0,1.45-1.47l-1,1.63Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1108,177.36a1.07,1.07,0,0,1,.57.93l-.17-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1110.51,174.86a6.76,6.76,0,0,1-2.27,0,3.2,3.2,0,0,1-1.66.11s1.22-.11,1.66.3A9.82,9.82,0,0,1,1110.51,174.86Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1142.36,166.31l6,3.72a2,2,0,0,0,1.83.13l14.41-6.44a2,2,0,0,0,.48-3.26h0a1.94,1.94,0,0,0-1.53-.46l-20.41,2.71A2,2,0,0,0,1142.36,166.31Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1153.02 151.4 1144.89 153.13 1137.73 158.63 1149.73 163.43 1164.42 157.42 1153.02 151.4"
              fill="#ffedc8"
            />
            <polygon
              points="1137.73 158.63 1137.73 163.43 1149.24 168.37 1164.73 162.08 1164.42 157.42 1149.73 163.43 1137.73 158.63"
              fill="#ccae79"
            />
            <polygon
              points="1149.73 163.43 1149.24 168.37 1164.73 162.08 1164.42 157.42 1149.73 163.43"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1141.16,160a2.17,2.17,0,0,1,0,2.47c.54-.78.67-2.2.92-2.1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1146.22,162a6.81,6.81,0,0,0,3-3.08l-2.17,3.42Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1155.79,161a2.23,2.23,0,0,1,1.2,1.94l-.36-2.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1161.16,155.7c-.15-.08-3,.58-4.77,0a6.86,6.86,0,0,1-3.47.24s2.55-.24,3.47.63A20.81,20.81,0,0,1,1161.16,155.7Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1162.27,164s1,2.07,2.49,2.42,3.64-1.1,3.31.1,2.73,1.72,4,1.4,4.21-3.14,4.19-4S1162.27,164,1162.27,164Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1162.22,162.28l0,1.7,2.5,1.74,3.24-.09.76,1.24s2.24,1,3.73-.1a12.05,12.05,0,0,0,2.62-3.14l0-1.7Z"
              fill="#ccae79"
            />
            <path
              d="M1164.82,161.1l-2.6,1.18,2.68,1.73,3.1-.09,1,1.28s3,.82,3.42-.09a18.8,18.8,0,0,1,2.62-3.18l-2.43-1Z"
              fill="#ffedc8"
            />
            <polygon
              points="1164.9 164.01 1164.77 165.72 1168.01 165.63 1168 163.93 1164.9 164.01"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1171.68,165.52s.53,1.54,0,1.65a7.45,7.45,0,0,0,3.4-3.54l0-1.7S1172.39,165.51,1171.68,165.52Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1169.59,165.33l.61.11s-.38-.1-.29.62A1.7,1.7,0,0,0,1169.59,165.33Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1171,165.55c-.06,0,.13,0,.68-.58a3.58,3.58,0,0,0,.75-1.16s-1.31,1.51-1,1.73Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1163.79,163.29a10.65,10.65,0,0,1,0,1.23s-.07-.93.19-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1168.55,161l1.23,0c.09,0-1,0-1.22.58V161"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1163.53,161.69l.65-.3s-.37.24-.22.28.72.29,1,.16a1,1,0,0,1,.62,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1096.31,223.55s2,4,4.77,4.63,7-2.09,6.32.19,5.23,3.3,7.75,2.68,8-6,8-7.71S1096.31,223.55,1096.31,223.55Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1096.23,220.3l.08,3.25,4.78,3.33,6.2-.17,1.47,2.38s4.27,2,7.12-.19a23.11,23.11,0,0,0,5-6l-.09-3.25Z"
              fill="#ccae79"
            />
            <path
              d="M1101.2,218.06l-5,2.24,5.12,3.31,5.92-.16,2,2.44s5.82,1.57,6.53-.17,5-6.08,5-6.08l-4.65-2Z"
              fill="#ffedc8"
            />
            <polygon
              points="1101.35 223.61 1101.09 226.88 1107.29 226.71 1107.27 223.45 1101.35 223.61"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1114.31,226.5s1,3,.09,3.16a14.25,14.25,0,0,0,6.48-6.77l-.09-3.25S1115.67,226.48,1114.31,226.5Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1110.31,226.14l1.18.21s-.73-.19-.55,1.18A3.32,3.32,0,0,0,1110.31,226.14Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1113,226.56c-.13-.05.23,0,1.28-1.1a6.75,6.75,0,0,0,1.44-2.23s-2.51,2.9-1.89,3.3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1099.22,222.24a18.57,18.57,0,0,1,.07,2.35s-.14-1.77.35-2.08Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1108.32,217.87l2.35-.07c.18,0-1.84,0-2.32,1.11l0-1"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1098.73,219.17l1.24-.55s-.7.44-.42.53,1.38.54,1.82.3a1.83,1.83,0,0,1,1.18,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1130.86,223.67s1.56,3.1,3.74,3.63,5.47-1.64,5,.15,4.11,2.59,6.09,2.1,6.32-4.71,6.29-6.05S1130.86,223.67,1130.86,223.67Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1130.79,221.11l.07,2.56,3.75,2.61,4.86-.13,1.16,1.87s3.35,1.56,5.59-.15a18.31,18.31,0,0,0,3.93-4.73l-.07-2.55Z"
              fill="#ccae79"
            />
            <path
              d="M1134.7,219.35l-3.91,1.76,4,2.6,4.64-.12,1.56,1.91s4.57,1.23,5.13-.14,3.93-4.77,3.93-4.77l-3.66-1.55Z"
              fill="#ffedc8"
            />
            <polygon
              points="1134.82 223.72 1134.61 226.28 1139.47 226.15 1139.46 223.59 1134.82 223.72"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1145,226s.8,2.32.07,2.48a11.2,11.2,0,0,0,5.09-5.32l-.07-2.55S1146.06,226,1145,226Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1141.85,225.7l.92.17s-.57-.15-.43.92A2.58,2.58,0,0,0,1141.85,225.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1144,226c-.1,0,.18,0,1-.86a5.63,5.63,0,0,0,1.13-1.76s-2,2.28-1.49,2.6Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1133.14,222.63a14.48,14.48,0,0,1,0,1.85s-.1-1.39.28-1.63Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1140.29,219.2l1.84,0c.14,0-1.45,0-1.82.87l0-.82"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1132.76,220.23l1-.44s-.55.35-.33.42,1.08.42,1.43.24a1.39,1.39,0,0,1,.93,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1194,273.82s1.84,3.64,4.4,4.26,6.41-1.93,5.81.17,4.82,3,7.13,2.47,7.42-5.53,7.39-7.1S1194,273.82,1194,273.82Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1193.89,270.83l.08,3,4.4,3.06,5.71-.15,1.35,2.19s3.94,1.83,6.56-.18a21.17,21.17,0,0,0,4.6-5.53l-.08-3Z"
              fill="#ccae79"
            />
            <path
              d="M1198.48,268.76l-4.59,2.07,4.72,3.05,5.45-.15,1.83,2.24s5.36,1.45,6-.16,4.61-5.59,4.61-5.59l-4.28-1.83Z"
              fill="#ffedc8"
            />
            <polygon
              points="1198.61 273.88 1198.38 276.88 1204.08 276.73 1204.06 273.73 1198.61 273.88"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1210.55,276.53s.93,2.72.07,2.91a13.05,13.05,0,0,0,6-6.23l-.08-3S1211.8,276.51,1210.55,276.53Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1206.86,276.2l1.09.2s-.68-.18-.51,1.08A3.07,3.07,0,0,0,1206.86,276.2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1209.34,276.59c-.12,0,.21,0,1.18-1a6.33,6.33,0,0,0,1.32-2.06s-2.31,2.67-1.74,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1196.65,272.61a18.65,18.65,0,0,1,.06,2.16s-.12-1.63.33-1.91Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1205,268.58l2.17-.05c.15,0-1.71,0-2.15,1l0-1"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1196.2,269.79l1.14-.52s-.64.42-.38.5,1.27.49,1.67.27a1.7,1.7,0,0,1,1.09,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1185.43,232.85s-1.26,2.5-3,2.93-4.4-1.32-4,.12-3.3,2.08-4.89,1.69-5.09-3.79-5.06-4.87S1185.43,232.85,1185.43,232.85Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1185.48,230.8l0,2-3,2.11-3.91-.11-.93,1.5s-2.7,1.26-4.5-.12a14.52,14.52,0,0,1-3.16-3.8l0-2.05Z"
              fill="#ccae79"
            />
            <path
              d="M1182.34,229.38l3.14,1.42-3.24,2.09-3.73-.1-1.26,1.54s-3.67,1-4.12-.11-3.17-3.84-3.17-3.84l2.94-1.25Z"
              fill="#ffedc8"
            />
            <polygon
              points="1182.24 232.89 1182.41 234.96 1178.5 234.85 1178.51 232.79 1182.24 232.89"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1174.06,234.72s-.65,1.86-.06,2a8.94,8.94,0,0,1-4.09-4.28l0-2.05S1173.2,234.7,1174.06,234.72Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1176.58,234.49l-.74.13s.46-.12.35.75A2.14,2.14,0,0,1,1176.58,234.49Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1174.89,234.75c.08,0-.15,0-.81-.69a4.24,4.24,0,0,1-.91-1.41s1.58,1.83,1.19,2.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1183.59,232a11.73,11.73,0,0,0,0,1.49s.09-1.12-.23-1.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1177.84,229.26l-1.48,0c-.11,0,1.16,0,1.47.7v-.66"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1183.9,230.09l-.78-.35s.44.28.26.33-.87.34-1.15.19a1.17,1.17,0,0,0-.74,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1162.43,272.89s-1,2.08-2.5,2.43-3.66-1.1-3.32.1-2.74,1.73-4.06,1.41-4.22-3.15-4.2-4.05S1162.43,272.89,1162.43,272.89Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1162.47,271.19l0,1.7-2.51,1.75-3.25-.09-.77,1.25s-2.24,1-3.73-.1a12.2,12.2,0,0,1-2.62-3.15l0-1.71Z"
              fill="#ccae79"
            />
            <path
              d="M1159.86,270l2.61,1.17-2.69,1.74-3.1-.09-1,1.28s-3.05.82-3.42-.09a18.51,18.51,0,0,0-2.63-3.19l2.44-1Z"
              fill="#ffedc8"
            />
            <polygon
              points="1159.78 272.93 1159.92 274.64 1156.67 274.55 1156.68 272.84 1159.78 272.93"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1153,274.44s-.53,1.55,0,1.66a7.49,7.49,0,0,1-3.4-3.55l0-1.71S1152.28,274.43,1153,274.44Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1155.09,274.25l-.62.11s.38-.1.29.62A1.77,1.77,0,0,1,1155.09,274.25Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1153.68,274.47c.07,0-.12,0-.67-.57a3.59,3.59,0,0,1-.76-1.18s1.32,1.52,1,1.74Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1160.9,272.21a10.65,10.65,0,0,0,0,1.23s.07-.93-.19-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1156.13,269.91l-1.23,0c-.09,0,1,0,1.22.58v-.55"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1161.16,270.6l-.65-.29s.36.23.22.28-.72.28-1,.16a.91.91,0,0,0-.62,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1200.28,390.5s-1,2.08-2.5,2.43-3.65-1.1-3.32.1-2.74,1.73-4.06,1.4-4.22-3.15-4.2-4S1200.28,390.5,1200.28,390.5Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1200.32,388.8l0,1.7-2.51,1.75-3.25-.09-.77,1.25s-2.24,1-3.73-.1a12.17,12.17,0,0,1-2.62-3.16l0-1.7Z"
              fill="#ccae79"
            />
            <path
              d="M1197.71,387.62l2.61,1.18-2.69,1.74-3.1-.09-1,1.28s-3,.82-3.42-.09a18.56,18.56,0,0,0-2.62-3.19l2.43-1Z"
              fill="#ffedc8"
            />
            <polygon
              points="1197.63 390.54 1197.77 392.25 1194.53 392.16 1194.53 390.45 1197.63 390.54"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1190.84,392.05s-.53,1.55,0,1.66a7.49,7.49,0,0,1-3.4-3.56l0-1.7S1190.13,392,1190.84,392.05Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1192.94,391.86l-.62.11s.38-.1.29.62A1.77,1.77,0,0,1,1192.94,391.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1191.53,392.08c.07,0-.12,0-.67-.58a3.71,3.71,0,0,1-.76-1.17s1.32,1.52,1,1.74Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1198.75,389.81a10.87,10.87,0,0,0,0,1.24s.07-.93-.19-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1194,387.52l-1.23,0c-.09,0,1,0,1.22.58v-.55"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1199,388.21l-.65-.29s.36.23.22.28-.72.28-1,.15a1,1,0,0,0-.62,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1190.54,423.06s-1.8,3.57-4.29,4.17-6.27-1.88-5.69.17-4.7,3-7,2.41-7.24-5.4-7.21-6.94S1190.54,423.06,1190.54,423.06Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1190.62,420.14l-.08,2.92-4.3,3-5.58-.15-1.32,2.14s-3.85,1.79-6.41-.17a20.84,20.84,0,0,1-4.5-5.41l.08-2.93Z"
              fill="#ccae79"
            />
            <path
              d="M1186.14,418.12l4.48,2-4.62,3-5.32-.14-1.79,2.19s-5.24,1.41-5.87-.16-4.51-5.47-4.51-5.47l4.19-1.78Z"
              fill="#ffedc8"
            />
            <polygon
              points="1186 423.12 1186.24 426.06 1180.66 425.91 1180.68 422.98 1186 423.12"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1174.34,425.72s-.92,2.66-.08,2.84a12.8,12.8,0,0,1-5.83-6.09l.08-2.93S1173.12,425.7,1174.34,425.72Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1177.94,425.39l-1.06.2s.66-.17.5,1.06A3,3,0,0,1,1177.94,425.39Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1175.52,425.77c.12,0-.21,0-1.15-1a6.22,6.22,0,0,1-1.3-2s2.26,2.61,1.7,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1187.92,421.88a18,18,0,0,0-.06,2.12s.12-1.59-.32-1.87Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1179.73,418l-2.11-.06c-.16,0,1.66,0,2.09,1l0-.94"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1188.36,419.13l-1.11-.51s.62.41.37.49-1.24.48-1.63.27a1.67,1.67,0,0,0-1.07,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M226.22,233.85c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,226.22,233.85Z"
                fill="#2f6840"
              />
              <path
                d="M225.72,233.5c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,225.72,233.5Z"
                fill="#3ba525"
              />
              <path
                d="M226.47,233.47a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,226.47,233.47Z"
                fill="#2f6840"
              />
              <path
                d="M230,232.68c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,230,232.68Z"
                fill="#2f6840"
              />
              <path
                d="M228.58,235.89a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,228.58,235.89Z"
                fill="#2f6840"
              />
              <path
                d="M226.62,233.93c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23A9.24,9.24,0,0,0,224,235a2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,226.62,233.93Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M223.56,242.57c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,223.56,242.57Z"
                fill="#2f6840"
              />
              <path
                d="M223.06,242.23c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,223.06,242.23Z"
                fill="#3ba525"
              />
              <path
                d="M223.81,242.2a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,223.81,242.2Z"
                fill="#2f6840"
              />
              <path
                d="M227.29,241.41c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,227.29,241.41Z"
                fill="#2f6840"
              />
              <path
                d="M225.92,244.62a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,225.92,244.62Z"
                fill="#2f6840"
              />
              <path
                d="M224,242.66c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,224,242.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M218.21,237.62c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,218.21,237.62Z"
                fill="#2f6840"
              />
              <path
                d="M217.71,237.27c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,217.71,237.27Z"
                fill="#3ba525"
              />
              <path
                d="M218.46,237.24a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,218.46,237.24Z"
                fill="#2f6840"
              />
              <path
                d="M221.94,236.45a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,221.94,236.45Z"
                fill="#2f6840"
              />
              <path
                d="M220.57,239.66a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,220.57,239.66Z"
                fill="#2f6840"
              />
              <path
                d="M218.61,237.7c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,218.61,237.7Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M209.87,234.24c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,209.87,234.24Z"
                fill="#2f6840"
              />
              <path
                d="M209.36,233.9c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,209.36,233.9Z"
                fill="#3ba525"
              />
              <path
                d="M210.12,233.87a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,210.12,233.87Z"
                fill="#2f6840"
              />
              <path
                d="M213.59,233.08c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,213.59,233.08Z"
                fill="#2f6840"
              />
              <path
                d="M212.22,236.29a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,212.22,236.29Z"
                fill="#2f6840"
              />
              <path
                d="M210.27,234.33c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,210.27,234.33Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M224.57,249.73c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,224.57,249.73Z"
                fill="#2f6840"
              />
              <path
                d="M224.07,249.39c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,224.07,249.39Z"
                fill="#3ba525"
              />
              <path
                d="M224.82,249.36a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,224.82,249.36Z"
                fill="#2f6840"
              />
              <path
                d="M228.3,248.57c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,228.3,248.57Z"
                fill="#2f6840"
              />
              <path
                d="M226.93,251.78a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,226.93,251.78Z"
                fill="#2f6840"
              />
              <path
                d="M225,249.82c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,225,249.82Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M211.12,244.16c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,211.12,244.16Z"
                fill="#2f6840"
              />
              <path
                d="M210.61,243.82c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,210.61,243.82Z"
                fill="#3ba525"
              />
              <path
                d="M211.36,243.79a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,211.36,243.79Z"
                fill="#2f6840"
              />
              <path
                d="M214.84,243c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,214.84,243Z"
                fill="#2f6840"
              />
              <path
                d="M213.47,246.21a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,213.47,246.21Z"
                fill="#2f6840"
              />
              <path
                d="M211.51,244.25c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,211.51,244.25Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M253.56,239.4c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,253.56,239.4Z"
                fill="#2f6840"
              />
              <path
                d="M253.05,239.06c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,253.05,239.06Z"
                fill="#3ba525"
              />
              <path
                d="M253.81,239a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,253.81,239Z"
                fill="#2f6840"
              />
              <path
                d="M257.29,238.23c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,257.29,238.23Z"
                fill="#2f6840"
              />
              <path
                d="M255.92,241.44a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,255.92,241.44Z"
                fill="#2f6840"
              />
              <path
                d="M254,239.49c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,254,239.49Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M250.9,248.13c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,250.9,248.13Z"
                fill="#2f6840"
              />
              <path
                d="M250.4,247.79c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,250.4,247.79Z"
                fill="#3ba525"
              />
              <path
                d="M251.15,247.76a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,251.15,247.76Z"
                fill="#2f6840"
              />
              <path
                d="M254.63,247c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,254.63,247Z"
                fill="#2f6840"
              />
              <path
                d="M253.26,250.17a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,253.26,250.17Z"
                fill="#2f6840"
              />
              <path
                d="M251.3,248.22c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,251.3,248.22Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M245.55,243.17c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,245.55,243.17Z"
                fill="#2f6840"
              />
              <path
                d="M245,242.83c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,245,242.83Z"
                fill="#3ba525"
              />
              <path
                d="M245.8,242.8a2.17,2.17,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,245.8,242.8Z"
                fill="#2f6840"
              />
              <path
                d="M249.27,242c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,249.27,242Z"
                fill="#2f6840"
              />
              <path
                d="M247.91,245.21a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,247.91,245.21Z"
                fill="#2f6840"
              />
              <path
                d="M246,243.26c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.34,9.34,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,246,243.26Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M237.21,239.8c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,237.21,239.8Z"
                fill="#2f6840"
              />
              <path
                d="M236.7,239.46c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,236.7,239.46Z"
                fill="#3ba525"
              />
              <path
                d="M237.45,239.43a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,237.45,239.43Z"
                fill="#2f6840"
              />
              <path
                d="M240.93,238.63c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,240.93,238.63Z"
                fill="#2f6840"
              />
              <path
                d="M239.56,241.84a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,239.56,241.84Z"
                fill="#2f6840"
              />
              <path
                d="M237.61,239.89c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,237.61,239.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M251.91,255.29c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,251.91,255.29Z"
                fill="#2f6840"
              />
              <path
                d="M251.41,255c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,251.41,255Z"
                fill="#3ba525"
              />
              <path
                d="M252.16,254.92a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,252.16,254.92Z"
                fill="#2f6840"
              />
              <path
                d="M255.64,254.12c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,255.64,254.12Z"
                fill="#2f6840"
              />
              <path
                d="M254.27,257.33a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,254.27,257.33Z"
                fill="#2f6840"
              />
              <path
                d="M252.31,255.38a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,252.31,255.38Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M238.45,249.72c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,238.45,249.72Z"
                fill="#2f6840"
              />
              <path
                d="M238,249.38c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,238,249.38Z"
                fill="#3ba525"
              />
              <path
                d="M238.7,249.35a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,238.7,249.35Z"
                fill="#2f6840"
              />
              <path
                d="M242.18,248.55c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,242.18,248.55Z"
                fill="#2f6840"
              />
              <path
                d="M240.81,251.76a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,240.81,251.76Z"
                fill="#2f6840"
              />
              <path
                d="M238.85,249.81c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,238.85,249.81Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M275.89,256.42c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,275.89,256.42Z"
                fill="#2f6840"
              />
              <path
                d="M275.38,256.07c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,275.38,256.07Z"
                fill="#3ba525"
              />
              <path
                d="M276.13,256a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,276.13,256Z"
                fill="#2f6840"
              />
              <path
                d="M279.61,255.25a5.21,5.21,0,0,0-.72.1,3,3,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,279.61,255.25Z"
                fill="#2f6840"
              />
              <path
                d="M278.24,258.46a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,278.24,258.46Z"
                fill="#2f6840"
              />
              <path
                d="M276.28,256.5c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,276.28,256.5Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M273.23,265.15c4.42-.26-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,273.23,265.15Z"
                fill="#2f6840"
              />
              <path
                d="M272.72,264.8c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,272.72,264.8Z"
                fill="#3ba525"
              />
              <path
                d="M273.47,264.77a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,273.47,264.77Z"
                fill="#2f6840"
              />
              <path
                d="M277,264c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,277,264Z"
                fill="#2f6840"
              />
              <path
                d="M275.58,267.19a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,275.58,267.19Z"
                fill="#2f6840"
              />
              <path
                d="M273.62,265.23c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,273.62,265.23Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M267.87,260.19c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,267.87,260.19Z"
                fill="#2f6840"
              />
              <path
                d="M267.37,259.84c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,267.37,259.84Z"
                fill="#3ba525"
              />
              <path
                d="M268.12,259.81a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,268.12,259.81Z"
                fill="#2f6840"
              />
              <path
                d="M271.6,259c-.26,0-.49,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,271.6,259Z"
                fill="#2f6840"
              />
              <path
                d="M270.23,262.23a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,270.23,262.23Z"
                fill="#2f6840"
              />
              <path
                d="M268.27,260.27c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,268.27,260.27Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M259.53,256.82c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55S254.8,258,255,257.88A14.65,14.65,0,0,1,259.53,256.82Z"
                fill="#2f6840"
              />
              <path
                d="M259,256.47c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,259,256.47Z"
                fill="#3ba525"
              />
              <path
                d="M259.78,256.44a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,259.78,256.44Z"
                fill="#2f6840"
              />
              <path
                d="M263.26,255.65a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,263.26,255.65Z"
                fill="#2f6840"
              />
              <path
                d="M261.89,258.86a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,261.89,258.86Z"
                fill="#2f6840"
              />
              <path
                d="M259.93,256.9c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,259.93,256.9Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M274.24,272.31c4.42-.26-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,274.24,272.31Z"
                fill="#2f6840"
              />
              <path
                d="M273.73,272c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,273.73,272Z"
                fill="#3ba525"
              />
              <path
                d="M274.48,271.93a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,274.48,271.93Z"
                fill="#2f6840"
              />
              <path
                d="M278,271.14c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.48,2.48,0,0,1,1.24-.86A2.07,2.07,0,0,1,278,271.14Z"
                fill="#2f6840"
              />
              <path
                d="M276.59,274.35a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,276.59,274.35Z"
                fill="#2f6840"
              />
              <path
                d="M274.63,272.39c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,274.63,272.39Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M260.78,266.74c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,260.78,266.74Z"
                fill="#2f6840"
              />
              <path
                d="M260.27,266.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S268,267,267,266.86s-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,260.27,266.39Z"
                fill="#3ba525"
              />
              <path
                d="M261,266.36a2.21,2.21,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,261,266.36Z"
                fill="#2f6840"
              />
              <path
                d="M264.5,265.57a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,264.5,265.57Z"
                fill="#2f6840"
              />
              <path
                d="M263.14,268.78a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,263.14,268.78Z"
                fill="#2f6840"
              />
              <path
                d="M261.18,266.82c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.68,10.68,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,261.18,266.82Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M292,279.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,292,279.76Z"
                fill="#2f6840"
              />
              <path
                d="M291.49,279.42c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,291.49,279.42Z"
                fill="#3ba525"
              />
              <path
                d="M292.24,279.39a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,292.24,279.39Z"
                fill="#2f6840"
              />
              <path
                d="M295.72,278.59c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,295.72,278.59Z"
                fill="#2f6840"
              />
              <path
                d="M294.35,281.8a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,294.35,281.8Z"
                fill="#2f6840"
              />
              <path
                d="M292.39,279.85c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,292.39,279.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M289.33,288.49c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,289.33,288.49Z"
                fill="#2f6840"
              />
              <path
                d="M288.83,288.15c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,288.83,288.15Z"
                fill="#3ba525"
              />
              <path
                d="M289.58,288.12a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,289.58,288.12Z"
                fill="#2f6840"
              />
              <path
                d="M293.06,287.32c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,293.06,287.32Z"
                fill="#2f6840"
              />
              <path
                d="M291.69,290.53a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,291.69,290.53Z"
                fill="#2f6840"
              />
              <path
                d="M289.73,288.58c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,289.73,288.58Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M284,283.53c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,284,283.53Z"
                fill="#2f6840"
              />
              <path
                d="M283.47,283.19c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,283.47,283.19Z"
                fill="#3ba525"
              />
              <path
                d="M284.23,283.16a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,284.23,283.16Z"
                fill="#2f6840"
              />
              <path
                d="M287.7,282.37c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,287.7,282.37Z"
                fill="#2f6840"
              />
              <path
                d="M286.34,285.58a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,286.34,285.58Z"
                fill="#2f6840"
              />
              <path
                d="M284.38,283.62c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,284.38,283.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M275.64,280.16c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,275.64,280.16Z"
                fill="#2f6840"
              />
              <path
                d="M275.13,279.82c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,275.13,279.82Z"
                fill="#3ba525"
              />
              <path
                d="M275.88,279.79a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,275.88,279.79Z"
                fill="#2f6840"
              />
              <path
                d="M279.36,279c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,279.36,279Z"
                fill="#2f6840"
              />
              <path
                d="M278,282.2a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,278,282.2Z"
                fill="#2f6840"
              />
              <path
                d="M276,280.25c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,276,280.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M290.34,295.65c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,290.34,295.65Z"
                fill="#2f6840"
              />
              <path
                d="M289.84,295.31c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,289.84,295.31Z"
                fill="#3ba525"
              />
              <path
                d="M290.59,295.28a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,290.59,295.28Z"
                fill="#2f6840"
              />
              <path
                d="M294.07,294.48c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,294.07,294.48Z"
                fill="#2f6840"
              />
              <path
                d="M292.7,297.69a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,292.7,297.69Z"
                fill="#2f6840"
              />
              <path
                d="M290.74,295.74c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,290.74,295.74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M276.89,290.08c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,276.89,290.08Z"
                fill="#2f6840"
              />
              <path
                d="M276.38,289.74c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,276.38,289.74Z"
                fill="#3ba525"
              />
              <path
                d="M277.13,289.71a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,277.13,289.71Z"
                fill="#2f6840"
              />
              <path
                d="M280.61,288.91c-.26,0-.49,0-.72.1a3.77,3.77,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,280.61,288.91Z"
                fill="#2f6840"
              />
              <path
                d="M279.24,292.12a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,279.24,292.12Z"
                fill="#2f6840"
              />
              <path
                d="M277.28,290.17c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,277.28,290.17Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M313.05,298.18c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,313.05,298.18Z"
                fill="#2f6840"
              />
              <path
                d="M312.54,297.84c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55S307.82,299,308,298.9A14.24,14.24,0,0,1,312.54,297.84Z"
                fill="#3ba525"
              />
              <path
                d="M313.3,297.81a2.24,2.24,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,313.3,297.81Z"
                fill="#2f6840"
              />
              <path
                d="M316.77,297c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17c-.45.13-.87.34-1.35.53a2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,316.77,297Z"
                fill="#2f6840"
              />
              <path
                d="M315.4,300.22a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81A2.17,2.17,0,0,1,315,299a1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,315.4,300.22Z"
                fill="#2f6840"
              />
              <path
                d="M313.45,298.27a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,313.45,298.27Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M310.39,306.91c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,310.39,306.91Z"
                fill="#2f6840"
              />
              <path
                d="M309.88,306.56c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,309.88,306.56Z"
                fill="#3ba525"
              />
              <path
                d="M310.64,306.54a2.12,2.12,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,310.64,306.54Z"
                fill="#2f6840"
              />
              <path
                d="M314.11,305.74c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,314.11,305.74Z"
                fill="#2f6840"
              />
              <path
                d="M312.75,309a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,312.75,309Z"
                fill="#2f6840"
              />
              <path
                d="M310.79,307a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,310.79,307Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M305,302c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,305,302Z"
                fill="#2f6840"
              />
              <path
                d="M304.53,301.61c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,304.53,301.61Z"
                fill="#3ba525"
              />
              <path
                d="M305.28,301.58a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,305.28,301.58Z"
                fill="#2f6840"
              />
              <path
                d="M308.76,300.78c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,308.76,300.78Z"
                fill="#2f6840"
              />
              <path
                d="M307.39,304a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,307.39,304Z"
                fill="#2f6840"
              />
              <path
                d="M305.44,302a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,305.44,302Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M296.69,298.58c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,296.69,298.58Z"
                fill="#2f6840"
              />
              <path
                d="M296.19,298.23c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,296.19,298.23Z"
                fill="#3ba525"
              />
              <path
                d="M296.94,298.21a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,296.94,298.21Z"
                fill="#2f6840"
              />
              <path
                d="M300.42,297.41c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,300.42,297.41Z"
                fill="#2f6840"
              />
              <path
                d="M299.05,300.62a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,299.05,300.62Z"
                fill="#2f6840"
              />
              <path
                d="M297.09,298.67c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,297.09,298.67Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M311.4,314.07c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,311.4,314.07Z"
                fill="#2f6840"
              />
              <path
                d="M310.89,313.72c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,310.89,313.72Z"
                fill="#3ba525"
              />
              <path
                d="M311.65,313.7a2.12,2.12,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,311.65,313.7Z"
                fill="#2f6840"
              />
              <path
                d="M315.12,312.9c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,315.12,312.9Z"
                fill="#2f6840"
              />
              <path
                d="M313.76,316.11a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,313.76,316.11Z"
                fill="#2f6840"
              />
              <path
                d="M311.8,314.15c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,311.8,314.15Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M297.94,308.5c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,297.94,308.5Z"
                fill="#2f6840"
              />
              <path
                d="M297.44,308.15c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71S298,309,298,309s-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,297.44,308.15Z"
                fill="#3ba525"
              />
              <path
                d="M298.19,308.13a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.38,2.38,0,0,1,.47.53A1,1,0,0,1,298.19,308.13Z"
                fill="#2f6840"
              />
              <path
                d="M301.67,307.33c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,301.67,307.33Z"
                fill="#2f6840"
              />
              <path
                d="M300.3,310.54a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,300.3,310.54Z"
                fill="#2f6840"
              />
              <path
                d="M298.34,308.59a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,298.34,308.59Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M34.54,163.39c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,34.54,163.39Z"
                fill="#2f6840"
              />
              <path
                d="M34,163.05c4.42-.25-4.33.45-4.35-.61S34,159.81,35,160s.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,34,163.05Z"
                fill="#3ba525"
              />
              <path
                d="M34.79,163a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,34.79,163Z"
                fill="#2f6840"
              />
              <path
                d="M38.27,162.22c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,38.27,162.22Z"
                fill="#2f6840"
              />
              <path
                d="M36.9,165.43a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,36.9,165.43Z"
                fill="#2f6840"
              />
              <path
                d="M34.94,163.48c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,34.94,163.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M31.88,172.12c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,31.88,172.12Z"
                fill="#2f6840"
              />
              <path
                d="M31.38,171.78c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,31.38,171.78Z"
                fill="#3ba525"
              />
              <path
                d="M32.13,171.75a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,32.13,171.75Z"
                fill="#2f6840"
              />
              <path
                d="M35.61,171c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,35.61,171Z"
                fill="#2f6840"
              />
              <path
                d="M34.24,174.16a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,34.24,174.16Z"
                fill="#2f6840"
              />
              <path
                d="M32.28,172.21a7,7,0,0,0-.69.16,3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,32.28,172.21Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M26.53,167.16c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,26.53,167.16Z"
                fill="#2f6840"
              />
              <path
                d="M26,166.82c4.42-.25-4.33.46-4.36-.61S26,163.58,27,163.75s.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,26,166.82Z"
                fill="#3ba525"
              />
              <path
                d="M26.78,166.79a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,26.78,166.79Z"
                fill="#2f6840"
              />
              <path
                d="M30.26,166c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,30.26,166Z"
                fill="#2f6840"
              />
              <path
                d="M28.89,169.2a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,28.89,169.2Z"
                fill="#2f6840"
              />
              <path
                d="M26.93,167.25c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,26.93,167.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M18.19,163.79c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,18.19,163.79Z"
                fill="#2f6840"
              />
              <path
                d="M17.68,163.45c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,17.68,163.45Z"
                fill="#3ba525"
              />
              <path
                d="M18.44,163.42a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,18.44,163.42Z"
                fill="#2f6840"
              />
              <path
                d="M21.91,162.62c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,21.91,162.62Z"
                fill="#2f6840"
              />
              <path
                d="M20.55,165.83a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,20.55,165.83Z"
                fill="#2f6840"
              />
              <path
                d="M18.59,163.88c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,18.59,163.88Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M32.89,179.28c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,32.89,179.28Z"
                fill="#2f6840"
              />
              <path
                d="M32.39,178.94c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,32.39,178.94Z"
                fill="#3ba525"
              />
              <path
                d="M33.14,178.91a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,33.14,178.91Z"
                fill="#2f6840"
              />
              <path
                d="M36.62,178.11c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,36.62,178.11Z"
                fill="#2f6840"
              />
              <path
                d="M35.25,181.32a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,35.25,181.32Z"
                fill="#2f6840"
              />
              <path
                d="M33.29,179.37c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,33.29,179.37Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M19.44,173.71c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,19.44,173.71Z"
                fill="#2f6840"
              />
              <path
                d="M18.93,173.37c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,18.93,173.37Z"
                fill="#3ba525"
              />
              <path
                d="M19.68,173.34a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,19.68,173.34Z"
                fill="#2f6840"
              />
              <path
                d="M23.16,172.54c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,23.16,172.54Z"
                fill="#2f6840"
              />
              <path
                d="M21.79,175.75a1.94,1.94,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,21.79,175.75Z"
                fill="#2f6840"
              />
              <path
                d="M19.84,173.8c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,19.84,173.8Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M25.36,184c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,25.36,184Z"
                fill="#2f6840"
              />
              <path
                d="M24.86,183.64c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,24.86,183.64Z"
                fill="#3ba525"
              />
              <path
                d="M25.61,183.61a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,25.61,183.61Z"
                fill="#2f6840"
              />
              <path
                d="M29.09,182.82a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,29.09,182.82Z"
                fill="#2f6840"
              />
              <path
                d="M27.72,186a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,27.72,186Z"
                fill="#2f6840"
              />
              <path
                d="M25.76,184.07c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,25.76,184.07Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M22.7,192.71c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,22.7,192.71Z"
                fill="#2f6840"
              />
              <path
                d="M22.2,192.37c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S29.94,193,29,192.84s-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,22.2,192.37Z"
                fill="#3ba525"
              />
              <path
                d="M23,192.34a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,23,192.34Z"
                fill="#2f6840"
              />
              <path
                d="M26.43,191.55c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,26.43,191.55Z"
                fill="#2f6840"
              />
              <path
                d="M25.06,194.76a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,25.06,194.76Z"
                fill="#2f6840"
              />
              <path
                d="M23.1,192.8c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,23.1,192.8Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M17.35,187.76c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,17.35,187.76Z"
                fill="#2f6840"
              />
              <path
                d="M16.84,187.41c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,16.84,187.41Z"
                fill="#3ba525"
              />
              <path
                d="M17.6,187.38a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,17.6,187.38Z"
                fill="#2f6840"
              />
              <path
                d="M21.07,186.59a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,21.07,186.59Z"
                fill="#2f6840"
              />
              <path
                d="M19.71,189.8a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,19.71,189.8Z"
                fill="#2f6840"
              />
              <path
                d="M17.75,187.84c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,17.75,187.84Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M9,184.39c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,9,184.39Z"
                fill="#2f6840"
              />
              <path
                d="M8.5,184c4.43-.25-4.33.46-4.35-.61S8.5,180.8,9.43,181s.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72S9,184.92,9,184.92s-.91,3.33-3,2.55S3.77,185.19,4,185.1A14.65,14.65,0,0,1,8.5,184Z"
                fill="#3ba525"
              />
              <path
                d="M9.25,184a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,9.25,184Z"
                fill="#2f6840"
              />
              <path
                d="M12.73,183.22c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18A11.31,11.31,0,0,0,10,184a2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,12.73,183.22Z"
                fill="#2f6840"
              />
              <path
                d="M11.36,186.43a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,11.36,186.43Z"
                fill="#2f6840"
              />
              <path
                d="M9.41,184.47c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2.07,2.07,0,0,1,9.41,184.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M23.71,199.87c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55S19,201,19.16,200.93A15,15,0,0,1,23.71,199.87Z"
                fill="#2f6840"
              />
              <path
                d="M23.21,199.53c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S31,200.12,30,200s-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,23.21,199.53Z"
                fill="#3ba525"
              />
              <path
                d="M24,199.5a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,24,199.5Z"
                fill="#2f6840"
              />
              <path
                d="M27.44,198.71c-.26,0-.5,0-.73.09A4,4,0,0,0,26,199a11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,27.44,198.71Z"
                fill="#2f6840"
              />
              <path
                d="M26.07,201.92a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,26.07,201.92Z"
                fill="#2f6840"
              />
              <path
                d="M24.11,200c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,24.11,200Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M10.25,194.31c4.43-.26-4.32.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S18,194.89,17,194.78s-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,10.25,194.31Z"
                fill="#2f6840"
              />
              <path
                d="M9.75,194c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55S5,195.11,5.2,195A14.65,14.65,0,0,1,9.75,194Z"
                fill="#3ba525"
              />
              <path
                d="M10.5,193.93a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,10.5,193.93Z"
                fill="#2f6840"
              />
              <path
                d="M14,193.14c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,14,193.14Z"
                fill="#2f6840"
              />
              <path
                d="M12.61,196.35a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,12.61,196.35Z"
                fill="#2f6840"
              />
              <path
                d="M10.65,194.39c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,10.65,194.39Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M48.07,200.36c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,48.07,200.36Z"
                fill="#2f6840"
              />
              <path
                d="M47.56,200c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25S50,196.42,51.68,197s3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,47.56,200Z"
                fill="#3ba525"
              />
              <path
                d="M48.31,200a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,48.31,200Z"
                fill="#2f6840"
              />
              <path
                d="M51.79,199.19c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18A11.31,11.31,0,0,0,49,200a2.48,2.48,0,0,1,1.24-.86A2.07,2.07,0,0,1,51.79,199.19Z"
                fill="#2f6840"
              />
              <path
                d="M50.42,202.4a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,50.42,202.4Z"
                fill="#2f6840"
              />
              <path
                d="M48.46,200.44c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,48.46,200.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M45.41,209.08c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,45.41,209.08Z"
                fill="#2f6840"
              />
              <path
                d="M44.9,208.74c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,44.9,208.74Z"
                fill="#3ba525"
              />
              <path
                d="M45.65,208.71a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,45.65,208.71Z"
                fill="#2f6840"
              />
              <path
                d="M49.13,207.92c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,49.13,207.92Z"
                fill="#2f6840"
              />
              <path
                d="M47.76,211.13a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,47.76,211.13Z"
                fill="#2f6840"
              />
              <path
                d="M45.81,209.17c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,45.81,209.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M40.05,204.13c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,40.05,204.13Z"
                fill="#2f6840"
              />
              <path
                d="M39.55,203.78c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,39.55,203.78Z"
                fill="#3ba525"
              />
              <path
                d="M40.3,203.75a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,40.3,203.75Z"
                fill="#2f6840"
              />
              <path
                d="M43.78,203a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,43.78,203Z"
                fill="#2f6840"
              />
              <path
                d="M42.41,206.17a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,42.41,206.17Z"
                fill="#2f6840"
              />
              <path
                d="M40.45,204.21c-.24.06-.47.09-.69.16a3.33,3.33,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,40.45,204.21Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M31.71,200.75c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,31.71,200.75Z"
                fill="#2f6840"
              />
              <path
                d="M31.21,200.41c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S39,201,38,200.88s-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,31.21,200.41Z"
                fill="#3ba525"
              />
              <path
                d="M32,200.38a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,32,200.38Z"
                fill="#2f6840"
              />
              <path
                d="M35.44,199.59c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,35.44,199.59Z"
                fill="#2f6840"
              />
              <path
                d="M34.07,202.8a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,34.07,202.8Z"
                fill="#2f6840"
              />
              <path
                d="M32.11,200.84c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,32.11,200.84Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M46.42,216.24c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,46.42,216.24Z"
                fill="#2f6840"
              />
              <path
                d="M45.91,215.9c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,45.91,215.9Z"
                fill="#3ba525"
              />
              <path
                d="M46.66,215.87a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,46.66,215.87Z"
                fill="#2f6840"
              />
              <path
                d="M50.14,215.08c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,50.14,215.08Z"
                fill="#2f6840"
              />
              <path
                d="M48.77,218.29a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,48.77,218.29Z"
                fill="#2f6840"
              />
              <path
                d="M46.82,216.33c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,46.82,216.33Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M33,210.67c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,33,210.67Z"
                fill="#2f6840"
              />
              <path
                d="M32.45,210.33c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,32.45,210.33Z"
                fill="#3ba525"
              />
              <path
                d="M33.21,210.3a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,33.21,210.3Z"
                fill="#2f6840"
              />
              <path
                d="M36.68,209.51c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,36.68,209.51Z"
                fill="#2f6840"
              />
              <path
                d="M35.32,212.72a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,35.32,212.72Z"
                fill="#2f6840"
              />
              <path
                d="M33.36,210.76c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,33.36,210.76Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M75.55,207.68c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,75.55,207.68Z"
                fill="#2f6840"
              />
              <path
                d="M75,207.34c4.43-.25-4.32.46-4.35-.61S75,204.1,76,204.27s.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,75,207.34Z"
                fill="#3ba525"
              />
              <path
                d="M75.8,207.31a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,75.8,207.31Z"
                fill="#2f6840"
              />
              <path
                d="M79.27,206.52c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,79.27,206.52Z"
                fill="#2f6840"
              />
              <path
                d="M77.91,209.73a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,77.91,209.73Z"
                fill="#2f6840"
              />
              <path
                d="M76,207.77c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,76,207.77Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M72.89,216.41c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,72.89,216.41Z"
                fill="#2f6840"
              />
              <path
                d="M72.38,216.07c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,72.38,216.07Z"
                fill="#3ba525"
              />
              <path
                d="M73.14,216a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,73.14,216Z"
                fill="#2f6840"
              />
              <path
                d="M76.62,215.24c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,76.62,215.24Z"
                fill="#2f6840"
              />
              <path
                d="M75.25,218.45a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,75.25,218.45Z"
                fill="#2f6840"
              />
              <path
                d="M73.29,216.5c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,73.29,216.5Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M67.54,211.45c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,67.54,211.45Z"
                fill="#2f6840"
              />
              <path
                d="M67,211.11c4.43-.25-4.33.46-4.35-.61S67,207.87,68,208.05s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,67,211.11Z"
                fill="#3ba525"
              />
              <path
                d="M67.79,211.08a2.24,2.24,0,0,0-.8-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,67.79,211.08Z"
                fill="#2f6840"
              />
              <path
                d="M71.26,210.29c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,71.26,210.29Z"
                fill="#2f6840"
              />
              <path
                d="M69.89,213.5a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,69.89,213.5Z"
                fill="#2f6840"
              />
              <path
                d="M67.94,211.54c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,67.94,211.54Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M59.2,208.08c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,59.2,208.08Z"
                fill="#2f6840"
              />
              <path
                d="M58.69,207.74c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,58.69,207.74Z"
                fill="#3ba525"
              />
              <path
                d="M59.44,207.71a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,59.44,207.71Z"
                fill="#2f6840"
              />
              <path
                d="M62.92,206.91c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,62.92,206.91Z"
                fill="#2f6840"
              />
              <path
                d="M61.55,210.12a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,61.55,210.12Z"
                fill="#2f6840"
              />
              <path
                d="M59.59,208.17c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,59.59,208.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M73.9,223.57c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25S76.33,220,78,220.6s3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,73.9,223.57Z"
                fill="#2f6840"
              />
              <path
                d="M73.39,223.23c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,73.39,223.23Z"
                fill="#3ba525"
              />
              <path
                d="M74.15,223.2a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,74.15,223.2Z"
                fill="#2f6840"
              />
              <path
                d="M77.63,222.4c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,77.63,222.4Z"
                fill="#2f6840"
              />
              <path
                d="M76.26,225.61a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,76.26,225.61Z"
                fill="#2f6840"
              />
              <path
                d="M74.3,223.66c-.25.06-.48.09-.7.16A3.45,3.45,0,0,0,73,224a9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,74.3,223.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M60.44,218c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,60.44,218Z"
                fill="#2f6840"
              />
              <path
                d="M59.94,217.66c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,59.94,217.66Z"
                fill="#3ba525"
              />
              <path
                d="M60.69,217.63a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,60.69,217.63Z"
                fill="#2f6840"
              />
              <path
                d="M64.17,216.83c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,64.17,216.83Z"
                fill="#2f6840"
              />
              <path
                d="M62.8,220a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,62.8,220Z"
                fill="#2f6840"
              />
              <path
                d="M60.84,218.09c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,60.84,218.09Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M102.46,216.94c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,102.46,216.94Z"
                fill="#2f6840"
              />
              <path
                d="M102,216.6c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,102,216.6Z"
                fill="#3ba525"
              />
              <path
                d="M102.71,216.57a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,102.71,216.57Z"
                fill="#2f6840"
              />
              <path
                d="M106.19,215.78c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,106.19,215.78Z"
                fill="#2f6840"
              />
              <path
                d="M104.82,219a1.94,1.94,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,104.82,219Z"
                fill="#2f6840"
              />
              <path
                d="M102.86,217c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,102.86,217Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M99.8,225.67c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,99.8,225.67Z"
                fill="#2f6840"
              />
              <path
                d="M99.3,225.33c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,99.3,225.33Z"
                fill="#3ba525"
              />
              <path
                d="M100.05,225.3a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,100.05,225.3Z"
                fill="#2f6840"
              />
              <path
                d="M103.53,224.5c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,103.53,224.5Z"
                fill="#2f6840"
              />
              <path
                d="M102.16,227.71a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,102.16,227.71Z"
                fill="#2f6840"
              />
              <path
                d="M100.2,225.76c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,8.71,8.71,0,0,0-1.25.64,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,100.2,225.76Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M94.45,220.71c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,94.45,220.71Z"
                fill="#2f6840"
              />
              <path
                d="M94,220.37c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,94,220.37Z"
                fill="#3ba525"
              />
              <path
                d="M94.7,220.34a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,94.7,220.34Z"
                fill="#2f6840"
              />
              <path
                d="M98.18,219.55c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,98.18,219.55Z"
                fill="#2f6840"
              />
              <path
                d="M96.81,222.76a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,96.81,222.76Z"
                fill="#2f6840"
              />
              <path
                d="M94.85,220.8c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,94.85,220.8Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M86.11,217.34c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,86.11,217.34Z"
                fill="#2f6840"
              />
              <path
                d="M85.6,217c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25S88,213.41,89.73,214s3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,85.6,217Z"
                fill="#3ba525"
              />
              <path
                d="M86.36,217a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,86.36,217Z"
                fill="#2f6840"
              />
              <path
                d="M89.83,216.17c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,89.83,216.17Z"
                fill="#2f6840"
              />
              <path
                d="M88.47,219.38a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,88.47,219.38Z"
                fill="#2f6840"
              />
              <path
                d="M86.51,217.43c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.8,8.8,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,86.51,217.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M100.81,232.83c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45S102,232,102,232s1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,100.81,232.83Z"
                fill="#2f6840"
              />
              <path
                d="M100.31,232.49c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,100.31,232.49Z"
                fill="#3ba525"
              />
              <path
                d="M101.06,232.46a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,101.06,232.46Z"
                fill="#2f6840"
              />
              <path
                d="M104.54,231.66c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,104.54,231.66Z"
                fill="#2f6840"
              />
              <path
                d="M103.17,234.87a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,103.17,234.87Z"
                fill="#2f6840"
              />
              <path
                d="M101.21,232.92c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,101.21,232.92Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M87.36,227.26c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,87.36,227.26Z"
                fill="#2f6840"
              />
              <path
                d="M86.85,226.92c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25S89.29,223.33,91,224s3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,86.85,226.92Z"
                fill="#3ba525"
              />
              <path
                d="M87.6,226.89a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.23,2.23,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,87.6,226.89Z"
                fill="#2f6840"
              />
              <path
                d="M91.08,226.09c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,91.08,226.09Z"
                fill="#2f6840"
              />
              <path
                d="M89.71,229.3a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,89.71,229.3Z"
                fill="#2f6840"
              />
              <path
                d="M87.76,227.35c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,87.76,227.35Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M127.68,230.18c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,127.68,230.18Z"
                fill="#2f6840"
              />
              <path
                d="M127.17,229.83c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,127.17,229.83Z"
                fill="#3ba525"
              />
              <path
                d="M127.93,229.8a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,127.93,229.8Z"
                fill="#2f6840"
              />
              <path
                d="M131.4,229a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,131.4,229Z"
                fill="#2f6840"
              />
              <path
                d="M130,232.22a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,130,232.22Z"
                fill="#2f6840"
              />
              <path
                d="M128.08,230.26c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,128.08,230.26Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M125,238.91c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,125,238.91Z"
                fill="#2f6840"
              />
              <path
                d="M124.51,238.56c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,124.51,238.56Z"
                fill="#3ba525"
              />
              <path
                d="M125.27,238.53a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,125.27,238.53Z"
                fill="#2f6840"
              />
              <path
                d="M128.74,237.74a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,128.74,237.74Z"
                fill="#2f6840"
              />
              <path
                d="M127.38,241a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,127.38,241Z"
                fill="#2f6840"
              />
              <path
                d="M125.42,239c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,11.51,11.51,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,125.42,239Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M119.67,234c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,119.67,234Z"
                fill="#2f6840"
              />
              <path
                d="M119.16,233.6c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,119.16,233.6Z"
                fill="#3ba525"
              />
              <path
                d="M119.91,233.57a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,119.91,233.57Z"
                fill="#2f6840"
              />
              <path
                d="M123.39,232.78c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,123.39,232.78Z"
                fill="#2f6840"
              />
              <path
                d="M122,236a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,122,236Z"
                fill="#2f6840"
              />
              <path
                d="M120.07,234c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,120.07,234Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M111.32,230.58c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,111.32,230.58Z"
                fill="#2f6840"
              />
              <path
                d="M110.82,230.23c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,110.82,230.23Z"
                fill="#3ba525"
              />
              <path
                d="M111.57,230.2a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74A2.34,2.34,0,0,1,111,229a1.85,1.85,0,0,1,.47.53A1,1,0,0,1,111.57,230.2Z"
                fill="#2f6840"
              />
              <path
                d="M115.05,229.41a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,115.05,229.41Z"
                fill="#2f6840"
              />
              <path
                d="M113.68,232.62a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,113.68,232.62Z"
                fill="#2f6840"
              />
              <path
                d="M111.72,230.66c-.24.06-.47.09-.69.16a3.33,3.33,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,111.72,230.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M126,246.07c4.43-.25-4.33.45-4.35-.61S126,242.83,127,243s.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,126,246.07Z"
                fill="#2f6840"
              />
              <path
                d="M125.52,245.72c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,125.52,245.72Z"
                fill="#3ba525"
              />
              <path
                d="M126.28,245.69a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,126.28,245.69Z"
                fill="#2f6840"
              />
              <path
                d="M129.75,244.9c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,129.75,244.9Z"
                fill="#2f6840"
              />
              <path
                d="M128.39,248.11a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,128.39,248.11Z"
                fill="#2f6840"
              />
              <path
                d="M126.43,246.15c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,11.51,11.51,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,126.43,246.15Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M112.57,240.5c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,112.57,240.5Z"
                fill="#2f6840"
              />
              <path
                d="M112.07,240.15c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,112.07,240.15Z"
                fill="#3ba525"
              />
              <path
                d="M112.82,240.12a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,112.82,240.12Z"
                fill="#2f6840"
              />
              <path
                d="M116.3,239.33a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,116.3,239.33Z"
                fill="#2f6840"
              />
              <path
                d="M114.93,242.54a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,114.93,242.54Z"
                fill="#2f6840"
              />
              <path
                d="M113,240.58c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,113,240.58Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M95.35,210.59s-1.38,4.1-4,5.12-7-1.05-6.07,1.06-4.59,3.9-7.11,3.65-8.59-4.69-8.79-6.34S95.35,210.59,95.35,210.59Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M95,207.45l.36,3.14-4.15,3.87-6,.69-1.09,2.5s-3.85,2.51-6.9.79a22.46,22.46,0,0,1-5.65-5.11l-.36-3.15Z"
              fill="#ccae79"
            />
            <path
              d="M89.88,206,95,207.45l-4.49,3.9-5.73.66-1.58,2.62s-5.4,2.31-6.32.73-5.67-5.18-5.67-5.18l4.21-2.55Z"
              fill="#ffedc8"
            />
            <polygon
              points="90.5 211.35 91.2 214.46 85.2 215.15 84.77 212.01 90.5 211.35"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M78.39,215.91s-.58,3,.35,3.07a13.86,13.86,0,0,1-7.18-5.65l-.36-3.15S77.08,216.08,78.39,215.91Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M82.2,215l-1.11.36s.68-.28.7,1.07A3.19,3.19,0,0,1,82.2,215Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M79.67,215.79a8.25,8.25,0,0,1-1.39-.88,6.77,6.77,0,0,1-1.7-2s2.82,2.45,2.28,2.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M92.36,209.73a18.15,18.15,0,0,0,.27,2.27s-.12-1.72-.63-1.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M83,206.76l-2.28.26c-.17,0,1.78-.21,2.39.75l-.12-1"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M92.42,206.7l-1.27-.37s.73.34.47.46-1.25.71-1.71.55a1.76,1.76,0,0,0-1.14.18Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M36.16,205.8s1.85,3.55,4.37,4.11,6.25-2,5.7.07,4.76,2.9,7,2.3,7.18-5.54,7.12-7.08S36.16,205.8,36.16,205.8Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M36,202.88l.13,2.92,4.36,2.93,5.58-.24,1.36,2.12s3.89,1.74,6.42-.28a20.83,20.83,0,0,0,4.42-5.5l-.13-2.93Z"
              fill="#ccae79"
            />
            <path
              d="M40.48,200.78,36,202.88l4.67,2.9,5.33-.23,1.83,2.17s5.28,1.32,5.89-.26,4.42-5.56,4.42-5.56L54,200.19Z"
              fill="#ffedc8"
            />
            <polygon
              points="40.7 205.78 40.52 208.73 46.1 208.49 46.03 205.55 40.7 205.78"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M52.43,208.19s1,2.65.13,2.85a12.84,12.84,0,0,0,5.74-6.21l-.13-2.93S53.66,208.15,52.43,208.19Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M48.82,207.93l1.07.17s-.67-.16-.49,1.07A2.89,2.89,0,0,0,48.82,207.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M51.25,208.26c-.12,0,.21,0,1.14-1a6.39,6.39,0,0,0,1.27-2s-2.22,2.65-1.66,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M38.76,204.58a17.21,17.21,0,0,1,.09,2.11s-.15-1.59.29-1.88Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M46.9,200.5l2.12-.1c.16,0-1.67.07-2.08,1l0-.94"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M38.27,201.82l1.11-.52s-.62.41-.37.49,1.25.46,1.65.24a1.6,1.6,0,0,1,1.06,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M13.8,184.51l5.94,3.69a1.93,1.93,0,0,0,1.81.12L35.8,182a1.93,1.93,0,0,0,.48-3.22h0a1.92,1.92,0,0,0-1.52-.46L14.57,181A1.93,1.93,0,0,0,13.8,184.51Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="24.34 169.77 16.3 171.47 9.22 176.91 21.09 181.67 35.62 175.72 24.34 169.77"
              fill="#ffedc8"
            />
            <polygon
              points="9.22 176.91 9.22 181.67 20.61 186.55 35.94 180.33 35.62 175.72 21.09 181.67 9.22 176.91"
              fill="#ccae79"
            />
            <polygon
              points="21.09 181.67 20.61 186.55 35.94 180.33 35.62 175.72 21.09 181.67"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M12.61,178.27a2.14,2.14,0,0,1,0,2.44c.54-.76.66-2.18.91-2.08Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M17.62,180.28a6.74,6.74,0,0,0,3-3.05l-2.15,3.38Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M27.09,179.21a2.18,2.18,0,0,1,1.18,1.92l-.35-2.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M32.4,174c-.15-.08-3,.58-4.72,0a6.7,6.7,0,0,1-3.43.24s2.52-.25,3.43.61A20.53,20.53,0,0,1,32.4,174Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M3.74,202.8l4.86,3a1.59,1.59,0,0,0,1.47.1l11.65-5.21a1.57,1.57,0,0,0,.39-2.63h0a1.55,1.55,0,0,0-1.24-.37l-16.5,2.19A1.58,1.58,0,0,0,3.74,202.8Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="12.36 190.74 5.79 192.14 0 196.58 9.7 200.47 21.58 195.61 12.36 190.74"
              fill="#ffedc8"
            />
            <polygon
              points="0 196.58 0 200.47 9.31 204.46 21.83 199.38 21.58 195.61 9.7 200.47 0 196.58"
              fill="#ccae79"
            />
            <polygon
              points="9.7 200.47 9.31 204.46 21.83 199.38 21.58 195.61 9.7 200.47"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M2.77,197.69a1.77,1.77,0,0,1,0,2c.44-.63.54-1.78.74-1.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M6.86,199.33a5.5,5.5,0,0,0,2.45-2.48l-1.76,2.76Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M14.6,198.46a1.81,1.81,0,0,1,1,1.57l-.29-1.84Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M18.94,194.22c-.12-.07-2.45.47-3.85,0a5.63,5.63,0,0,1-2.81.2s2.06-.21,2.81.5A16.61,16.61,0,0,1,18.94,194.22Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M20,216.88l4.85,3a1.54,1.54,0,0,0,1.47.1L38,214.78a1.58,1.58,0,0,0,.39-2.63h0a1.62,1.62,0,0,0-1.25-.37L20.59,214A1.57,1.57,0,0,0,20,216.88Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="28.58 204.83 22.01 206.22 16.22 210.67 25.92 214.56 37.8 209.69 28.58 204.83"
              fill="#ffedc8"
            />
            <polygon
              points="16.22 210.67 16.22 214.56 25.53 218.54 38.06 213.46 37.8 209.69 25.92 214.56 16.22 210.67"
              fill="#ccae79"
            />
            <polygon
              points="25.92 214.56 25.53 218.54 38.06 213.46 37.8 209.69 25.92 214.56"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M19,211.78a1.74,1.74,0,0,1,0,2c.44-.62.54-1.78.74-1.69Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M23.08,213.42a5.56,5.56,0,0,0,2.45-2.49l-1.76,2.76Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M30.83,212.55a1.77,1.77,0,0,1,1,1.57l-.29-1.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M35.17,208.3c-.13-.06-2.46.48-3.86,0a5.5,5.5,0,0,1-2.81.2s2.06-.2,2.81.5A16.75,16.75,0,0,1,35.17,208.3Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M36.94,222l2.7,1.68a.88.88,0,0,0,.82,0l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.86.86,0,0,0-.69-.2l-9.19,1.22A.88.88,0,0,0,36.94,222Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="41.73 215.29 38.08 216.06 34.85 218.54 40.26 220.7 46.87 218 41.73 215.29"
              fill="#ffedc8"
            />
            <polygon
              points="34.85 218.54 34.85 220.7 40.04 222.93 47.01 220.09 46.87 218 40.26 220.7 34.85 218.54"
              fill="#ccae79"
            />
            <polygon
              points="40.26 220.7 40.04 222.93 47.01 220.09 46.87 218 40.26 220.7"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M36.4,219.16a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M38.67,220.07A3.08,3.08,0,0,0,40,218.69l-1,1.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M43,219.58a1,1,0,0,1,.53.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M45.4,217.22a6.27,6.27,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.11,1.57.28A9.49,9.49,0,0,1,45.4,217.22Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M116.94,239.52l2.7,1.68a.88.88,0,0,0,.82.05l6.49-2.9a.87.87,0,0,0,.22-1.46h0a.87.87,0,0,0-.69-.21l-9.19,1.22A.88.88,0,0,0,116.94,239.52Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="121.73 232.81 118.08 233.59 114.85 236.06 120.25 238.23 126.87 235.52 121.73 232.81"
              fill="#ffedc8"
            />
            <polygon
              points="114.85 236.06 114.85 238.23 120.04 240.45 127.01 237.62 126.87 235.52 120.25 238.23 114.85 236.06"
              fill="#ccae79"
            />
            <polygon
              points="120.25 238.23 120.04 240.45 127.01 237.62 126.87 235.52 120.25 238.23"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M116.4,236.68a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-.94Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M118.67,237.59a3.08,3.08,0,0,0,1.37-1.38l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M123,237.11a1,1,0,0,1,.53.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M125.4,234.75a6.56,6.56,0,0,1-2.14,0,3,3,0,0,1-1.57.1s1.15-.11,1.57.29A8.93,8.93,0,0,1,125.4,234.75Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M121.63,230.21l2.71,1.68a.88.88,0,0,0,.82.05l6.49-2.9a.87.87,0,0,0,.21-1.46h0a.87.87,0,0,0-.69-.21L122,228.59A.88.88,0,0,0,121.63,230.21Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="126.43 223.5 122.77 224.27 119.55 226.75 124.95 228.91 131.56 226.21 126.43 223.5"
              fill="#ffedc8"
            />
            <polygon
              points="119.55 226.75 119.55 228.91 124.73 231.14 131.71 228.31 131.56 226.21 124.95 228.91 119.55 226.75"
              fill="#ccae79"
            />
            <polygon
              points="124.95 228.91 124.73 231.14 131.71 228.31 131.56 226.21 124.95 228.91"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M121.09,227.37a1,1,0,0,1,0,1.11c.25-.35.3-1,.42-.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M123.37,228.28a3,3,0,0,0,1.36-1.38l-1,1.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M127.68,227.8a1,1,0,0,1,.54.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M130.1,225.43a6.08,6.08,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9.54,9.54,0,0,1,130.1,225.43Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M219.37,241.15l3.75,2.33a1.24,1.24,0,0,0,1.14.08l9-4a1.22,1.22,0,0,0,.31-2h0a1.25,1.25,0,0,0-1-.28l-12.77,1.69A1.22,1.22,0,0,0,219.37,241.15Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="226.03 231.83 220.95 232.91 216.48 236.35 223.98 239.35 233.16 235.59 226.03 231.83"
              fill="#ffedc8"
            />
            <polygon
              points="216.48 236.35 216.48 239.35 223.67 242.44 233.36 238.51 233.16 235.59 223.98 239.35 216.48 236.35"
              fill="#ccae79"
            />
            <polygon
              points="223.98 239.35 223.67 242.44 233.36 238.51 233.16 235.59 223.98 239.35"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M218.62,237.21a1.35,1.35,0,0,1,0,1.54c.34-.49.41-1.38.57-1.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M221.78,238.47a4.24,4.24,0,0,0,1.89-1.92l-1.36,2.14Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M227.77,237.8a1.39,1.39,0,0,1,.75,1.21l-.23-1.42Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M231.12,234.52a9,9,0,0,1-3,0,4.26,4.26,0,0,1-2.17.15s1.6-.15,2.17.39A13.15,13.15,0,0,1,231.12,234.52Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M243.52,245.86l4.24,2.64a1.39,1.39,0,0,0,1.3.08l10.2-4.55a1.39,1.39,0,0,0,.34-2.31h0a1.36,1.36,0,0,0-1.09-.32l-14.45,1.92A1.38,1.38,0,0,0,243.52,245.86Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="251.06 235.31 245.31 236.53 240.24 240.42 248.73 243.83 259.13 239.57 251.06 235.31"
              fill="#ffedc8"
            />
            <polygon
              points="240.24 240.42 240.24 243.83 248.39 247.32 259.35 242.87 259.13 239.57 248.73 243.83 240.24 240.42"
              fill="#ccae79"
            />
            <polygon
              points="248.73 243.83 248.39 247.32 259.35 242.87 259.13 239.57 248.73 243.83"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M242.66,241.39a1.53,1.53,0,0,1,0,1.75c.39-.55.48-1.56.65-1.49Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M246.25,242.83a4.88,4.88,0,0,0,2.14-2.18l-1.54,2.42Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M253,242.07a1.58,1.58,0,0,1,.85,1.37l-.25-1.62Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M256.82,238.35a9.67,9.67,0,0,1-3.37,0,4.86,4.86,0,0,1-2.46.17s1.8-.17,2.46.45A14.45,14.45,0,0,1,256.82,238.35Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M271.83,276.56l3.95,2.45a1.31,1.31,0,0,0,1.2.08l9.48-4.24a1.29,1.29,0,0,0,.32-2.14h0a1.29,1.29,0,0,0-1-.3l-13.43,1.78A1.29,1.29,0,0,0,271.83,276.56Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="278.84 266.75 273.49 267.88 268.78 271.5 276.67 274.66 286.34 270.71 278.84 266.75"
              fill="#ffedc8"
            />
            <polygon
              points="268.78 271.5 268.78 274.66 276.36 277.91 286.55 273.77 286.34 270.71 276.67 274.66 268.78 271.5"
              fill="#ccae79"
            />
            <polygon
              points="276.67 274.66 276.36 277.91 286.55 273.77 286.34 270.71 276.67 274.66"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M271,272.4a1.43,1.43,0,0,1,0,1.63c.35-.51.44-1.45.6-1.38Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M274.37,273.74a4.48,4.48,0,0,0,2-2L274.92,274Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M280.66,273a1.45,1.45,0,0,1,.79,1.28l-.23-1.51Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M284.2,269.58a9.7,9.7,0,0,1-3.14,0,4.53,4.53,0,0,1-2.29.16s1.68-.17,2.29.41A13.29,13.29,0,0,1,284.2,269.58Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M276.3,293.1l4.52,2.81a1.47,1.47,0,0,0,1.38.09l10.85-4.85a1.47,1.47,0,0,0,.36-2.45h0a1.52,1.52,0,0,0-1.16-.35l-15.37,2A1.47,1.47,0,0,0,276.3,293.1Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="284.32 281.88 278.21 283.18 272.82 287.32 281.85 290.94 292.91 286.41 284.32 281.88"
              fill="#ffedc8"
            />
            <polygon
              points="272.82 287.32 272.82 290.94 281.48 294.65 293.15 289.92 292.91 286.41 281.85 290.94 272.82 287.32"
              fill="#ccae79"
            />
            <polygon
              points="281.85 290.94 281.48 294.65 293.15 289.92 292.91 286.41 281.85 290.94"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M275.39,288.35a1.63,1.63,0,0,1,0,1.86c.41-.58.51-1.66.7-1.58Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M279.21,289.88a5.15,5.15,0,0,0,2.27-2.31l-1.63,2.57Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M286.42,289.07a1.67,1.67,0,0,1,.9,1.46l-.27-1.72Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M290.46,285.12c-.12-.06-2.29.44-3.59,0a5.15,5.15,0,0,1-2.62.18s1.92-.19,2.62.47A15.19,15.19,0,0,1,290.46,285.12Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M296.27,299.61l4.41,2.74a1.44,1.44,0,0,0,1.35.1l10.61-4.75a1.43,1.43,0,0,0,.35-2.39h0a1.41,1.41,0,0,0-1.13-.34l-15,2A1.43,1.43,0,0,0,296.27,299.61Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="304.11 288.64 298.13 289.91 292.86 293.95 301.69 297.5 312.5 293.07 304.11 288.64"
              fill="#ffedc8"
            />
            <polygon
              points="292.86 293.95 292.86 297.5 301.33 301.13 312.74 296.5 312.5 293.07 301.69 297.5 292.86 293.95"
              fill="#ccae79"
            />
            <polygon
              points="301.69 297.5 301.33 301.13 312.74 296.5 312.5 293.07 301.69 297.5"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M295.38,295a1.59,1.59,0,0,1,0,1.81c.4-.57.49-1.62.67-1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M299.1,296.46a5,5,0,0,0,2.23-2.26l-1.6,2.51Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M306.15,295.67a1.61,1.61,0,0,1,.88,1.43l-.26-1.69Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M310.1,291.8c-.11-.06-2.23.43-3.5,0A5,5,0,0,1,304,292s1.87-.18,2.56.46A15.35,15.35,0,0,1,310.1,291.8Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M308.93,307.41l2.7,1.68a.88.88,0,0,0,.82.05l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.89.89,0,0,0-.7-.2l-9.19,1.22A.88.88,0,0,0,308.93,307.41Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="313.72 300.7 310.06 301.47 306.84 303.95 312.24 306.11 318.86 303.4 313.72 300.7"
              fill="#ffedc8"
            />
            <polygon
              points="306.84 303.95 306.84 306.11 312.02 308.33 319 305.5 318.86 303.4 312.24 306.11 306.84 303.95"
              fill="#ccae79"
            />
            <polygon
              points="312.24 306.11 312.02 308.33 319 305.5 318.86 303.4 312.24 306.11"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M308.38,304.57a1,1,0,0,1,0,1.11c.25-.35.3-1,.42-.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M310.66,305.48A3,3,0,0,0,312,304.1l-1,1.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M315,305a1,1,0,0,1,.54.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M317.39,302.63a6.33,6.33,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9.54,9.54,0,0,1,317.39,302.63Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M102.5,234.47l2.7,1.68a.88.88,0,0,0,.82,0l6.49-2.9a.87.87,0,0,0,.22-1.46h0a.87.87,0,0,0-.69-.21l-9.19,1.22A.88.88,0,0,0,102.5,234.47Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="107.29 227.76 103.64 228.53 100.41 231.01 105.81 233.18 112.43 230.47 107.29 227.76"
              fill="#ffedc8"
            />
            <polygon
              points="100.41 231.01 100.41 233.18 105.6 235.4 112.57 232.56 112.43 230.47 105.81 233.18 100.41 231.01"
              fill="#ccae79"
            />
            <polygon
              points="105.81 233.18 105.6 235.4 112.57 232.56 112.43 230.47 105.81 233.18"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M102,231.63a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M104.23,232.54a3.08,3.08,0,0,0,1.37-1.38l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M108.55,232.06a1,1,0,0,1,.53.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M111,229.69a6,6,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.11,1.57.28A9.49,9.49,0,0,1,111,229.69Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M55.91,221.1l4,2.48a1.27,1.27,0,0,0,1.21.08l9.61-4.29a1.31,1.31,0,0,0,.33-2.17h0a1.3,1.3,0,0,0-1-.31L56.43,218.7A1.3,1.3,0,0,0,55.91,221.1Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="63.02 211.16 57.6 212.3 52.83 215.97 60.83 219.18 70.62 215.17 63.02 211.16"
              fill="#ffedc8"
            />
            <polygon
              points="52.83 215.97 52.83 219.18 60.5 222.47 70.83 218.28 70.62 215.17 60.83 219.18 52.83 215.97"
              fill="#ccae79"
            />
            <polygon
              points="60.83 219.18 60.5 222.47 70.83 218.28 70.62 215.17 60.83 219.18"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M55.11,216.89a1.43,1.43,0,0,1,0,1.64c.36-.51.44-1.46.61-1.4Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M58.48,218.24a4.56,4.56,0,0,0,2-2.05l-1.45,2.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M64.87,217.52a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M68.45,214a9.37,9.37,0,0,1-3.18,0,4.51,4.51,0,0,1-2.32.16s1.7-.16,2.32.42A13.87,13.87,0,0,1,68.45,214Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M281.43,135.32c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.08-2.36A14.65,14.65,0,0,1,281.43,135.32Z"
                fill="#2f6840"
              />
              <path
                d="M280.93,135c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,280.93,135Z"
                fill="#3ba525"
              />
              <path
                d="M281.68,134.94a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,281.68,134.94Z"
                fill="#2f6840"
              />
              <path
                d="M285.16,134.15a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,285.16,134.15Z"
                fill="#2f6840"
              />
              <path
                d="M283.79,137.36a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,283.79,137.36Z"
                fill="#2f6840"
              />
              <path
                d="M281.83,135.4c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,281.83,135.4Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M278.77,144.05c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,278.77,144.05Z"
                fill="#2f6840"
              />
              <path
                d="M278.27,143.7c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,278.27,143.7Z"
                fill="#3ba525"
              />
              <path
                d="M279,143.67a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,279,143.67Z"
                fill="#2f6840"
              />
              <path
                d="M282.5,142.88a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,282.5,142.88Z"
                fill="#2f6840"
              />
              <path
                d="M281.13,146.09a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,281.13,146.09Z"
                fill="#2f6840"
              />
              <path
                d="M279.17,144.13c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,279.17,144.13Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M273.42,139.09c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71S274,140,274,140s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,273.42,139.09Z"
                fill="#2f6840"
              />
              <path
                d="M272.91,138.74c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,272.91,138.74Z"
                fill="#3ba525"
              />
              <path
                d="M273.67,138.71a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,273.67,138.71Z"
                fill="#2f6840"
              />
              <path
                d="M277.14,137.92c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,277.14,137.92Z"
                fill="#2f6840"
              />
              <path
                d="M275.78,141.13a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,275.78,141.13Z"
                fill="#2f6840"
              />
              <path
                d="M273.82,139.17c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,273.82,139.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M265.08,135.72c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,265.08,135.72Z"
                fill="#2f6840"
              />
              <path
                d="M264.57,135.37c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,264.57,135.37Z"
                fill="#3ba525"
              />
              <path
                d="M265.32,135.34a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,265.32,135.34Z"
                fill="#2f6840"
              />
              <path
                d="M268.8,134.55a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.45,10.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,268.8,134.55Z"
                fill="#2f6840"
              />
              <path
                d="M267.43,137.76a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,267.43,137.76Z"
                fill="#2f6840"
              />
              <path
                d="M265.48,135.8c-.25.06-.48.09-.7.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,265.48,135.8Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M279.78,151.21c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,279.78,151.21Z"
                fill="#2f6840"
              />
              <path
                d="M279.28,150.86c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,279.28,150.86Z"
                fill="#3ba525"
              />
              <path
                d="M280,150.83a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,280,150.83Z"
                fill="#2f6840"
              />
              <path
                d="M283.51,150a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53A2.4,2.4,0,0,1,282,150,2.07,2.07,0,0,1,283.51,150Z"
                fill="#2f6840"
              />
              <path
                d="M282.14,153.25a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,282.14,153.25Z"
                fill="#2f6840"
              />
              <path
                d="M280.18,151.29c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,280.18,151.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M266.33,145.64c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,266.33,145.64Z"
                fill="#2f6840"
              />
              <path
                d="M265.82,145.29c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,265.82,145.29Z"
                fill="#3ba525"
              />
              <path
                d="M266.57,145.26a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74A2.34,2.34,0,0,1,266,144a1.71,1.71,0,0,1,.47.53A1,1,0,0,1,266.57,145.26Z"
                fill="#2f6840"
              />
              <path
                d="M270.05,144.47a5.21,5.21,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,270.05,144.47Z"
                fill="#2f6840"
              />
              <path
                d="M268.68,147.68a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,268.68,147.68Z"
                fill="#2f6840"
              />
              <path
                d="M266.72,145.72c-.24.06-.47.09-.69.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,266.72,145.72Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M253.06,132.86c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,253.06,132.86Z"
                fill="#2f6840"
              />
              <path
                d="M252.55,132.52c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,252.55,132.52Z"
                fill="#3ba525"
              />
              <path
                d="M253.3,132.49a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,253.3,132.49Z"
                fill="#2f6840"
              />
              <path
                d="M256.78,131.69c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,256.78,131.69Z"
                fill="#2f6840"
              />
              <path
                d="M255.41,134.9a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,255.41,134.9Z"
                fill="#2f6840"
              />
              <path
                d="M253.45,133c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,253.45,133Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M250.4,141.59c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,250.4,141.59Z"
                fill="#2f6840"
              />
              <path
                d="M249.89,141.25c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,249.89,141.25Z"
                fill="#3ba525"
              />
              <path
                d="M250.64,141.22a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,250.64,141.22Z"
                fill="#2f6840"
              />
              <path
                d="M254.12,140.42c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,254.12,140.42Z"
                fill="#2f6840"
              />
              <path
                d="M252.75,143.63a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,252.75,143.63Z"
                fill="#2f6840"
              />
              <path
                d="M250.8,141.68c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,250.8,141.68Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M245,136.63c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,245,136.63Z"
                fill="#2f6840"
              />
              <path
                d="M244.54,136.29c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,244.54,136.29Z"
                fill="#3ba525"
              />
              <path
                d="M245.29,136.26a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,245.29,136.26Z"
                fill="#2f6840"
              />
              <path
                d="M248.77,135.47c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,248.77,135.47Z"
                fill="#2f6840"
              />
              <path
                d="M247.4,138.68a1.94,1.94,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,247.4,138.68Z"
                fill="#2f6840"
              />
              <path
                d="M245.44,136.72c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,245.44,136.72Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M236.7,133.26c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,236.7,133.26Z"
                fill="#2f6840"
              />
              <path
                d="M236.2,132.92c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,236.2,132.92Z"
                fill="#3ba525"
              />
              <path
                d="M237,132.89a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,2,2,0,0,1,.47.53A1,1,0,0,1,237,132.89Z"
                fill="#2f6840"
              />
              <path
                d="M240.43,132.09c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,240.43,132.09Z"
                fill="#2f6840"
              />
              <path
                d="M239.06,135.3a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,239.06,135.3Z"
                fill="#2f6840"
              />
              <path
                d="M237.1,133.35c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,237.1,133.35Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M251.41,148.75c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,251.41,148.75Z"
                fill="#2f6840"
              />
              <path
                d="M250.9,148.41c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,250.9,148.41Z"
                fill="#3ba525"
              />
              <path
                d="M251.65,148.38a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,251.65,148.38Z"
                fill="#2f6840"
              />
              <path
                d="M255.13,147.58c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,255.13,147.58Z"
                fill="#2f6840"
              />
              <path
                d="M253.76,150.79a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,253.76,150.79Z"
                fill="#2f6840"
              />
              <path
                d="M251.81,148.84c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2.07,2.07,0,0,1,251.81,148.84Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M238,143.18c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,238,143.18Z"
                fill="#2f6840"
              />
              <path
                d="M237.44,142.84c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,237.44,142.84Z"
                fill="#3ba525"
              />
              <path
                d="M238.2,142.81a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,238.2,142.81Z"
                fill="#2f6840"
              />
              <path
                d="M241.67,142c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,241.67,142Z"
                fill="#2f6840"
              />
              <path
                d="M240.31,145.22a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,240.31,145.22Z"
                fill="#2f6840"
              />
              <path
                d="M238.35,143.27c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,238.35,143.27Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M224.58,131.77c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,224.58,131.77Z"
                fill="#2f6840"
              />
              <path
                d="M224.08,131.43c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,224.08,131.43Z"
                fill="#3ba525"
              />
              <path
                d="M224.83,131.4a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,224.83,131.4Z"
                fill="#2f6840"
              />
              <path
                d="M228.31,130.6c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,228.31,130.6Z"
                fill="#2f6840"
              />
              <path
                d="M226.94,133.81a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,226.94,133.81Z"
                fill="#2f6840"
              />
              <path
                d="M225,131.86c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,225,131.86Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M221.92,140.5c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44S224,141,224,141s6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,221.92,140.5Z"
                fill="#2f6840"
              />
              <path
                d="M221.42,140.16c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71S222,141,222,141s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,221.42,140.16Z"
                fill="#3ba525"
              />
              <path
                d="M222.17,140.13a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,222.17,140.13Z"
                fill="#2f6840"
              />
              <path
                d="M225.65,139.33c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,225.65,139.33Z"
                fill="#2f6840"
              />
              <path
                d="M224.28,142.54a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,224.28,142.54Z"
                fill="#2f6840"
              />
              <path
                d="M222.32,140.59c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,222.32,140.59Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M216.57,135.54c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,216.57,135.54Z"
                fill="#2f6840"
              />
              <path
                d="M216.06,135.2c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,216.06,135.2Z"
                fill="#3ba525"
              />
              <path
                d="M216.82,135.17a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,216.82,135.17Z"
                fill="#2f6840"
              />
              <path
                d="M220.29,134.38c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,220.29,134.38Z"
                fill="#2f6840"
              />
              <path
                d="M218.93,137.59a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,218.93,137.59Z"
                fill="#2f6840"
              />
              <path
                d="M217,135.63c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,217,135.63Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M208.23,132.17c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,208.23,132.17Z"
                fill="#2f6840"
              />
              <path
                d="M207.72,131.83c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,207.72,131.83Z"
                fill="#3ba525"
              />
              <path
                d="M208.47,131.8a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,208.47,131.8Z"
                fill="#2f6840"
              />
              <path
                d="M212,131c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,212,131Z"
                fill="#2f6840"
              />
              <path
                d="M210.58,134.21a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,210.58,134.21Z"
                fill="#2f6840"
              />
              <path
                d="M208.63,132.26c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,208.63,132.26Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M222.93,147.66c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,222.93,147.66Z"
                fill="#2f6840"
              />
              <path
                d="M222.43,147.32c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,222.43,147.32Z"
                fill="#3ba525"
              />
              <path
                d="M223.18,147.29a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,223.18,147.29Z"
                fill="#2f6840"
              />
              <path
                d="M226.66,146.49c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,226.66,146.49Z"
                fill="#2f6840"
              />
              <path
                d="M225.29,149.7a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,225.29,149.7Z"
                fill="#2f6840"
              />
              <path
                d="M223.33,147.75c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,223.33,147.75Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M209.48,142.09c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71S210,143,210,143s-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,209.48,142.09Z"
                fill="#2f6840"
              />
              <path
                d="M209,141.75c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,209,141.75Z"
                fill="#3ba525"
              />
              <path
                d="M209.72,141.72a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,209.72,141.72Z"
                fill="#2f6840"
              />
              <path
                d="M213.2,140.92c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,213.2,140.92Z"
                fill="#2f6840"
              />
              <path
                d="M211.83,144.13a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,211.83,144.13Z"
                fill="#2f6840"
              />
              <path
                d="M209.87,142.18c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,209.87,142.18Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M196.18,133.57c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,196.18,133.57Z"
                fill="#2f6840"
              />
              <path
                d="M195.67,133.23c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,195.67,133.23Z"
                fill="#3ba525"
              />
              <path
                d="M196.43,133.2a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,196.43,133.2Z"
                fill="#2f6840"
              />
              <path
                d="M199.91,132.41c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.1,2.1,0,0,1,199.91,132.41Z"
                fill="#2f6840"
              />
              <path
                d="M198.54,135.62a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,198.54,135.62Z"
                fill="#2f6840"
              />
              <path
                d="M196.58,133.66c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,196.58,133.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M193.52,142.3c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,193.52,142.3Z"
                fill="#2f6840"
              />
              <path
                d="M193,142c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,193,142Z"
                fill="#3ba525"
              />
              <path
                d="M193.77,141.93a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,193.77,141.93Z"
                fill="#2f6840"
              />
              <path
                d="M197.25,141.14c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,197.25,141.14Z"
                fill="#2f6840"
              />
              <path
                d="M195.88,144.35a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,195.88,144.35Z"
                fill="#2f6840"
              />
              <path
                d="M193.92,142.39c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,193.92,142.39Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M188.17,137.35c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,188.17,137.35Z"
                fill="#2f6840"
              />
              <path
                d="M187.66,137c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,187.66,137Z"
                fill="#3ba525"
              />
              <path
                d="M188.42,137a2.21,2.21,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,188.42,137Z"
                fill="#2f6840"
              />
              <path
                d="M191.89,136.18a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,191.89,136.18Z"
                fill="#2f6840"
              />
              <path
                d="M190.53,139.39a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,190.53,139.39Z"
                fill="#2f6840"
              />
              <path
                d="M188.57,137.43c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.68,10.68,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,188.57,137.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M179.83,134c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,179.83,134Z"
                fill="#2f6840"
              />
              <path
                d="M179.32,133.63c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,179.32,133.63Z"
                fill="#3ba525"
              />
              <path
                d="M180.07,133.6a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,180.07,133.6Z"
                fill="#2f6840"
              />
              <path
                d="M183.55,132.81c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,183.55,132.81Z"
                fill="#2f6840"
              />
              <path
                d="M182.18,136a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,182.18,136Z"
                fill="#2f6840"
              />
              <path
                d="M180.22,134.06c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,180.22,134.06Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M194.53,149.46c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,194.53,149.46Z"
                fill="#2f6840"
              />
              <path
                d="M194,149.12c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,194,149.12Z"
                fill="#3ba525"
              />
              <path
                d="M194.78,149.09a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,194.78,149.09Z"
                fill="#2f6840"
              />
              <path
                d="M198.26,148.3c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.1,2.1,0,0,1,198.26,148.3Z"
                fill="#2f6840"
              />
              <path
                d="M196.89,151.51a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,196.89,151.51Z"
                fill="#2f6840"
              />
              <path
                d="M194.93,149.55c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,194.93,149.55Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M181.07,143.89c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,181.07,143.89Z"
                fill="#2f6840"
              />
              <path
                d="M180.57,143.55c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,180.57,143.55Z"
                fill="#3ba525"
              />
              <path
                d="M181.32,143.52a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,181.32,143.52Z"
                fill="#2f6840"
              />
              <path
                d="M184.8,142.73c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,184.8,142.73Z"
                fill="#2f6840"
              />
              <path
                d="M183.43,145.94a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,183.43,145.94Z"
                fill="#2f6840"
              />
              <path
                d="M181.47,144c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,181.47,144Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M168.15,138c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,168.15,138Z"
                fill="#2f6840"
              />
              <path
                d="M167.64,137.62c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,167.64,137.62Z"
                fill="#3ba525"
              />
              <path
                d="M168.39,137.59a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,168.39,137.59Z"
                fill="#2f6840"
              />
              <path
                d="M171.87,136.79c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,171.87,136.79Z"
                fill="#2f6840"
              />
              <path
                d="M170.5,140a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,170.5,140Z"
                fill="#2f6840"
              />
              <path
                d="M168.54,138.05c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,168.54,138.05Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M165.49,146.69c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,165.49,146.69Z"
                fill="#2f6840"
              />
              <path
                d="M165,146.35c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,165,146.35Z"
                fill="#3ba525"
              />
              <path
                d="M165.73,146.32a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,165.73,146.32Z"
                fill="#2f6840"
              />
              <path
                d="M169.21,145.52c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,169.21,145.52Z"
                fill="#2f6840"
              />
              <path
                d="M167.84,148.73a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,167.84,148.73Z"
                fill="#2f6840"
              />
              <path
                d="M165.89,146.78c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,165.89,146.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M160.13,141.73c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,160.13,141.73Z"
                fill="#2f6840"
              />
              <path
                d="M159.63,141.39c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,159.63,141.39Z"
                fill="#3ba525"
              />
              <path
                d="M160.38,141.36a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,160.38,141.36Z"
                fill="#2f6840"
              />
              <path
                d="M163.86,140.57c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,163.86,140.57Z"
                fill="#2f6840"
              />
              <path
                d="M162.49,143.78a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,162.49,143.78Z"
                fill="#2f6840"
              />
              <path
                d="M160.53,141.82c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,160.53,141.82Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M151.79,138.36c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,151.79,138.36Z"
                fill="#2f6840"
              />
              <path
                d="M151.29,138c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,151.29,138Z"
                fill="#3ba525"
              />
              <path
                d="M152,138a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,152,138Z"
                fill="#2f6840"
              />
              <path
                d="M155.52,137.19c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,155.52,137.19Z"
                fill="#2f6840"
              />
              <path
                d="M154.15,140.4a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,154.15,140.4Z"
                fill="#2f6840"
              />
              <path
                d="M152.19,138.45c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,152.19,138.45Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M166.5,153.85c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,166.5,153.85Z"
                fill="#2f6840"
              />
              <path
                d="M166,153.51c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,166,153.51Z"
                fill="#3ba525"
              />
              <path
                d="M166.74,153.48a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,166.74,153.48Z"
                fill="#2f6840"
              />
              <path
                d="M170.22,152.68c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,170.22,152.68Z"
                fill="#2f6840"
              />
              <path
                d="M168.85,155.89a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,168.85,155.89Z"
                fill="#2f6840"
              />
              <path
                d="M166.89,153.94c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,166.89,153.94Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M153,148.28c4.43-.25-4.33.46-4.35-.61S153,145,154,145.22s.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,153,148.28Z"
                fill="#2f6840"
              />
              <path
                d="M152.53,147.94c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,152.53,147.94Z"
                fill="#3ba525"
              />
              <path
                d="M153.29,147.91a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,153.29,147.91Z"
                fill="#2f6840"
              />
              <path
                d="M156.76,147.11c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,156.76,147.11Z"
                fill="#2f6840"
              />
              <path
                d="M155.4,150.32a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,155.4,150.32Z"
                fill="#2f6840"
              />
              <path
                d="M153.44,148.37c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.8,8.8,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,153.44,148.37Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M140.76,145.83c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46S142,145,142,145s1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,140.76,145.83Z"
                fill="#2f6840"
              />
              <path
                d="M140.25,145.48c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16S148,146.07,147,146s-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,140.25,145.48Z"
                fill="#3ba525"
              />
              <path
                d="M141,145.45a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,141,145.45Z"
                fill="#2f6840"
              />
              <path
                d="M144.48,144.66a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12.12,12.12,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,144.48,144.66Z"
                fill="#2f6840"
              />
              <path
                d="M143.11,147.87a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,143.11,147.87Z"
                fill="#2f6840"
              />
              <path
                d="M141.16,145.91c-.25.06-.48.09-.7.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,141.16,145.91Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M138.1,154.56c4.42-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,138.1,154.56Z"
                fill="#2f6840"
              />
              <path
                d="M137.59,154.21c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,137.59,154.21Z"
                fill="#3ba525"
              />
              <path
                d="M138.35,154.18a2.15,2.15,0,0,0-.8-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,138.35,154.18Z"
                fill="#2f6840"
              />
              <path
                d="M141.82,153.39c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.52,2.52,0,0,1,1.24-.86A2.07,2.07,0,0,1,141.82,153.39Z"
                fill="#2f6840"
              />
              <path
                d="M140.45,156.6a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,140.45,156.6Z"
                fill="#2f6840"
              />
              <path
                d="M138.5,154.64c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,138.5,154.64Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M132.75,149.6c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,132.75,149.6Z"
                fill="#2f6840"
              />
              <path
                d="M132.24,149.25c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,132.24,149.25Z"
                fill="#3ba525"
              />
              <path
                d="M133,149.22a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,133,149.22Z"
                fill="#2f6840"
              />
              <path
                d="M136.47,148.43c-.26,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,136.47,148.43Z"
                fill="#2f6840"
              />
              <path
                d="M135.1,151.64a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,135.1,151.64Z"
                fill="#2f6840"
              />
              <path
                d="M133.14,149.68c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,133.14,149.68Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M124.4,146.23c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,124.4,146.23Z"
                fill="#2f6840"
              />
              <path
                d="M123.9,145.88c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,123.9,145.88Z"
                fill="#3ba525"
              />
              <path
                d="M124.65,145.85a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,124.65,145.85Z"
                fill="#2f6840"
              />
              <path
                d="M128.13,145.06a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,128.13,145.06Z"
                fill="#2f6840"
              />
              <path
                d="M126.76,148.27a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,126.76,148.27Z"
                fill="#2f6840"
              />
              <path
                d="M124.8,146.31c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,124.8,146.31Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M139.11,161.72c4.42-.26-4.33.45-4.35-.62s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,139.11,161.72Z"
                fill="#2f6840"
              />
              <path
                d="M138.6,161.37c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,138.6,161.37Z"
                fill="#3ba525"
              />
              <path
                d="M139.35,161.34a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,139.35,161.34Z"
                fill="#2f6840"
              />
              <path
                d="M142.83,160.55c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.52,2.52,0,0,1,1.24-.86A2.07,2.07,0,0,1,142.83,160.55Z"
                fill="#2f6840"
              />
              <path
                d="M141.46,163.76a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,141.46,163.76Z"
                fill="#2f6840"
              />
              <path
                d="M139.51,161.8c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,139.51,161.8Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M125.65,156.15c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,125.65,156.15Z"
                fill="#2f6840"
              />
              <path
                d="M125.15,155.8c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,125.15,155.8Z"
                fill="#3ba525"
              />
              <path
                d="M125.9,155.77a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,125.9,155.77Z"
                fill="#2f6840"
              />
              <path
                d="M129.38,155a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,129.38,155Z"
                fill="#2f6840"
              />
              <path
                d="M128,158.19a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,128,158.19Z"
                fill="#2f6840"
              />
              <path
                d="M126.05,156.23c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,126.05,156.23Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M114.48,156.78c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,114.48,156.78Z"
                fill="#2f6840"
              />
              <path
                d="M114,156.44c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,114,156.44Z"
                fill="#3ba525"
              />
              <path
                d="M114.72,156.41a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,114.72,156.41Z"
                fill="#2f6840"
              />
              <path
                d="M118.2,155.62c-.26,0-.49,0-.72.09a3.77,3.77,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,118.2,155.62Z"
                fill="#2f6840"
              />
              <path
                d="M116.83,158.83a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,116.83,158.83Z"
                fill="#2f6840"
              />
              <path
                d="M114.87,156.87c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,114.87,156.87Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M111.82,165.51c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,111.82,165.51Z"
                fill="#2f6840"
              />
              <path
                d="M111.31,165.17c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,111.31,165.17Z"
                fill="#3ba525"
              />
              <path
                d="M112.06,165.14a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,112.06,165.14Z"
                fill="#2f6840"
              />
              <path
                d="M115.54,164.34c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,115.54,164.34Z"
                fill="#2f6840"
              />
              <path
                d="M114.17,167.55a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,114.17,167.55Z"
                fill="#2f6840"
              />
              <path
                d="M112.21,165.6c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,112.21,165.6Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M106.46,160.55c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,106.46,160.55Z"
                fill="#2f6840"
              />
              <path
                d="M106,160.21c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,106,160.21Z"
                fill="#3ba525"
              />
              <path
                d="M106.71,160.18a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,106.71,160.18Z"
                fill="#2f6840"
              />
              <path
                d="M110.19,159.39c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,110.19,159.39Z"
                fill="#2f6840"
              />
              <path
                d="M108.82,162.6a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,108.82,162.6Z"
                fill="#2f6840"
              />
              <path
                d="M106.86,160.64c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,106.86,160.64Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M98.12,157.18c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,98.12,157.18Z"
                fill="#2f6840"
              />
              <path
                d="M97.62,156.84c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,97.62,156.84Z"
                fill="#3ba525"
              />
              <path
                d="M98.37,156.81a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,98.37,156.81Z"
                fill="#2f6840"
              />
              <path
                d="M101.85,156c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.15,2.15,0,0,1,101.85,156Z"
                fill="#2f6840"
              />
              <path
                d="M100.48,159.22a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,100.48,159.22Z"
                fill="#2f6840"
              />
              <path
                d="M98.52,157.27c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,98.52,157.27Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M112.83,172.67c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,112.83,172.67Z"
                fill="#2f6840"
              />
              <path
                d="M112.32,172.33c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,112.32,172.33Z"
                fill="#3ba525"
              />
              <path
                d="M113.07,172.3a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,113.07,172.3Z"
                fill="#2f6840"
              />
              <path
                d="M116.55,171.5c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,116.55,171.5Z"
                fill="#2f6840"
              />
              <path
                d="M115.18,174.71a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,115.18,174.71Z"
                fill="#2f6840"
              />
              <path
                d="M113.22,172.76c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,113.22,172.76Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M99.37,167.1c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71S99.9,168,99.9,168s-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,99.37,167.1Z"
                fill="#2f6840"
              />
              <path
                d="M98.86,166.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,98.86,166.76Z"
                fill="#3ba525"
              />
              <path
                d="M99.62,166.73a2.17,2.17,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,99.62,166.73Z"
                fill="#2f6840"
              />
              <path
                d="M103.09,165.93c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,103.09,165.93Z"
                fill="#2f6840"
              />
              <path
                d="M101.73,169.14a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,101.73,169.14Z"
                fill="#2f6840"
              />
              <path
                d="M99.77,167.19c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.34,9.34,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,99.77,167.19Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M86.65,162.94c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,86.65,162.94Z"
                fill="#2f6840"
              />
              <path
                d="M86.15,162.59c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,86.15,162.59Z"
                fill="#3ba525"
              />
              <path
                d="M86.9,162.56a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,86.9,162.56Z"
                fill="#2f6840"
              />
              <path
                d="M90.38,161.77a5.58,5.58,0,0,0-.73.1A3,3,0,0,0,89,162a11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,90.38,161.77Z"
                fill="#2f6840"
              />
              <path
                d="M89,165a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,89,165Z"
                fill="#2f6840"
              />
              <path
                d="M87.05,163c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,87.05,163Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M84,171.67c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,84,171.67Z"
                fill="#2f6840"
              />
              <path
                d="M83.49,171.32c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71S84,172.2,84,172.2s-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,83.49,171.32Z"
                fill="#3ba525"
              />
              <path
                d="M84.24,171.29a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,84.24,171.29Z"
                fill="#2f6840"
              />
              <path
                d="M87.72,170.5c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,87.72,170.5Z"
                fill="#2f6840"
              />
              <path
                d="M86.35,173.71a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,86.35,173.71Z"
                fill="#2f6840"
              />
              <path
                d="M84.39,171.75c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,84.39,171.75Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M78.64,166.71c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.08-2.36A14.65,14.65,0,0,1,78.64,166.71Z"
                fill="#2f6840"
              />
              <path
                d="M78.14,166.36c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,78.14,166.36Z"
                fill="#3ba525"
              />
              <path
                d="M78.89,166.33a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,78.89,166.33Z"
                fill="#2f6840"
              />
              <path
                d="M82.37,165.54c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,82.37,165.54Z"
                fill="#2f6840"
              />
              <path
                d="M81,168.75a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,81,168.75Z"
                fill="#2f6840"
              />
              <path
                d="M79,166.79c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,79,166.79Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M70.3,163.34c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,70.3,163.34Z"
                fill="#2f6840"
              />
              <path
                d="M69.79,163c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,69.79,163Z"
                fill="#3ba525"
              />
              <path
                d="M70.55,163a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,70.55,163Z"
                fill="#2f6840"
              />
              <path
                d="M74,162.17a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,74,162.17Z"
                fill="#2f6840"
              />
              <path
                d="M72.66,165.38a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,72.66,165.38Z"
                fill="#2f6840"
              />
              <path
                d="M70.7,163.42c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,70.7,163.42Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M85,178.83c4.43-.26-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,85,178.83Z"
                fill="#2f6840"
              />
              <path
                d="M84.5,178.48c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,84.5,178.48Z"
                fill="#3ba525"
              />
              <path
                d="M85.25,178.45a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,85.25,178.45Z"
                fill="#2f6840"
              />
              <path
                d="M88.73,177.66c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.48,2.48,0,0,1,1.24-.86A2.07,2.07,0,0,1,88.73,177.66Z"
                fill="#2f6840"
              />
              <path
                d="M87.36,180.87a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,87.36,180.87Z"
                fill="#2f6840"
              />
              <path
                d="M85.4,178.91c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,85.4,178.91Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M71.55,173.26c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,71.55,173.26Z"
                fill="#2f6840"
              />
              <path
                d="M71,172.91c4.43-.25-4.33.46-4.35-.61S71,169.67,72,169.85s.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,71,172.91Z"
                fill="#3ba525"
              />
              <path
                d="M71.79,172.88A2.13,2.13,0,0,0,71,172c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,71.79,172.88Z"
                fill="#2f6840"
              />
              <path
                d="M75.27,172.09a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.45,10.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,75.27,172.09Z"
                fill="#2f6840"
              />
              <path
                d="M73.9,175.3a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,73.9,175.3Z"
                fill="#2f6840"
              />
              <path
                d="M72,173.34c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,72,173.34Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M58.19,161.54c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15S65.94,162.12,65,162s-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,58.19,161.54Z"
                fill="#2f6840"
              />
              <path
                d="M57.69,161.19c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,57.69,161.19Z"
                fill="#3ba525"
              />
              <path
                d="M58.44,161.16a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,58.44,161.16Z"
                fill="#2f6840"
              />
              <path
                d="M61.92,160.37c-.26,0-.49,0-.73.1a3,3,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,61.92,160.37Z"
                fill="#2f6840"
              />
              <path
                d="M60.55,163.58a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,60.55,163.58Z"
                fill="#2f6840"
              />
              <path
                d="M58.59,161.62c-.24.06-.47.09-.69.16a4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,58.59,161.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M55.54,170.27c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,55.54,170.27Z"
                fill="#2f6840"
              />
              <path
                d="M55,169.92c4.43-.25-4.33.46-4.35-.61S55,166.68,56,166.86s.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,55,169.92Z"
                fill="#3ba525"
              />
              <path
                d="M55.78,169.89A2.08,2.08,0,0,0,55,169c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,55.78,169.89Z"
                fill="#2f6840"
              />
              <path
                d="M59.26,169.1a5.21,5.21,0,0,0-.72.1,3.08,3.08,0,0,0-.68.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,59.26,169.1Z"
                fill="#2f6840"
              />
              <path
                d="M57.89,172.31a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,57.89,172.31Z"
                fill="#2f6840"
              />
              <path
                d="M55.93,170.35c-.24.06-.47.09-.69.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,55.93,170.35Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M50.18,165.31c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,50.18,165.31Z"
                fill="#2f6840"
              />
              <path
                d="M49.68,165c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S45,166.11,45.13,166A14.56,14.56,0,0,1,49.68,165Z"
                fill="#3ba525"
              />
              <path
                d="M50.43,164.94a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,50.43,164.94Z"
                fill="#2f6840"
              />
              <path
                d="M53.91,164.14c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,53.91,164.14Z"
                fill="#2f6840"
              />
              <path
                d="M52.54,167.35a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,52.54,167.35Z"
                fill="#2f6840"
              />
              <path
                d="M50.58,165.39c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,50.58,165.39Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M41.84,161.94c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25S44.27,158.35,46,159s3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,41.84,161.94Z"
                fill="#2f6840"
              />
              <path
                d="M41.33,161.59c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,41.33,161.59Z"
                fill="#3ba525"
              />
              <path
                d="M42.09,161.56a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,42.09,161.56Z"
                fill="#2f6840"
              />
              <path
                d="M45.56,160.77a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,45.56,160.77Z"
                fill="#2f6840"
              />
              <path
                d="M44.2,164a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,44.2,164Z"
                fill="#2f6840"
              />
              <path
                d="M42.24,162c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,42.24,162Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M56.54,177.43c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,56.54,177.43Z"
                fill="#2f6840"
              />
              <path
                d="M56,177.08c4.43-.25-4.33.46-4.35-.61S56,173.84,57,174s.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,56,177.08Z"
                fill="#3ba525"
              />
              <path
                d="M56.79,177.05a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,56.79,177.05Z"
                fill="#2f6840"
              />
              <path
                d="M60.27,176.26a5.21,5.21,0,0,0-.72.1,3,3,0,0,0-.68.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,60.27,176.26Z"
                fill="#2f6840"
              />
              <path
                d="M58.9,179.47a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,58.9,179.47Z"
                fill="#2f6840"
              />
              <path
                d="M56.94,177.51c-.24.06-.47.09-.69.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,56.94,177.51Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M43.09,171.86c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,43.09,171.86Z"
                fill="#2f6840"
              />
              <path
                d="M42.58,171.51c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,42.58,171.51Z"
                fill="#3ba525"
              />
              <path
                d="M43.34,171.48a2.21,2.21,0,0,0-.8-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,43.34,171.48Z"
                fill="#2f6840"
              />
              <path
                d="M46.81,170.69a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12.94,12.94,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,46.81,170.69Z"
                fill="#2f6840"
              />
              <path
                d="M45.44,173.9a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,45.44,173.9Z"
                fill="#2f6840"
              />
              <path
                d="M43.49,171.94c-.25.06-.48.09-.7.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65A2.24,2.24,0,0,1,42,172,2,2,0,0,1,43.49,171.94Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M79.71,165.74s.72,2.65,2.32,3.4,4.5-.41,3.82.9,2.77,2.65,4.38,2.58,5.64-2.65,5.83-3.7S79.71,165.74,79.71,165.74Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M80.05,163.75l-.34,2,2.49,2.61L86,169l.6,1.63s2.35,1.74,4.35.77a14.45,14.45,0,0,0,3.79-3l.34-2Z"
              fill="#ccae79"
            />
            <path
              d="M83.36,163l-3.31.75,2.71,2.65,3.62.63.91,1.73s3.34,1.67,4,.7,3.79-3.08,3.79-3.08l-2.58-1.78Z"
              fill="#ffedc8"
            />
            <polygon
              points="82.76 166.4 82.2 168.35 85.99 169.01 86.38 167.03 82.76 166.4"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M90.29,169.75s.25,1.93-.34,1.94a8.83,8.83,0,0,0,4.78-3.32l.34-2S91.12,169.91,90.29,169.75Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M87.9,169l.69.28s-.42-.21-.48.64A2,2,0,0,0,87.9,169Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M89.48,169.63c-.07,0,.14,0,.92-.51a4.48,4.48,0,0,0,1.15-1.18s-1.89,1.45-1.56,1.77Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M81.64,165.3a13.73,13.73,0,0,1-.25,1.43s.13-1.09.47-1.22Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M87.71,163.76l1.44.26c.1,0-1.13-.21-1.55.38l.11-.64"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M81.72,163.37l.82-.18s-.48.18-.32.27.77.5,1.07.41A1.09,1.09,0,0,1,84,164Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M253.42,153.33l2.7,1.68a.86.86,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.92.92,0,0,0-.69-.21l-9.2,1.23A.87.87,0,0,0,253.42,153.33Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="258.21 146.62 254.56 147.4 251.33 149.88 256.73 152.04 263.35 149.33 258.21 146.62"
              fill="#ffedc8"
            />
            <polygon
              points="251.33 149.88 251.33 152.04 256.52 154.26 263.49 151.43 263.35 149.33 256.73 152.04 251.33 149.88"
              fill="#ccae79"
            />
            <polygon
              points="256.73 152.04 256.52 154.26 263.49 151.43 263.35 149.33 256.73 152.04"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M252.88,150.49a1,1,0,0,1,0,1.11c.24-.34.3-1,.41-.94Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M255.15,151.41a3.08,3.08,0,0,0,1.37-1.39l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M259.46,150.92a1,1,0,0,1,.54.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M261.88,148.56a6.56,6.56,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.11,1.57.28A8.85,8.85,0,0,1,261.88,148.56Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M247.33,144.48l2.7,1.68a.88.88,0,0,0,.82.05l6.49-2.9a.87.87,0,0,0,.22-1.46h0a.87.87,0,0,0-.69-.21l-9.19,1.22A.88.88,0,0,0,247.33,144.48Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="252.13 137.77 248.47 138.54 245.25 141.02 250.65 143.19 257.26 140.48 252.13 137.77"
              fill="#ffedc8"
            />
            <polygon
              points="245.25 141.02 245.25 143.19 250.43 145.41 257.4 142.58 257.26 140.48 250.65 143.19 245.25 141.02"
              fill="#ccae79"
            />
            <polygon
              points="250.65 143.19 250.43 145.41 257.4 142.58 257.26 140.48 250.65 143.19"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M246.79,141.64a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-.95Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M249.06,142.55a3.08,3.08,0,0,0,1.37-1.38l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M253.38,142.07a1,1,0,0,1,.53.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M255.79,139.7a6,6,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.11,1.57.28A9.49,9.49,0,0,1,255.79,139.7Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M233.9,137.42l2.7,1.68a.88.88,0,0,0,.82.05l6.49-2.9a.87.87,0,0,0,.22-1.46h0a.89.89,0,0,0-.7-.21l-9.19,1.22A.88.88,0,0,0,233.9,137.42Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="238.69 130.71 235.03 131.49 231.81 133.96 237.21 136.13 243.83 133.42 238.69 130.71"
              fill="#ffedc8"
            />
            <polygon
              points="231.81 133.96 231.81 136.13 237 138.35 243.97 135.52 243.83 133.42 237.21 136.13 231.81 133.96"
              fill="#ccae79"
            />
            <polygon
              points="237.21 136.13 237 138.35 243.97 135.52 243.83 133.42 237.21 136.13"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M233.35,134.58a1,1,0,0,1,0,1.11c.25-.35.3-1,.42-.94Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M235.63,135.49a3,3,0,0,0,1.36-1.38l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M239.94,135a1,1,0,0,1,.54.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M242.36,132.64a6.07,6.07,0,0,1-2.15,0,3,3,0,0,1-1.56.11s1.15-.11,1.56.28A9.54,9.54,0,0,1,242.36,132.64Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M234.43,148.19l2.7,1.67a.86.86,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.21-1.47h0a.86.86,0,0,0-.69-.2l-9.19,1.22A.88.88,0,0,0,234.43,148.19Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="239.22 141.47 235.56 142.25 232.34 144.73 237.74 146.89 244.36 144.18 239.22 141.47"
              fill="#ffedc8"
            />
            <polygon
              points="232.34 144.73 232.34 146.89 237.52 149.11 244.5 146.28 244.36 144.18 237.74 146.89 232.34 144.73"
              fill="#ccae79"
            />
            <polygon
              points="237.74 146.89 237.52 149.11 244.5 146.28 244.36 144.18 237.74 146.89"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M233.88,145.34a1,1,0,0,1,0,1.12c.25-.35.3-1,.42-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M236.16,146.26a3,3,0,0,0,1.36-1.39l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M240.47,145.77a1,1,0,0,1,.54.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M242.89,143.41a6.62,6.62,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9,9,0,0,1,242.89,143.41Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M53.54,173.32l2.7,1.68a.88.88,0,0,0,.82.05l6.49-2.9a.87.87,0,0,0,.22-1.46h0a.89.89,0,0,0-.7-.21l-9.19,1.22A.88.88,0,0,0,53.54,173.32Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="58.33 166.61 54.67 167.38 51.45 169.86 56.85 172.02 63.47 169.32 58.33 166.61"
              fill="#ffedc8"
            />
            <polygon
              points="51.45 169.86 51.45 172.02 56.63 174.25 63.61 171.41 63.47 169.32 56.85 172.02 51.45 169.86"
              fill="#ccae79"
            />
            <polygon
              points="56.85 172.02 56.63 174.25 63.61 171.41 63.47 169.32 56.85 172.02"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M53,170.48a1,1,0,0,1,0,1.11c.25-.35.3-1,.42-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M55.27,171.39A3,3,0,0,0,56.63,170l-1,1.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M59.58,170.91a1,1,0,0,1,.54.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M62,168.54a6.07,6.07,0,0,1-2.15,0,3.09,3.09,0,0,1-1.56.11s1.15-.11,1.56.28A9.54,9.54,0,0,1,62,168.54Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M66.49,168.33l2.7,1.68a.92.92,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.87.87,0,0,0-.69-.21l-9.19,1.22A.88.88,0,0,0,66.49,168.33Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="71.28 161.62 67.63 162.4 64.4 164.87 69.8 167.04 76.42 164.33 71.28 161.62"
              fill="#ffedc8"
            />
            <polygon
              points="64.4 164.87 64.4 167.04 69.59 169.26 76.56 166.43 76.42 164.33 69.8 167.04 64.4 164.87"
              fill="#ccae79"
            />
            <polygon
              points="69.8 167.04 69.59 169.26 76.56 166.43 76.42 164.33 69.8 167.04"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M66,165.49a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-.94Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M68.22,166.4A3.08,3.08,0,0,0,69.59,165l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M72.54,165.92a1,1,0,0,1,.53.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M75,163.56a6.56,6.56,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.12,1.57.28A8.93,8.93,0,0,1,75,163.56Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M70.73,175.5l2.7,1.68a.88.88,0,0,0,.82,0l6.49-2.9a.87.87,0,0,0,.22-1.46h0a.87.87,0,0,0-.69-.21l-9.19,1.22A.88.88,0,0,0,70.73,175.5Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="75.53 168.79 71.87 169.57 68.64 172.04 74.04 174.21 80.66 171.5 75.53 168.79"
              fill="#ffedc8"
            />
            <polygon
              points="68.64 172.04 68.64 174.21 73.83 176.43 80.8 173.6 80.66 171.5 74.04 174.21 68.64 172.04"
              fill="#ccae79"
            />
            <polygon
              points="74.04 174.21 73.83 176.43 80.8 173.6 80.66 171.5 74.04 174.21"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M70.19,172.66a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-.94Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M72.46,173.57a3.08,3.08,0,0,0,1.37-1.38l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M76.78,173.09a1,1,0,0,1,.53.87l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M79.19,170.72a6,6,0,0,1-2.14,0,3,3,0,0,1-1.57.11s1.15-.11,1.57.28A9.49,9.49,0,0,1,79.19,170.72Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M125.94,155.89l2,1.24a.66.66,0,0,0,.61.05L133.4,155a.65.65,0,0,0,.16-1.09h0a.64.64,0,0,0-.51-.16l-6.85.91A.66.66,0,0,0,125.94,155.89Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="129.52 150.89 126.79 151.47 124.39 153.31 128.41 154.92 133.34 152.91 129.52 150.89"
              fill="#ffedc8"
            />
            <polygon
              points="124.39 153.31 124.39 154.92 128.25 156.58 133.44 154.47 133.34 152.91 128.41 154.92 124.39 153.31"
              fill="#ccae79"
            />
            <polygon
              points="128.41 154.92 128.25 156.58 133.44 154.47 133.34 152.91 128.41 154.92"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M125.54,153.77a.72.72,0,0,1,0,.83c.18-.26.22-.74.31-.71Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M127.24,154.45a2.3,2.3,0,0,0,1-1l-.73,1.14Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M130.45,154.09a.76.76,0,0,1,.4.65l-.12-.77Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M132.25,152.33a4.75,4.75,0,0,1-1.6,0,2.29,2.29,0,0,1-1.17.08s.86-.08,1.17.21A7,7,0,0,1,132.25,152.33Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M132.88,151l1.5.93a.51.51,0,0,0,.45,0l3.6-1.61a.49.49,0,0,0,.12-.81h0a.5.5,0,0,0-.38-.12l-5.1.68A.49.49,0,0,0,132.88,151Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="135.54 147.26 133.51 147.69 131.72 149.06 134.72 150.26 138.38 148.76 135.54 147.26"
              fill="#ffedc8"
            />
            <polygon
              points="131.72 149.06 131.72 150.26 134.6 151.49 138.46 149.92 138.38 148.76 134.72 150.26 131.72 149.06"
              fill="#ccae79"
            />
            <polygon
              points="134.72 150.26 134.6 151.49 138.46 149.92 138.38 148.76 134.72 150.26"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M132.58,149.4a.56.56,0,0,1,0,.62c.13-.19.16-.55.23-.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M133.84,149.91a1.71,1.71,0,0,0,.76-.77l-.55.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M136.23,149.64a.55.55,0,0,1,.3.48l-.09-.57Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M137.57,148.33a3.44,3.44,0,0,1-1.19,0,1.66,1.66,0,0,1-.87.06s.64-.06.87.16A5.12,5.12,0,0,1,137.57,148.33Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M135.23,145.06l1.5.93a.48.48,0,0,0,.45,0l3.6-1.61a.49.49,0,0,0,.12-.82h0a.48.48,0,0,0-.38-.11l-5.1.68A.48.48,0,0,0,135.23,145.06Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="137.89 141.34 135.86 141.77 134.07 143.15 137.07 144.35 140.73 142.84 137.89 141.34"
              fill="#ffedc8"
            />
            <polygon
              points="134.07 143.15 134.07 144.35 136.95 145.58 140.81 144.01 140.73 142.84 137.07 144.35 134.07 143.15"
              fill="#ccae79"
            />
            <polygon
              points="137.07 144.35 136.95 145.58 140.81 144.01 140.73 142.84 137.07 144.35"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M134.93,143.49a.54.54,0,0,1,0,.62c.13-.2.16-.55.23-.53Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M136.19,144a1.78,1.78,0,0,0,.76-.77l-.55.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M138.58,143.73a.55.55,0,0,1,.3.48l-.09-.57Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M139.92,142.42a3.72,3.72,0,0,1-1.19,0,1.8,1.8,0,0,1-.87.06s.64-.06.87.15A5.51,5.51,0,0,1,139.92,142.42Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M121.25,149.27l2,1.25a.63.63,0,0,0,.61,0l4.83-2.16a.65.65,0,0,0,.16-1.09h0a.64.64,0,0,0-.51-.15l-6.84.91A.65.65,0,0,0,121.25,149.27Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="124.82 144.28 122.09 144.85 119.69 146.7 123.72 148.31 128.64 146.29 124.82 144.28"
              fill="#ffedc8"
            />
            <polygon
              points="119.69 146.7 119.69 148.31 123.55 149.96 128.75 147.85 128.64 146.29 123.72 148.31 119.69 146.7"
              fill="#ccae79"
            />
            <polygon
              points="123.72 148.31 123.55 149.96 128.75 147.85 128.64 146.29 123.72 148.31"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M120.84,147.16a.7.7,0,0,1,0,.82c.18-.26.23-.73.31-.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M122.54,147.84a2.25,2.25,0,0,0,1-1l-.73,1.14Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M125.75,147.48a.72.72,0,0,1,.4.65l-.12-.77Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M127.55,145.72a5,5,0,0,1-1.6,0,2.4,2.4,0,0,1-1.16.08s.85-.09,1.16.21A6.46,6.46,0,0,1,127.55,145.72Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M252.87,135.67l3.63,2.25a1.16,1.16,0,0,0,1.1.07l8.71-3.89a1.18,1.18,0,0,0,.3-2h0a1.22,1.22,0,0,0-.93-.28l-12.35,1.64A1.19,1.19,0,0,0,252.87,135.67Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="259.31 126.65 254.4 127.69 250.07 131.02 257.32 133.93 266.2 130.29 259.31 126.65"
              fill="#ffedc8"
            />
            <polygon
              points="250.07 131.02 250.07 133.93 257.03 136.91 266.4 133.11 266.2 130.29 257.32 133.93 250.07 131.02"
              fill="#ccae79"
            />
            <polygon
              points="257.32 133.93 257.03 136.91 266.4 133.11 266.2 130.29 257.32 133.93"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M252.14,131.85a1.31,1.31,0,0,1,0,1.49c.33-.46.4-1.33.55-1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M255.2,133.08a4.16,4.16,0,0,0,1.83-1.86l-1.32,2.06Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M261,132.43a1.33,1.33,0,0,1,.72,1.17l-.21-1.38Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M264.24,129.25a8.5,8.5,0,0,1-2.89,0,4.13,4.13,0,0,1-2.1.15s1.54-.15,2.1.38A12.2,12.2,0,0,1,264.24,129.25Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M279.21,141.53l3.62,2.26a1.21,1.21,0,0,0,1.11.07l8.71-3.89a1.18,1.18,0,0,0,.29-2h0a1.15,1.15,0,0,0-.92-.28l-12.35,1.64A1.18,1.18,0,0,0,279.21,141.53Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="285.65 132.52 280.74 133.56 276.41 136.89 283.66 139.8 292.54 136.16 285.65 132.52"
              fill="#ffedc8"
            />
            <polygon
              points="276.41 136.89 276.41 139.8 283.37 142.78 292.74 138.98 292.54 136.16 283.66 139.8 276.41 136.89"
              fill="#ccae79"
            />
            <polygon
              points="283.66 139.8 283.37 142.78 292.74 138.98 292.54 136.16 283.66 139.8"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M278.48,137.72a1.31,1.31,0,0,1,0,1.49c.32-.47.4-1.33.55-1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M281.54,138.94a4.1,4.1,0,0,0,1.83-1.85l-1.32,2.06Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M287.33,138.29a1.35,1.35,0,0,1,.72,1.18l-.22-1.38Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M290.57,135.12a8.7,8.7,0,0,1-2.88,0,4.13,4.13,0,0,1-2.1.15s1.54-.15,2.1.37A12.5,12.5,0,0,1,290.57,135.12Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M260.45,146.21l2.48,1.54a.8.8,0,0,0,.75.05l5.94-2.66a.8.8,0,0,0,.2-1.34h0a.8.8,0,0,0-.63-.19l-8.42,1.12A.8.8,0,0,0,260.45,146.21Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="264.85 140.06 261.49 140.77 258.54 143.04 263.49 145.02 269.55 142.54 264.85 140.06"
              fill="#ffedc8"
            />
            <polygon
              points="258.54 143.04 258.54 145.02 263.29 147.06 269.68 144.47 269.55 142.54 263.49 145.02 258.54 143.04"
              fill="#ccae79"
            />
            <polygon
              points="263.49 145.02 263.29 147.06 269.68 144.47 269.55 142.54 263.49 145.02"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M260,143.61a.89.89,0,0,1,0,1c.23-.32.28-.91.38-.87Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M262,144.44a2.8,2.8,0,0,0,1.25-1.26l-.9,1.4Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M266,144a.9.9,0,0,1,.49.8l-.14-.94Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M268.21,141.83a5.58,5.58,0,0,1-2,0,2.77,2.77,0,0,1-1.43.1s1.05-.1,1.43.26A8.56,8.56,0,0,1,268.21,141.83Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M1037.66,34.48l2.7,1.67a.86.86,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.86.86,0,0,0-.69-.2L1038,32.86A.88.88,0,0,0,1037.66,34.48Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1042.45 27.76 1038.8 28.54 1035.57 31.02 1040.97 33.18 1047.59 30.47 1042.45 27.76"
            fill="#ffedc8"
          />
          <polygon
            points="1035.57 31.02 1035.57 33.18 1040.76 35.4 1047.73 32.57 1047.59 30.47 1040.97 33.18 1035.57 31.02"
            fill="#ccae79"
          />
          <polygon
            points="1040.97 33.18 1040.76 35.4 1047.73 32.57 1047.59 30.47 1040.97 33.18"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1037.12,31.63a1,1,0,0,1,0,1.12c.24-.35.3-1,.41-.95Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1039.39,32.55a3.08,3.08,0,0,0,1.37-1.39l-1,1.54Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1043.71,32.06a1,1,0,0,1,.53.88l-.16-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1046.12,29.7a6.56,6.56,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.11,1.57.28A8.93,8.93,0,0,1,1046.12,29.7Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1055.56,24.33l2.7,1.68a.9.9,0,0,0,.83,0l6.48-2.9a.88.88,0,0,0,.22-1.47h0a.86.86,0,0,0-.69-.2l-9.19,1.22A.88.88,0,0,0,1055.56,24.33Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1060.36 17.62 1056.7 18.39 1053.48 20.87 1058.88 23.03 1065.49 20.32 1060.36 17.62"
            fill="#ffedc8"
          />
          <polygon
            points="1053.48 20.87 1053.48 23.03 1058.66 25.25 1065.63 22.42 1065.49 20.32 1058.88 23.03 1053.48 20.87"
            fill="#ccae79"
          />
          <polygon
            points="1058.88 23.03 1058.66 25.25 1065.63 22.42 1065.49 20.32 1058.88 23.03"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1055,21.49a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1057.3,22.4a3.09,3.09,0,0,0,1.36-1.38l-1,1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1061.61,21.91a1,1,0,0,1,.54.88l-.16-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1064,19.55a6.34,6.34,0,0,1-2.15,0,3.13,3.13,0,0,1-1.57.11s1.15-.11,1.57.28A9.54,9.54,0,0,1,1064,19.55Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="M889.3,3.42c4.42-.25-4.33.46-4.36-.61S889.29.18,890.22.36s.27,2.25.27,2.25,1.24-2.78,2.93-2.16S897,4,896.07,3.9s-4.7,0-4.7,0,6,.86,4,1.55S892,7.47,891,7.2s-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,889.3,3.42Z"
              fill="#2f6840"
            />
            <path
              d="M888.79,3.08c4.43-.25-4.33.45-4.35-.61S888.79-.16,889.72,0s.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72S889.32,4,889.32,4s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,888.79,3.08Z"
              fill="#3ba525"
            />
            <path
              d="M889.54,3.05a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,889.54,3.05Z"
              fill="#2f6840"
            />
            <path
              d="M893,2.25c-.26,0-.49,0-.72.1a3.77,3.77,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,893,2.25Z"
              fill="#2f6840"
            />
            <path
              d="M891.65,5.46a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,891.65,5.46Z"
              fill="#2f6840"
            />
            <path
              d="M889.69,3.51c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,889.69,3.51Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M886.64,12.15c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,886.64,12.15Z"
              fill="#2f6840"
            />
            <path
              d="M886.13,11.81c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,886.13,11.81Z"
              fill="#3ba525"
            />
            <path
              d="M886.88,11.78a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.06-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,886.88,11.78Z"
              fill="#2f6840"
            />
            <path
              d="M890.36,11c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,890.36,11Z"
              fill="#2f6840"
            />
            <path
              d="M889,14.19a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,889,14.19Z"
              fill="#2f6840"
            />
            <path
              d="M887,12.24c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,887,12.24Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M881.28,7.19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55S884,11.24,883,11s-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,881.28,7.19Z"
              fill="#2f6840"
            />
            <path
              d="M880.78,6.85c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46S882,6,882,6s1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55S876.05,8,876.23,7.91A14.65,14.65,0,0,1,880.78,6.85Z"
              fill="#3ba525"
            />
            <path
              d="M881.53,6.82a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73A2.26,2.26,0,0,1,881,5.6a1.85,1.85,0,0,1,.47.53A1,1,0,0,1,881.53,6.82Z"
              fill="#2f6840"
            />
            <path
              d="M885,6c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52A2.38,2.38,0,0,1,883.5,6,2.12,2.12,0,0,1,885,6Z"
              fill="#2f6840"
            />
            <path
              d="M883.64,9.23a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,883.64,9.23Z"
              fill="#2f6840"
            />
            <path
              d="M881.68,7.28c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,881.68,7.28Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M872.94,3.82c4.43-.25-4.33.46-4.35-.61S872.94.58,873.87.76s.27,2.25.27,2.25S875.37.23,877.06.85s3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55S868.21,5,868.39,4.88A14.65,14.65,0,0,1,872.94,3.82Z"
              fill="#2f6840"
            />
            <path
              d="M872.44,3.48c4.42-.25-4.33.45-4.36-.61S872.43.24,873.36.41s.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71S873,4.35,873,4.35s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,872.44,3.48Z"
              fill="#3ba525"
            />
            <path
              d="M873.19,3.45a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,873.19,3.45Z"
              fill="#2f6840"
            />
            <path
              d="M876.67,2.65c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,876.67,2.65Z"
              fill="#2f6840"
            />
            <path
              d="M875.3,5.86a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,875.3,5.86Z"
              fill="#2f6840"
            />
            <path
              d="M873.34,3.91c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,873.34,3.91Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M887.65,19.31c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,887.65,19.31Z"
              fill="#2f6840"
            />
            <path
              d="M887.14,19c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,887.14,19Z"
              fill="#3ba525"
            />
            <path
              d="M887.89,18.94a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.06-.74a2.27,2.27,0,0,1,1.28.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,887.89,18.94Z"
              fill="#2f6840"
            />
            <path
              d="M891.37,18.14c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,891.37,18.14Z"
              fill="#2f6840"
            />
            <path
              d="M890,21.35a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,890,21.35Z"
              fill="#2f6840"
            />
            <path
              d="M888,19.4c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,888,19.4Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M874.19,13.74c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,874.19,13.74Z"
              fill="#2f6840"
            />
            <path
              d="M873.68,13.4c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,873.68,13.4Z"
              fill="#3ba525"
            />
            <path
              d="M874.44,13.37a2.17,2.17,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,874.44,13.37Z"
              fill="#2f6840"
            />
            <path
              d="M877.91,12.57c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,877.91,12.57Z"
              fill="#2f6840"
            />
            <path
              d="M876.55,15.78a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,876.55,15.78Z"
              fill="#2f6840"
            />
            <path
              d="M874.59,13.83c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,874.59,13.83Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M917.63,6.36c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S925.37,7,924.4,6.83s-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,917.63,6.36Z"
              fill="#2f6840"
            />
            <path
              d="M917.12,6c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,917.12,6Z"
              fill="#3ba525"
            />
            <path
              d="M917.87,6a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,917.87,6Z"
              fill="#2f6840"
            />
            <path
              d="M921.35,5.19c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18A11.31,11.31,0,0,0,918.6,6a2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,921.35,5.19Z"
              fill="#2f6840"
            />
            <path
              d="M920,8.4a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,920,8.4Z"
              fill="#2f6840"
            />
            <path
              d="M918,6.45c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,918,6.45Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M915,15.09c4.42-.25-4.33.46-4.36-.61S915,11.85,915.89,12s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71S915.5,16,915.5,16s-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,915,15.09Z"
              fill="#2f6840"
            />
            <path
              d="M914.46,14.75c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,914.46,14.75Z"
              fill="#3ba525"
            />
            <path
              d="M915.21,14.72a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.25,2.25,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,915.21,14.72Z"
              fill="#2f6840"
            />
            <path
              d="M918.69,13.92c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,918.69,13.92Z"
              fill="#2f6840"
            />
            <path
              d="M917.32,17.13a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,917.32,17.13Z"
              fill="#2f6840"
            />
            <path
              d="M915.37,15.18a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,915.37,15.18Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M909.61,10.13c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,909.61,10.13Z"
              fill="#2f6840"
            />
            <path
              d="M909.11,9.79c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46S910.3,9,910.3,9s1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,909.11,9.79Z"
              fill="#3ba525"
            />
            <path
              d="M909.86,9.76a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,909.86,9.76Z"
              fill="#2f6840"
            />
            <path
              d="M913.34,9c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,913.34,9Z"
              fill="#2f6840"
            />
            <path
              d="M912,12.17a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,912,12.17Z"
              fill="#2f6840"
            />
            <path
              d="M910,10.22c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,910,10.22Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M901.27,6.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S909,7.35,908,7.23s-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,901.27,6.76Z"
              fill="#2f6840"
            />
            <path
              d="M900.77,6.42c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46S902,5.6,902,5.6s1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S896,7.57,896.22,7.48A14.56,14.56,0,0,1,900.77,6.42Z"
              fill="#3ba525"
            />
            <path
              d="M901.52,6.39a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,901.52,6.39Z"
              fill="#2f6840"
            />
            <path
              d="M905,5.59c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,905,5.59Z"
              fill="#2f6840"
            />
            <path
              d="M903.63,8.8a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,903.63,8.8Z"
              fill="#2f6840"
            />
            <path
              d="M901.67,6.85c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,901.67,6.85Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M916,22.25c4.42-.25-4.33.46-4.36-.61S916,19,916.9,19.19s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,916,22.25Z"
              fill="#2f6840"
            />
            <path
              d="M915.47,21.91c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,915.47,21.91Z"
              fill="#3ba525"
            />
            <path
              d="M916.22,21.88a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,916.22,21.88Z"
              fill="#2f6840"
            />
            <path
              d="M919.7,21.08c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,919.7,21.08Z"
              fill="#2f6840"
            />
            <path
              d="M918.33,24.29a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,918.33,24.29Z"
              fill="#2f6840"
            />
            <path
              d="M916.38,22.34a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,916.38,22.34Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M902.52,16.68c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,902.52,16.68Z"
              fill="#2f6840"
            />
            <path
              d="M902,16.34c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,902,16.34Z"
              fill="#3ba525"
            />
            <path
              d="M902.77,16.31a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,902.77,16.31Z"
              fill="#2f6840"
            />
            <path
              d="M906.24,15.51c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,906.24,15.51Z"
              fill="#2f6840"
            />
            <path
              d="M904.88,18.72a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,904.88,18.72Z"
              fill="#2f6840"
            />
            <path
              d="M902.92,16.77c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,902.92,16.77Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M945.71,11.17c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,945.71,11.17Z"
              fill="#2f6840"
            />
            <path
              d="M945.2,10.83c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,945.2,10.83Z"
              fill="#3ba525"
            />
            <path
              d="M946,10.8a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,946,10.8Z"
              fill="#2f6840"
            />
            <path
              d="M949.43,10c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,949.43,10Z"
              fill="#2f6840"
            />
            <path
              d="M948.06,13.21a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,948.06,13.21Z"
              fill="#2f6840"
            />
            <path
              d="M946.1,11.26c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,946.1,11.26Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M943.05,19.9c4.42-.25-4.33.46-4.36-.61S943,16.66,944,16.84s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,943.05,19.9Z"
              fill="#2f6840"
            />
            <path
              d="M942.54,19.56c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25S945,16,946.66,16.59s3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,942.54,19.56Z"
              fill="#3ba525"
            />
            <path
              d="M943.29,19.53a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,943.29,19.53Z"
              fill="#2f6840"
            />
            <path
              d="M946.77,18.73c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,946.77,18.73Z"
              fill="#2f6840"
            />
            <path
              d="M945.4,21.94a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,945.4,21.94Z"
              fill="#2f6840"
            />
            <path
              d="M943.45,20c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65A2.36,2.36,0,0,1,942,20,2.07,2.07,0,0,1,943.45,20Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M937.69,14.94c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S933,16.09,933.15,16A14.55,14.55,0,0,1,937.69,14.94Z"
              fill="#2f6840"
            />
            <path
              d="M937.19,14.6c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,937.19,14.6Z"
              fill="#3ba525"
            />
            <path
              d="M937.94,14.57a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,937.94,14.57Z"
              fill="#2f6840"
            />
            <path
              d="M941.42,13.78c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,941.42,13.78Z"
              fill="#2f6840"
            />
            <path
              d="M940.05,17a1.94,1.94,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,940.05,17Z"
              fill="#2f6840"
            />
            <path
              d="M938.09,15c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,938.09,15Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M929.35,11.57c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25S931.79,8,933.47,8.6s3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,929.35,11.57Z"
              fill="#2f6840"
            />
            <path
              d="M928.85,11.23c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,928.85,11.23Z"
              fill="#3ba525"
            />
            <path
              d="M929.6,11.2a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74A2.29,2.29,0,0,1,929,10a1.88,1.88,0,0,1,.48.53A1,1,0,0,1,929.6,11.2Z"
              fill="#2f6840"
            />
            <path
              d="M933.08,10.4c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,933.08,10.4Z"
              fill="#2f6840"
            />
            <path
              d="M931.71,13.61a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,931.71,13.61Z"
              fill="#2f6840"
            />
            <path
              d="M929.75,11.66c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,929.75,11.66Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M944.06,27.06c4.42-.25-4.33.46-4.36-.61S944.05,23.82,945,24s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,944.06,27.06Z"
              fill="#2f6840"
            />
            <path
              d="M943.55,26.72c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,943.55,26.72Z"
              fill="#3ba525"
            />
            <path
              d="M944.3,26.69a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.06-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,944.3,26.69Z"
              fill="#2f6840"
            />
            <path
              d="M947.78,25.89c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,947.78,25.89Z"
              fill="#2f6840"
            />
            <path
              d="M946.41,29.1a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,946.41,29.1Z"
              fill="#2f6840"
            />
            <path
              d="M944.45,27.15c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,944.45,27.15Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M930.6,21.49c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,930.6,21.49Z"
              fill="#2f6840"
            />
            <path
              d="M930.09,21.15c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,930.09,21.15Z"
              fill="#3ba525"
            />
            <path
              d="M930.85,21.12a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,930.85,21.12Z"
              fill="#2f6840"
            />
            <path
              d="M934.32,20.32c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,934.32,20.32Z"
              fill="#2f6840"
            />
            <path
              d="M933,23.53a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,933,23.53Z"
              fill="#2f6840"
            />
            <path
              d="M931,21.58c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,931,21.58Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M973.63,16.84c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S968.9,18,969.08,17.9A14.65,14.65,0,0,1,973.63,16.84Z"
              fill="#2f6840"
            />
            <path
              d="M973.12,16.5c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,973.12,16.5Z"
              fill="#3ba525"
            />
            <path
              d="M973.88,16.47a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,973.88,16.47Z"
              fill="#2f6840"
            />
            <path
              d="M977.35,15.67c-.25,0-.49.05-.72.1A4,4,0,0,0,976,16a11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,977.35,15.67Z"
              fill="#2f6840"
            />
            <path
              d="M976,18.88a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,976,18.88Z"
              fill="#2f6840"
            />
            <path
              d="M974,16.93c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,974,16.93Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M971,25.57c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,971,25.57Z"
              fill="#2f6840"
            />
            <path
              d="M970.46,25.23c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71S971,26.1,971,26.1s-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,970.46,25.23Z"
              fill="#3ba525"
            />
            <path
              d="M971.22,25.2a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,971.22,25.2Z"
              fill="#2f6840"
            />
            <path
              d="M974.69,24.4c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,974.69,24.4Z"
              fill="#2f6840"
            />
            <path
              d="M973.33,27.61a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,973.33,27.61Z"
              fill="#2f6840"
            />
            <path
              d="M971.37,25.66c-.25.06-.48.09-.7.16A3.45,3.45,0,0,0,970,26a9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,971.37,25.66Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M965.62,20.61c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,965.62,20.61Z"
              fill="#2f6840"
            />
            <path
              d="M965.11,20.27c4.43-.25-4.33.46-4.35-.61S965.11,17,966,17.2s.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,965.11,20.27Z"
              fill="#3ba525"
            />
            <path
              d="M965.86,20.24a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,965.86,20.24Z"
              fill="#2f6840"
            />
            <path
              d="M969.34,19.45c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,969.34,19.45Z"
              fill="#2f6840"
            />
            <path
              d="M968,22.66a1.93,1.93,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,968,22.66Z"
              fill="#2f6840"
            />
            <path
              d="M966,20.7c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,966,20.7Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M957.27,17.24c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55S960,21.29,959,21s-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,957.27,17.24Z"
              fill="#2f6840"
            />
            <path
              d="M956.77,16.9c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S952,18.05,952.22,18A14.65,14.65,0,0,1,956.77,16.9Z"
              fill="#3ba525"
            />
            <path
              d="M957.52,16.87a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,957.52,16.87Z"
              fill="#2f6840"
            />
            <path
              d="M961,16.07c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,961,16.07Z"
              fill="#2f6840"
            />
            <path
              d="M959.63,19.28a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,959.63,19.28Z"
              fill="#2f6840"
            />
            <path
              d="M957.67,17.33c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,957.67,17.33Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M972,32.73c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,972,32.73Z"
              fill="#2f6840"
            />
            <path
              d="M971.47,32.39c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,971.47,32.39Z"
              fill="#3ba525"
            />
            <path
              d="M972.23,32.36a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,972.23,32.36Z"
              fill="#2f6840"
            />
            <path
              d="M975.7,31.56c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,975.7,31.56Z"
              fill="#2f6840"
            />
            <path
              d="M974.34,34.77a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,974.34,34.77Z"
              fill="#2f6840"
            />
            <path
              d="M972.38,32.82c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,972.38,32.82Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M958.52,27.16c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,958.52,27.16Z"
              fill="#2f6840"
            />
            <path
              d="M958,26.82c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,958,26.82Z"
              fill="#3ba525"
            />
            <path
              d="M958.77,26.79a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,958.77,26.79Z"
              fill="#2f6840"
            />
            <path
              d="M962.25,26c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,962.25,26Z"
              fill="#2f6840"
            />
            <path
              d="M960.88,29.2a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,960.88,29.2Z"
              fill="#2f6840"
            />
            <path
              d="M958.92,27.25c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,958.92,27.25Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1001.4,23.2c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1001.4,23.2Z"
              fill="#2f6840"
            />
            <path
              d="M1000.9,22.86c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1000.9,22.86Z"
              fill="#3ba525"
            />
            <path
              d="M1001.65,22.83a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1001.65,22.83Z"
              fill="#2f6840"
            />
            <path
              d="M1005.13,22c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1005.13,22Z"
              fill="#2f6840"
            />
            <path
              d="M1003.76,25.25a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1003.76,25.25Z"
              fill="#2f6840"
            />
            <path
              d="M1001.8,23.29c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1001.8,23.29Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M998.74,31.93c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S994,33.08,994.2,33A14.55,14.55,0,0,1,998.74,31.93Z"
              fill="#2f6840"
            />
            <path
              d="M998.24,31.59c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,998.24,31.59Z"
              fill="#3ba525"
            />
            <path
              d="M999,31.56a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,999,31.56Z"
              fill="#2f6840"
            />
            <path
              d="M1002.47,30.77c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1002.47,30.77Z"
              fill="#2f6840"
            />
            <path
              d="M1001.1,34a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1001.1,34Z"
              fill="#2f6840"
            />
            <path
              d="M999.14,32c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,999.14,32Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M993.39,27c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,993.39,27Z"
              fill="#2f6840"
            />
            <path
              d="M992.88,26.63c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25S995.32,23,997,23.66s3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,992.88,26.63Z"
              fill="#3ba525"
            />
            <path
              d="M993.64,26.6a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,993.64,26.6Z"
              fill="#2f6840"
            />
            <path
              d="M997.12,25.81a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,997.12,25.81Z"
              fill="#2f6840"
            />
            <path
              d="M995.75,29a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,995.75,29Z"
              fill="#2f6840"
            />
            <path
              d="M993.79,27.06c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,993.79,27.06Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M985.05,23.6c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,985.05,23.6Z"
              fill="#2f6840"
            />
            <path
              d="M984.54,23.26c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,984.54,23.26Z"
              fill="#3ba525"
            />
            <path
              d="M985.3,23.23a2.24,2.24,0,0,0-.8-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,985.3,23.23Z"
              fill="#2f6840"
            />
            <path
              d="M988.77,22.44c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,988.77,22.44Z"
              fill="#2f6840"
            />
            <path
              d="M987.4,25.65a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,987.4,25.65Z"
              fill="#2f6840"
            />
            <path
              d="M985.45,23.69c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,985.45,23.69Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M999.75,39.09c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,999.75,39.09Z"
              fill="#2f6840"
            />
            <path
              d="M999.25,38.75c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,999.25,38.75Z"
              fill="#3ba525"
            />
            <path
              d="M1000,38.72a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1000,38.72Z"
              fill="#2f6840"
            />
            <path
              d="M1003.48,37.93c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1003.48,37.93Z"
              fill="#2f6840"
            />
            <path
              d="M1002.11,41.14a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1002.11,41.14Z"
              fill="#2f6840"
            />
            <path
              d="M1000.15,39.18c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1000.15,39.18Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M986.3,33.52c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S994,34.11,993.07,34s-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,986.3,33.52Z"
              fill="#2f6840"
            />
            <path
              d="M985.79,33.18c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,985.79,33.18Z"
              fill="#3ba525"
            />
            <path
              d="M986.54,33.15a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,986.54,33.15Z"
              fill="#2f6840"
            />
            <path
              d="M990,32.36c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,990,32.36Z"
              fill="#2f6840"
            />
            <path
              d="M988.65,35.57a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,988.65,35.57Z"
              fill="#2f6840"
            />
            <path
              d="M986.69,33.61c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,986.69,33.61Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1029.62,24.64c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1029.62,24.64Z"
              fill="#2f6840"
            />
            <path
              d="M1029.12,24.3c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1029.12,24.3Z"
              fill="#3ba525"
            />
            <path
              d="M1029.87,24.27a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1029.87,24.27Z"
              fill="#2f6840"
            />
            <path
              d="M1033.35,23.47c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1033.35,23.47Z"
              fill="#2f6840"
            />
            <path
              d="M1032,26.68a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1032,26.68Z"
              fill="#2f6840"
            />
            <path
              d="M1030,24.73c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1030,24.73Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1027,33.37c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1027,33.37Z"
              fill="#2f6840"
            />
            <path
              d="M1026.46,33c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1026.46,33Z"
              fill="#3ba525"
            />
            <path
              d="M1027.21,33a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1027.21,33Z"
              fill="#2f6840"
            />
            <path
              d="M1030.69,32.2c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1030.69,32.2Z"
              fill="#2f6840"
            />
            <path
              d="M1029.32,35.41a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1029.32,35.41Z"
              fill="#2f6840"
            />
            <path
              d="M1027.36,33.46c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1027.36,33.46Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1021.61,28.41c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1021.61,28.41Z"
              fill="#2f6840"
            />
            <path
              d="M1021.11,28.07c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1021.11,28.07Z"
              fill="#3ba525"
            />
            <path
              d="M1021.86,28a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1021.86,28Z"
              fill="#2f6840"
            />
            <path
              d="M1025.34,27.24c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1025.34,27.24Z"
              fill="#2f6840"
            />
            <path
              d="M1024,30.45a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1024,30.45Z"
              fill="#2f6840"
            />
            <path
              d="M1022,28.5c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1022,28.5Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1013.27,25c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1013.27,25Z"
              fill="#2f6840"
            />
            <path
              d="M1012.76,24.7c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1012.76,24.7Z"
              fill="#3ba525"
            />
            <path
              d="M1013.52,24.67a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1013.52,24.67Z"
              fill="#2f6840"
            />
            <path
              d="M1017,23.87c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1017,23.87Z"
              fill="#2f6840"
            />
            <path
              d="M1015.63,27.08a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1015.63,27.08Z"
              fill="#2f6840"
            />
            <path
              d="M1013.67,25.13c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1013.67,25.13Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1028,40.53c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1028,40.53Z"
              fill="#2f6840"
            />
            <path
              d="M1027.47,40.19c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1027.47,40.19Z"
              fill="#3ba525"
            />
            <path
              d="M1028.22,40.16a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1028.22,40.16Z"
              fill="#2f6840"
            />
            <path
              d="M1031.7,39.36c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1031.7,39.36Z"
              fill="#2f6840"
            />
            <path
              d="M1030.33,42.57a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1030.33,42.57Z"
              fill="#2f6840"
            />
            <path
              d="M1028.37,40.62c-.24.06-.47.09-.69.16a3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1028.37,40.62Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1014.52,35c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1014.52,35Z"
              fill="#2f6840"
            />
            <path
              d="M1014,34.62c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1014,34.62Z"
              fill="#3ba525"
            />
            <path
              d="M1014.76,34.59a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1014.76,34.59Z"
              fill="#2f6840"
            />
            <path
              d="M1018.24,33.79c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1018.24,33.79Z"
              fill="#2f6840"
            />
            <path
              d="M1016.87,37a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1016.87,37Z"
              fill="#2f6840"
            />
            <path
              d="M1014.92,35.05c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1014.92,35.05Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1056.37,15.6c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1056.37,15.6Z"
              fill="#2f6840"
            />
            <path
              d="M1055.86,15.25c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1055.86,15.25Z"
              fill="#3ba525"
            />
            <path
              d="M1056.62,15.22a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74A2.28,2.28,0,0,1,1056,14a1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1056.62,15.22Z"
              fill="#2f6840"
            />
            <path
              d="M1060.1,14.43c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1060.1,14.43Z"
              fill="#2f6840"
            />
            <path
              d="M1058.73,17.64a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1058.73,17.64Z"
              fill="#2f6840"
            />
            <path
              d="M1056.77,15.68c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1056.77,15.68Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1053.71,24.33c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1053.71,24.33Z"
              fill="#2f6840"
            />
            <path
              d="M1053.21,24c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1053.21,24Z"
              fill="#3ba525"
            />
            <path
              d="M1054,24a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1054,24Z"
              fill="#2f6840"
            />
            <path
              d="M1057.44,23.16a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1057.44,23.16Z"
              fill="#2f6840"
            />
            <path
              d="M1056.07,26.37a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1056.07,26.37Z"
              fill="#2f6840"
            />
            <path
              d="M1054.11,24.41c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1054.11,24.41Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1048.36,19.37c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1048.36,19.37Z"
              fill="#2f6840"
            />
            <path
              d="M1047.85,19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1047.85,19Z"
              fill="#3ba525"
            />
            <path
              d="M1048.61,19a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1048.61,19Z"
              fill="#2f6840"
            />
            <path
              d="M1052.08,18.2c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1052.08,18.2Z"
              fill="#2f6840"
            />
            <path
              d="M1050.72,21.41a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1050.72,21.41Z"
              fill="#2f6840"
            />
            <path
              d="M1048.76,19.45c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1048.76,19.45Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1040,16c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1040,16Z"
              fill="#2f6840"
            />
            <path
              d="M1039.51,15.65c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1039.51,15.65Z"
              fill="#3ba525"
            />
            <path
              d="M1040.26,15.62a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1040.26,15.62Z"
              fill="#2f6840"
            />
            <path
              d="M1043.74,14.83a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1043.74,14.83Z"
              fill="#2f6840"
            />
            <path
              d="M1042.37,18a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1042.37,18Z"
              fill="#2f6840"
            />
            <path
              d="M1040.42,16.08c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1040.42,16.08Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1054.72,31.49c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1054.72,31.49Z"
              fill="#2f6840"
            />
            <path
              d="M1054.22,31.14c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1054.22,31.14Z"
              fill="#3ba525"
            />
            <path
              d="M1055,31.11a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1055,31.11Z"
              fill="#2f6840"
            />
            <path
              d="M1058.45,30.32a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1058.45,30.32Z"
              fill="#2f6840"
            />
            <path
              d="M1057.08,33.53a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1057.08,33.53Z"
              fill="#2f6840"
            />
            <path
              d="M1055.12,31.57c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1055.12,31.57Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1041.26,25.92c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1041.26,25.92Z"
              fill="#2f6840"
            />
            <path
              d="M1040.76,25.57c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1040.76,25.57Z"
              fill="#3ba525"
            />
            <path
              d="M1041.51,25.54a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1041.51,25.54Z"
              fill="#2f6840"
            />
            <path
              d="M1045,24.75a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1045,24.75Z"
              fill="#2f6840"
            />
            <path
              d="M1043.62,28a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1043.62,28Z"
              fill="#2f6840"
            />
            <path
              d="M1041.66,26c-.24.06-.47.09-.69.16a4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1041.66,26Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1082.66,5.77c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1082.66,5.77Z"
              fill="#2f6840"
            />
            <path
              d="M1082.15,5.43c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1082.15,5.43Z"
              fill="#3ba525"
            />
            <path
              d="M1082.9,5.4a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1082.9,5.4Z"
              fill="#2f6840"
            />
            <path
              d="M1086.38,4.6c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,1086.38,4.6Z"
              fill="#2f6840"
            />
            <path
              d="M1085,7.81a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1085,7.81Z"
              fill="#2f6840"
            />
            <path
              d="M1083.06,5.86c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1083.06,5.86Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1080,14.5c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1080,14.5Z"
              fill="#2f6840"
            />
            <path
              d="M1079.49,14.16c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71S1080,15,1080,15s-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1079.49,14.16Z"
              fill="#3ba525"
            />
            <path
              d="M1080.24,14.13a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1080.24,14.13Z"
              fill="#2f6840"
            />
            <path
              d="M1083.72,13.33c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1083.72,13.33Z"
              fill="#2f6840"
            />
            <path
              d="M1082.35,16.54a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1082.35,16.54Z"
              fill="#2f6840"
            />
            <path
              d="M1080.4,14.59c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1080.4,14.59Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1074.65,9.54c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1074.65,9.54Z"
              fill="#2f6840"
            />
            <path
              d="M1074.14,9.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1074.14,9.2Z"
              fill="#3ba525"
            />
            <path
              d="M1074.89,9.17a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1074.89,9.17Z"
              fill="#2f6840"
            />
            <path
              d="M1078.37,8.38c-.26,0-.49,0-.72.09a3.77,3.77,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1078.37,8.38Z"
              fill="#2f6840"
            />
            <path
              d="M1077,11.59a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1077,11.59Z"
              fill="#2f6840"
            />
            <path
              d="M1075,9.63c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1075,9.63Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1066.3,6.17c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1066.3,6.17Z"
              fill="#2f6840"
            />
            <path
              d="M1065.8,5.83c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46S1067,5,1067,5s1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1065.8,5.83Z"
              fill="#3ba525"
            />
            <path
              d="M1066.55,5.8a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1066.55,5.8Z"
              fill="#2f6840"
            />
            <path
              d="M1070,5c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1070,5Z"
              fill="#2f6840"
            />
            <path
              d="M1068.66,8.21a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1068.66,8.21Z"
              fill="#2f6840"
            />
            <path
              d="M1066.7,6.26c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1066.7,6.26Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1081,21.66c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1081,21.66Z"
              fill="#2f6840"
            />
            <path
              d="M1080.5,21.32c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1080.5,21.32Z"
              fill="#3ba525"
            />
            <path
              d="M1081.25,21.29a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1081.25,21.29Z"
              fill="#2f6840"
            />
            <path
              d="M1084.73,20.49c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1084.73,20.49Z"
              fill="#2f6840"
            />
            <path
              d="M1083.36,23.7a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1083.36,23.7Z"
              fill="#2f6840"
            />
            <path
              d="M1081.41,21.75c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1081.41,21.75Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1067.55,16.09c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1067.55,16.09Z"
              fill="#2f6840"
            />
            <path
              d="M1067,15.75c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1067,15.75Z"
              fill="#3ba525"
            />
            <path
              d="M1067.8,15.72a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1067.8,15.72Z"
              fill="#2f6840"
            />
            <path
              d="M1071.28,14.92c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1071.28,14.92Z"
              fill="#2f6840"
            />
            <path
              d="M1069.91,18.13a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1069.91,18.13Z"
              fill="#2f6840"
            />
            <path
              d="M1068,16.18c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,1068,16.18Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1104,18.21c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1104,18.21Z"
              fill="#2f6840"
            />
            <path
              d="M1103.47,17.87c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1103.47,17.87Z"
              fill="#3ba525"
            />
            <path
              d="M1104.22,17.84a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1104.22,17.84Z"
              fill="#2f6840"
            />
            <path
              d="M1107.7,17c-.26,0-.49.05-.72.1a4.83,4.83,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1107.7,17Z"
              fill="#2f6840"
            />
            <path
              d="M1106.33,20.25a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1106.33,20.25Z"
              fill="#2f6840"
            />
            <path
              d="M1104.37,18.3a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1104.37,18.3Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1101.32,26.94c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1101.32,26.94Z"
              fill="#2f6840"
            />
            <path
              d="M1100.81,26.59c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1100.81,26.59Z"
              fill="#3ba525"
            />
            <path
              d="M1101.56,26.57a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1101.56,26.57Z"
              fill="#2f6840"
            />
            <path
              d="M1105,25.77c-.26,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1105,25.77Z"
              fill="#2f6840"
            />
            <path
              d="M1103.67,29a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.13,2.13,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1103.67,29Z"
              fill="#2f6840"
            />
            <path
              d="M1101.71,27a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1101.71,27Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1096,22c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1096,22Z"
              fill="#2f6840"
            />
            <path
              d="M1095.46,21.64c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1095.46,21.64Z"
              fill="#3ba525"
            />
            <path
              d="M1096.21,21.61a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1096.21,21.61Z"
              fill="#2f6840"
            />
            <path
              d="M1099.69,20.81c-.26,0-.49.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1099.69,20.81Z"
              fill="#2f6840"
            />
            <path
              d="M1098.32,24a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1098.32,24Z"
              fill="#2f6840"
            />
            <path
              d="M1096.36,22.07c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1096.36,22.07Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1087.62,18.61c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1087.62,18.61Z"
              fill="#2f6840"
            />
            <path
              d="M1087.12,18.26c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1087.12,18.26Z"
              fill="#3ba525"
            />
            <path
              d="M1087.87,18.24a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1087.87,18.24Z"
              fill="#2f6840"
            />
            <path
              d="M1091.35,17.44c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.1,2.1,0,0,1,1091.35,17.44Z"
              fill="#2f6840"
            />
            <path
              d="M1090,20.65a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1090,20.65Z"
              fill="#2f6840"
            />
            <path
              d="M1088,18.7a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1088,18.7Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1102.33,34.1c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1102.33,34.1Z"
              fill="#2f6840"
            />
            <path
              d="M1101.82,33.75c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1101.82,33.75Z"
              fill="#3ba525"
            />
            <path
              d="M1102.57,33.73a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1102.57,33.73Z"
              fill="#2f6840"
            />
            <path
              d="M1106.05,32.93c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1106.05,32.93Z"
              fill="#2f6840"
            />
            <path
              d="M1104.68,36.14a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.13,2.13,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1104.68,36.14Z"
              fill="#2f6840"
            />
            <path
              d="M1102.72,34.19a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1102.72,34.19Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1088.87,28.53c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1088.87,28.53Z"
              fill="#2f6840"
            />
            <path
              d="M1088.36,28.18c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1088.36,28.18Z"
              fill="#3ba525"
            />
            <path
              d="M1089.12,28.16a2.12,2.12,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1089.12,28.16Z"
              fill="#2f6840"
            />
            <path
              d="M1092.59,27.36c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1092.59,27.36Z"
              fill="#2f6840"
            />
            <path
              d="M1091.23,30.57a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1091.23,30.57Z"
              fill="#2f6840"
            />
            <path
              d="M1089.27,28.62a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1089.27,28.62Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1131.24,22.07c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1131.24,22.07Z"
              fill="#2f6840"
            />
            <path
              d="M1130.73,21.72c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1130.73,21.72Z"
              fill="#3ba525"
            />
            <path
              d="M1131.48,21.7a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1131.48,21.7Z"
              fill="#2f6840"
            />
            <path
              d="M1135,20.9c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1135,20.9Z"
              fill="#2f6840"
            />
            <path
              d="M1133.59,24.11a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1133.59,24.11Z"
              fill="#2f6840"
            />
            <path
              d="M1131.64,22.16a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1131.64,22.16Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1128.58,30.8c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1128.58,30.8Z"
              fill="#2f6840"
            />
            <path
              d="M1128.07,30.45c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1128.07,30.45Z"
              fill="#3ba525"
            />
            <path
              d="M1128.82,30.43a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1128.82,30.43Z"
              fill="#2f6840"
            />
            <path
              d="M1132.3,29.63c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1132.3,29.63Z"
              fill="#2f6840"
            />
            <path
              d="M1130.93,32.84a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1130.93,32.84Z"
              fill="#2f6840"
            />
            <path
              d="M1129,30.88c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1129,30.88Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1123.22,25.84c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1123.22,25.84Z"
              fill="#2f6840"
            />
            <path
              d="M1122.72,25.5c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1122.72,25.5Z"
              fill="#3ba525"
            />
            <path
              d="M1123.47,25.47a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1123.47,25.47Z"
              fill="#2f6840"
            />
            <path
              d="M1127,24.67c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1127,24.67Z"
              fill="#2f6840"
            />
            <path
              d="M1125.58,27.88a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1125.58,27.88Z"
              fill="#2f6840"
            />
            <path
              d="M1123.62,25.93a7,7,0,0,0-.69.16,3.31,3.31,0,0,0-.65.22A10,10,0,0,0,1121,27a2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1123.62,25.93Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1114.88,22.47c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1114.88,22.47Z"
              fill="#2f6840"
            />
            <path
              d="M1114.38,22.12c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1114.38,22.12Z"
              fill="#3ba525"
            />
            <path
              d="M1115.13,22.1a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.18,2.18,0,0,1,.47.53A1,1,0,0,1,1115.13,22.1Z"
              fill="#2f6840"
            />
            <path
              d="M1118.61,21.3c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1118.61,21.3Z"
              fill="#2f6840"
            />
            <path
              d="M1117.24,24.51a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1117.24,24.51Z"
              fill="#2f6840"
            />
            <path
              d="M1115.28,22.56a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1115.28,22.56Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1129.59,38c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1129.59,38Z"
              fill="#2f6840"
            />
            <path
              d="M1129.08,37.61c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1129.08,37.61Z"
              fill="#3ba525"
            />
            <path
              d="M1129.83,37.59a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1129.83,37.59Z"
              fill="#2f6840"
            />
            <path
              d="M1133.31,36.79c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1133.31,36.79Z"
              fill="#2f6840"
            />
            <path
              d="M1131.94,40a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1131.94,40Z"
              fill="#2f6840"
            />
            <path
              d="M1130,38c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1130,38Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1116.13,32.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1116.13,32.39Z"
              fill="#2f6840"
            />
            <path
              d="M1115.62,32c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1115.62,32Z"
              fill="#3ba525"
            />
            <path
              d="M1116.38,32a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1116.38,32Z"
              fill="#2f6840"
            />
            <path
              d="M1119.85,31.22c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1119.85,31.22Z"
              fill="#2f6840"
            />
            <path
              d="M1118.49,34.43a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1118.49,34.43Z"
              fill="#2f6840"
            />
            <path
              d="M1116.53,32.48a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1116.53,32.48Z"
              fill="#2f6840"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M1103.57,33.85l1.84,1.14a.59.59,0,0,0,.56,0l4.41-2a.59.59,0,0,0,.15-1h0a.55.55,0,0,0-.47-.14l-6.25.83A.59.59,0,0,0,1103.57,33.85Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1106.83 29.3 1104.35 29.82 1102.16 31.5 1105.83 32.98 1110.32 31.14 1106.83 29.3"
            fill="#ffedc8"
          />
          <polygon
            points="1102.16 31.5 1102.16 32.98 1105.68 34.48 1110.42 32.56 1110.32 31.14 1105.83 32.98 1102.16 31.5"
            fill="#ccae79"
          />
          <polygon
            points="1105.83 32.98 1105.68 34.48 1110.42 32.56 1110.32 31.14 1105.83 32.98"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1103.21,31.92a.69.69,0,0,1,0,.76c.16-.24.2-.67.28-.64Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1104.75,32.55a2.15,2.15,0,0,0,.93-.95l-.67,1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1107.68,32.22a.67.67,0,0,1,.37.59l-.11-.7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1109.33,30.61a4.2,4.2,0,0,1-1.46,0,2.1,2.1,0,0,1-1.07.07s.78-.07,1.07.19A6.41,6.41,0,0,1,1109.33,30.61Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M976.27,24.42l1.84,1.14a.61.61,0,0,0,.56,0l4.4-2a.6.6,0,0,0,.15-1h0a.61.61,0,0,0-.47-.14l-6.24.83A.6.6,0,0,0,976.27,24.42Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="979.53 19.86 977.04 20.39 974.85 22.07 978.52 23.54 983.02 21.7 979.53 19.86"
            fill="#ffedc8"
          />
          <polygon
            points="974.85 22.07 974.85 23.54 978.38 25.05 983.12 23.13 983.02 21.7 978.52 23.54 974.85 22.07"
            fill="#ccae79"
          />
          <polygon
            points="978.52 23.54 978.38 25.05 983.12 23.13 983.02 21.7 978.52 23.54"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M975.9,22.49a.65.65,0,0,1,0,.75c.17-.23.21-.67.28-.64Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M977.45,23.11a2.08,2.08,0,0,0,.93-.94l-.67,1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M980.38,22.78a.69.69,0,0,1,.37.59l-.11-.69Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M982,21.17a4.19,4.19,0,0,1-1.46,0,2,2,0,0,1-1.06.08s.78-.08,1.06.19A6.61,6.61,0,0,1,982,21.17Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M927.29,23.43l1.83,1.14a.62.62,0,0,0,.56,0l4.41-2a.59.59,0,0,0,.15-1h0a.55.55,0,0,0-.47-.14l-6.25.83A.6.6,0,0,0,927.29,23.43Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="930.55 18.86 928.06 19.39 925.87 21.07 929.54 22.55 934.03 20.71 930.55 18.86"
            fill="#ffedc8"
          />
          <polygon
            points="925.87 21.07 925.87 22.55 929.39 24.05 934.13 22.13 934.03 20.71 929.54 22.55 925.87 21.07"
            fill="#ccae79"
          />
          <polygon
            points="929.54 22.55 929.39 24.05 934.13 22.13 934.03 20.71 929.54 22.55"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M926.92,21.5a.65.65,0,0,1,0,.75c.16-.24.2-.67.28-.64Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M928.47,22.12a2.09,2.09,0,0,0,.92-.94l-.66,1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M931.4,21.79a.67.67,0,0,1,.36.59l-.11-.7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M933,20.18a4.2,4.2,0,0,1-1.46,0,2.06,2.06,0,0,1-1.06.07s.78-.07,1.06.2A6,6,0,0,1,933,20.18Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1079.93,17.12l4,2.49a1.29,1.29,0,0,0,1.22.08l9.62-4.3a1.31,1.31,0,0,0,.32-2.18h0a1.3,1.3,0,0,0-1-.3l-13.64,1.81A1.3,1.3,0,0,0,1079.93,17.12Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1087.05 7.17 1081.62 8.32 1076.84 11.99 1084.85 15.2 1094.66 11.18 1087.05 7.17"
            fill="#ffedc8"
          />
          <polygon
            points="1076.84 11.99 1076.84 15.2 1084.53 18.5 1094.87 14.3 1094.66 11.18 1084.85 15.2 1076.84 11.99"
            fill="#ccae79"
          />
          <polygon
            points="1084.85 15.2 1084.53 18.5 1094.87 14.3 1094.66 11.18 1084.85 15.2"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1079.12,12.91a1.43,1.43,0,0,1,0,1.64c.37-.51.45-1.47.62-1.4Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1082.5,14.26a4.6,4.6,0,0,0,2-2l-1.46,2.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1088.9,13.54a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1092.49,10a9.72,9.72,0,0,1-3.19,0,4.65,4.65,0,0,1-2.32.16s1.7-.17,2.32.41A13.73,13.73,0,0,1,1092.49,10Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M894.68,20.33l4,2.49a1.29,1.29,0,0,0,1.22.08l9.63-4.3a1.3,1.3,0,0,0,.32-2.17h0a1.27,1.27,0,0,0-1-.31l-13.64,1.81A1.3,1.3,0,0,0,894.68,20.33Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="901.79 10.38 896.37 11.53 891.59 15.2 899.6 18.41 909.41 14.39 901.79 10.38"
            fill="#ffedc8"
          />
          <polygon
            points="891.59 15.2 891.59 18.41 899.27 21.71 909.62 17.51 909.41 14.39 899.6 18.41 891.59 15.2"
            fill="#ccae79"
          />
          <polygon
            points="899.6 18.41 899.27 21.71 909.62 17.51 909.41 14.39 899.6 18.41"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M893.87,16.12a1.44,1.44,0,0,1,0,1.65c.36-.52.45-1.47.61-1.41Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M897.25,17.47a4.56,4.56,0,0,0,2-2l-1.45,2.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M903.65,16.75a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M907.23,13.25a9.65,9.65,0,0,1-3.18,0,4.64,4.64,0,0,1-2.32.16s1.7-.17,2.32.42A13.32,13.32,0,0,1,907.23,13.25Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M955,30.72l4,2.49a1.29,1.29,0,0,0,1.22.08l9.63-4.3a1.31,1.31,0,0,0,.32-2.18h0a1.32,1.32,0,0,0-1-.3l-13.63,1.81A1.31,1.31,0,0,0,955,30.72Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="962.11 20.77 956.68 21.92 951.9 25.59 959.91 28.8 969.72 24.78 962.11 20.77"
            fill="#ffedc8"
          />
          <polygon
            points="951.9 25.59 951.9 28.8 959.59 32.1 969.94 27.9 969.72 24.78 959.91 28.8 951.9 25.59"
            fill="#ccae79"
          />
          <polygon
            points="959.91 28.8 959.59 32.1 969.94 27.9 969.72 24.78 959.91 28.8"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M954.19,26.51a1.44,1.44,0,0,1,0,1.65c.36-.52.44-1.47.61-1.41Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M957.57,27.86a4.56,4.56,0,0,0,2-2.05l-1.45,2.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M964,27.14a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M967.55,23.64a9.66,9.66,0,0,1-3.18,0,4.69,4.69,0,0,1-2.33.16s1.71-.17,2.33.41A13.59,13.59,0,0,1,967.55,23.64Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1086.2,34.47l3,1.85a1,1,0,0,0,.91.06l7.16-3.2a1,1,0,0,0,.24-1.62h0a1,1,0,0,0-.76-.23l-10.15,1.35A1,1,0,0,0,1086.2,34.47Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1091.5 27.05 1087.46 27.91 1083.9 30.65 1089.87 33.04 1097.17 30.05 1091.5 27.05"
            fill="#ffedc8"
          />
          <polygon
            points="1083.9 30.65 1083.9 33.04 1089.63 35.49 1097.33 32.36 1097.17 30.05 1089.87 33.04 1083.9 30.65"
            fill="#ccae79"
          />
          <polygon
            points="1089.87 33.04 1089.63 35.49 1097.33 32.36 1097.17 30.05 1089.87 33.04"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1085.6,31.33a1.07,1.07,0,0,1,0,1.23c.27-.39.34-1.1.46-1.05Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1088.12,32.34a3.45,3.45,0,0,0,1.51-1.53l-1.09,1.7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1092.88,31.8a1.12,1.12,0,0,1,.6,1l-.18-1.14Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1095.55,29.19a7.07,7.07,0,0,1-2.37,0,3.41,3.41,0,0,1-1.73.12s1.27-.12,1.73.31A10.46,10.46,0,0,1,1095.55,29.19Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M987.05,39.19l3,1.86a1,1,0,0,0,.91.06l7.16-3.2a1,1,0,0,0,.24-1.62h0a.93.93,0,0,0-.76-.23l-10.15,1.35A1,1,0,0,0,987.05,39.19Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="992.35 31.78 988.31 32.64 984.75 35.37 990.72 37.76 998.02 34.77 992.35 31.78"
            fill="#ffedc8"
          />
          <polygon
            points="984.75 35.37 984.75 37.76 990.48 40.22 998.18 37.09 998.02 34.77 990.72 37.76 984.75 35.37"
            fill="#ccae79"
          />
          <polygon
            points="990.72 37.76 990.48 40.22 998.18 37.09 998.02 34.77 990.72 37.76"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M986.45,36.06a1.05,1.05,0,0,1,0,1.22c.27-.38.34-1.09.46-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M989,37.06a3.39,3.39,0,0,0,1.51-1.52l-1.09,1.69Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M993.73,36.53a1.12,1.12,0,0,1,.6,1l-.18-1.14Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M996.4,33.92a7.07,7.07,0,0,1-2.37,0,3.41,3.41,0,0,1-1.73.12s1.27-.12,1.73.31A10.46,10.46,0,0,1,996.4,33.92Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M886.14,9.86l3,1.86a1,1,0,0,0,.91.06l7.16-3.2A1,1,0,0,0,897.43,7h0a.92.92,0,0,0-.76-.23L886.52,8.08A1,1,0,0,0,886.14,9.86Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="891.43 2.45 887.39 3.31 883.83 6.04 889.8 8.44 897.1 5.44 891.43 2.45"
            fill="#ffedc8"
          />
          <polygon
            points="883.83 6.04 883.83 8.44 889.56 10.89 897.26 7.76 897.1 5.44 889.8 8.44 883.83 6.04"
            fill="#ccae79"
          />
          <polygon
            points="889.8 8.44 889.56 10.89 897.26 7.76 897.1 5.44 889.8 8.44"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M885.54,6.73a1.07,1.07,0,0,1,0,1.22c.27-.38.33-1.09.45-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M888.05,7.74a3.45,3.45,0,0,0,1.51-1.53l-1.08,1.7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M892.81,7.2a1.12,1.12,0,0,1,.6,1L893.23,7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M895.48,4.59a7.06,7.06,0,0,1-2.37,0,3.37,3.37,0,0,1-1.72.12s1.26-.12,1.72.31A10.46,10.46,0,0,1,895.48,4.59Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1057.39,38.12l4,2.49a1.29,1.29,0,0,0,1.22.08l9.62-4.3a1.31,1.31,0,0,0,.32-2.18h0a1.3,1.3,0,0,0-1-.3l-13.63,1.81A1.3,1.3,0,0,0,1057.39,38.12Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1064.51 28.16 1059.08 29.32 1054.3 32.99 1062.31 36.2 1072.12 32.18 1064.51 28.16"
            fill="#ffedc8"
          />
          <polygon
            points="1054.3 32.99 1054.3 36.2 1061.99 39.49 1072.33 35.3 1072.12 32.18 1062.31 36.2 1054.3 32.99"
            fill="#ccae79"
          />
          <polygon
            points="1062.31 36.2 1061.99 39.49 1072.33 35.3 1072.12 32.18 1062.31 36.2"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1056.59,33.91a1.45,1.45,0,0,1,0,1.64c.36-.51.44-1.47.61-1.4Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1060,35.26a4.6,4.6,0,0,0,2-2l-1.46,2.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1066.36,34.54a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1070,31a9.72,9.72,0,0,1-3.19,0,4.65,4.65,0,0,1-2.32.16s1.7-.17,2.32.41A13.73,13.73,0,0,1,1070,31Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1005.54,27.77l4,2.49a1.32,1.32,0,0,0,1.22.09L1020.4,26a1.3,1.3,0,0,0,.32-2.17h0a1.29,1.29,0,0,0-1-.31l-13.63,1.81A1.31,1.31,0,0,0,1005.54,27.77Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1012.66 17.82 1007.23 18.97 1002.45 22.64 1010.46 25.85 1020.27 21.84 1012.66 17.82"
            fill="#ffedc8"
          />
          <polygon
            points="1002.45 22.64 1002.45 25.85 1010.14 29.15 1020.49 24.95 1020.27 21.84 1010.46 25.85 1002.45 22.64"
            fill="#ccae79"
          />
          <polygon
            points="1010.46 25.85 1010.14 29.15 1020.49 24.95 1020.27 21.84 1010.46 25.85"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1004.74,23.56a1.44,1.44,0,0,1,0,1.65c.36-.52.44-1.47.61-1.4Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1008.12,24.91a4.56,4.56,0,0,0,2-2.05l-1.45,2.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1014.51,24.19a1.5,1.5,0,0,1,.8,1.3l-.24-1.52Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1018.1,20.69a9.38,9.38,0,0,1-3.18,0,4.55,4.55,0,0,1-2.33.16s1.71-.16,2.33.42A13.78,13.78,0,0,1,1018.1,20.69Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1104.51,24.22s1.69,3.36,4,3.93,5.91-1.78,5.36.16,4.44,2.8,6.57,2.27,6.83-5.09,6.8-6.54S1104.51,24.22,1104.51,24.22Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M1104.43,21.47l.08,2.75,4,2.82,5.25-.14,1.25,2s3.63,1.69,6-.16a19.74,19.74,0,0,0,4.24-5.1l-.07-2.76Z"
            fill="#ccae79"
          />
          <path
            d="M1108.65,19.56l-4.22,1.91,4.35,2.8,5-.13,1.68,2.07s4.94,1.33,5.54-.15,4.25-5.16,4.25-5.16l-4-1.68Z"
            fill="#ffedc8"
          />
          <polygon
            points="1108.78 24.27 1108.56 27.04 1113.81 26.9 1113.8 24.14 1108.78 24.27"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1119.77,26.72s.87,2.51.08,2.68a12,12,0,0,0,5.49-5.74l-.07-2.76S1120.93,26.7,1119.77,26.72Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1116.38,26.42l1,.18s-.62-.16-.47,1A2.74,2.74,0,0,0,1116.38,26.42Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1118.66,26.77c-.11,0,.2,0,1.09-.93a5.86,5.86,0,0,0,1.22-1.9s-2.13,2.47-1.6,2.81Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1107,23.11a15.82,15.82,0,0,1,.06,2s-.12-1.5.3-1.76Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1114.69,19.4l2,0c.14,0-1.57,0-2,.94l0-.89"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1106.56,20.51l1-.47s-.59.37-.36.45,1.17.45,1.55.25a1.58,1.58,0,0,1,1,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M930.23,13.32s1.69,3.36,4,3.93,5.9-1.78,5.36.16,4.43,2.8,6.57,2.27,6.83-5.09,6.8-6.54S930.23,13.32,930.23,13.32Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M930.16,10.56l.07,2.76,4.06,2.82,5.25-.14,1.25,2s3.62,1.69,6-.16a19.74,19.74,0,0,0,4.24-5.1L951,10Z"
            fill="#ccae79"
          />
          <path
            d="M934.38,8.66l-4.22,1.9,4.35,2.81,5-.13,1.69,2.07s4.94,1.32,5.54-.15S951,10,951,10l-4-1.68Z"
            fill="#ffedc8"
          />
          <polygon
            points="934.5 13.37 934.29 16.14 939.54 16 939.52 13.24 934.5 13.37"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M945.5,15.82s.86,2.51.07,2.68a12.08,12.08,0,0,0,5.5-5.74L951,10S946.65,15.8,945.5,15.82Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M942.11,15.51l1,.19s-.62-.16-.47,1A2.9,2.9,0,0,0,942.11,15.51Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M944.39,15.87c-.11,0,.19,0,1.08-.93A5.9,5.9,0,0,0,946.7,13s-2.13,2.47-1.61,2.81Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M932.7,12.21a16.74,16.74,0,0,1,0,2s-.11-1.5.31-1.76Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M940.42,8.5l2-.06c.15,0-1.57,0-2,1l0-.89"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M932.28,9.61l1.05-.48s-.59.38-.35.46,1.17.45,1.54.25a1.53,1.53,0,0,1,1,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="M1224.76,494.49c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1224.76,494.49Z"
              fill="#2f6840"
            />
            <path
              d="M1224.26,494.15c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1224.26,494.15Z"
              fill="#3ba525"
            />
            <path
              d="M1225,494.12a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1225,494.12Z"
              fill="#2f6840"
            />
            <path
              d="M1228.49,493.32c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1228.49,493.32Z"
              fill="#2f6840"
            />
            <path
              d="M1227.12,496.53a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1227.12,496.53Z"
              fill="#2f6840"
            />
            <path
              d="M1225.16,494.58a7,7,0,0,0-.69.16,3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1225.16,494.58Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1222.11,503.22c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1222.11,503.22Z"
              fill="#2f6840"
            />
            <path
              d="M1221.6,502.88c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1221.6,502.88Z"
              fill="#3ba525"
            />
            <path
              d="M1222.35,502.85a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1222.35,502.85Z"
              fill="#2f6840"
            />
            <path
              d="M1225.83,502.05c-.26,0-.49.05-.72.1a4.83,4.83,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1225.83,502.05Z"
              fill="#2f6840"
            />
            <path
              d="M1224.46,505.26a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1224.46,505.26Z"
              fill="#2f6840"
            />
            <path
              d="M1222.5,503.31a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1222.5,503.31Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1216.75,498.26c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1216.75,498.26Z"
              fill="#2f6840"
            />
            <path
              d="M1216.25,497.92c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1216.25,497.92Z"
              fill="#3ba525"
            />
            <path
              d="M1217,497.89a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1217,497.89Z"
              fill="#2f6840"
            />
            <path
              d="M1220.48,497.09c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52A2.45,2.45,0,0,1,1219,497,2.12,2.12,0,0,1,1220.48,497.09Z"
              fill="#2f6840"
            />
            <path
              d="M1219.11,500.3a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1219.11,500.3Z"
              fill="#2f6840"
            />
            <path
              d="M1217.15,498.35c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1217.15,498.35Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1208.41,494.89c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1208.41,494.89Z"
              fill="#2f6840"
            />
            <path
              d="M1207.9,494.55c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1207.9,494.55Z"
              fill="#3ba525"
            />
            <path
              d="M1208.66,494.52a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.94.94,0,0,1,1208.66,494.52Z"
              fill="#2f6840"
            />
            <path
              d="M1212.13,493.72c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1212.13,493.72Z"
              fill="#2f6840"
            />
            <path
              d="M1210.77,496.93a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1210.77,496.93Z"
              fill="#2f6840"
            />
            <path
              d="M1208.81,495a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1208.81,495Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1223.12,510.38c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1223.12,510.38Z"
              fill="#2f6840"
            />
            <path
              d="M1222.61,510c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1222.61,510Z"
              fill="#3ba525"
            />
            <path
              d="M1223.36,510a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1223.36,510Z"
              fill="#2f6840"
            />
            <path
              d="M1226.84,509.21c-.26,0-.49.05-.72.1a4.51,4.51,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1226.84,509.21Z"
              fill="#2f6840"
            />
            <path
              d="M1225.47,512.42a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1225.47,512.42Z"
              fill="#2f6840"
            />
            <path
              d="M1223.51,510.47a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1223.51,510.47Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1209.66,504.81c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1209.66,504.81Z"
              fill="#2f6840"
            />
            <path
              d="M1209.15,504.47c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1209.15,504.47Z"
              fill="#3ba525"
            />
            <path
              d="M1209.91,504.44a2.24,2.24,0,0,0-.8-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1209.91,504.44Z"
              fill="#2f6840"
            />
            <path
              d="M1213.38,503.64c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17c-.45.13-.87.34-1.35.53a2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1213.38,503.64Z"
              fill="#2f6840"
            />
            <path
              d="M1212,506.85a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1212,506.85Z"
              fill="#2f6840"
            />
            <path
              d="M1210.06,504.9a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1210.06,504.9Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1250.66,506.15c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1250.66,506.15Z"
              fill="#2f6840"
            />
            <path
              d="M1250.16,505.8c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1250.16,505.8Z"
              fill="#3ba525"
            />
            <path
              d="M1250.91,505.78a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.38,2.38,0,0,1,.47.53A1,1,0,0,1,1250.91,505.78Z"
              fill="#2f6840"
            />
            <path
              d="M1254.39,505c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1254.39,505Z"
              fill="#2f6840"
            />
            <path
              d="M1253,508.19a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1253,508.19Z"
              fill="#2f6840"
            />
            <path
              d="M1251.06,506.24a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1251.06,506.24Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1248,514.88c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1248,514.88Z"
              fill="#2f6840"
            />
            <path
              d="M1247.5,514.53c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1247.5,514.53Z"
              fill="#3ba525"
            />
            <path
              d="M1248.25,514.5a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1248.25,514.5Z"
              fill="#2f6840"
            />
            <path
              d="M1251.73,513.71c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1251.73,513.71Z"
              fill="#2f6840"
            />
            <path
              d="M1250.36,516.92a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1250.36,516.92Z"
              fill="#2f6840"
            />
            <path
              d="M1248.4,515c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1248.4,515Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1242.65,509.92c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1242.65,509.92Z"
              fill="#2f6840"
            />
            <path
              d="M1242.14,509.58c4.43-.26-4.32.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1242.14,509.58Z"
              fill="#3ba525"
            />
            <path
              d="M1242.9,509.55a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1242.9,509.55Z"
              fill="#2f6840"
            />
            <path
              d="M1246.37,508.75c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1246.37,508.75Z"
              fill="#2f6840"
            />
            <path
              d="M1245,512a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1245,512Z"
              fill="#2f6840"
            />
            <path
              d="M1243.05,510a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1243.05,510Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1234.31,506.55c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1234.31,506.55Z"
              fill="#2f6840"
            />
            <path
              d="M1233.8,506.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1233.8,506.2Z"
              fill="#3ba525"
            />
            <path
              d="M1234.55,506.17a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1234.55,506.17Z"
              fill="#2f6840"
            />
            <path
              d="M1238,505.38c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1238,505.38Z"
              fill="#2f6840"
            />
            <path
              d="M1236.66,508.59a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1236.66,508.59Z"
              fill="#2f6840"
            />
            <path
              d="M1234.71,506.63c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1234.71,506.63Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1249,522c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1249,522Z"
              fill="#2f6840"
            />
            <path
              d="M1248.51,521.69c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1248.51,521.69Z"
              fill="#3ba525"
            />
            <path
              d="M1249.26,521.66a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1249.26,521.66Z"
              fill="#2f6840"
            />
            <path
              d="M1252.74,520.87c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1252.74,520.87Z"
              fill="#2f6840"
            />
            <path
              d="M1251.37,524.08a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1251.37,524.08Z"
              fill="#2f6840"
            />
            <path
              d="M1249.41,522.12c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1249.41,522.12Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1235.56,516.47c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1235.56,516.47Z"
              fill="#2f6840"
            />
            <path
              d="M1235.05,516.12c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1235.05,516.12Z"
              fill="#3ba525"
            />
            <path
              d="M1235.8,516.09a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1235.8,516.09Z"
              fill="#2f6840"
            />
            <path
              d="M1239.28,515.3c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1239.28,515.3Z"
              fill="#2f6840"
            />
            <path
              d="M1237.91,518.51a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1237.91,518.51Z"
              fill="#2f6840"
            />
            <path
              d="M1236,516.55c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1236,516.55Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1278.64,507.87c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1278.64,507.87Z"
              fill="#2f6840"
            />
            <path
              d="M1278.13,507.53c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1278.13,507.53Z"
              fill="#3ba525"
            />
            <path
              d="M1278.89,507.5a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1278.89,507.5Z"
              fill="#2f6840"
            />
            <path
              d="M1282.37,506.7c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1282.37,506.7Z"
              fill="#2f6840"
            />
            <path
              d="M1281,509.91a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1281,509.91Z"
              fill="#2f6840"
            />
            <path
              d="M1279,508a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1279,508Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1276,516.6c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1276,516.6Z"
              fill="#2f6840"
            />
            <path
              d="M1275.48,516.26c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,1275.48,516.26Z"
              fill="#3ba525"
            />
            <path
              d="M1276.23,516.23a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1276.23,516.23Z"
              fill="#2f6840"
            />
            <path
              d="M1279.71,515.43c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1279.71,515.43Z"
              fill="#2f6840"
            />
            <path
              d="M1278.34,518.64a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1278.34,518.64Z"
              fill="#2f6840"
            />
            <path
              d="M1276.38,516.69a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1276.38,516.69Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1270.63,511.64c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1270.63,511.64Z"
              fill="#2f6840"
            />
            <path
              d="M1270.12,511.3c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1270.12,511.3Z"
              fill="#3ba525"
            />
            <path
              d="M1270.88,511.27a2.17,2.17,0,0,0-.8-.94c-.32-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1270.88,511.27Z"
              fill="#2f6840"
            />
            <path
              d="M1274.35,510.47c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1274.35,510.47Z"
              fill="#2f6840"
            />
            <path
              d="M1273,513.68a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1273,513.68Z"
              fill="#2f6840"
            />
            <path
              d="M1271,511.73c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1271,511.73Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1262.29,508.27c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1262.29,508.27Z"
              fill="#2f6840"
            />
            <path
              d="M1261.78,507.93c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1261.78,507.93Z"
              fill="#3ba525"
            />
            <path
              d="M1262.53,507.9a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1262.53,507.9Z"
              fill="#2f6840"
            />
            <path
              d="M1266,507.1c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1266,507.1Z"
              fill="#2f6840"
            />
            <path
              d="M1264.64,510.31a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1264.64,510.31Z"
              fill="#2f6840"
            />
            <path
              d="M1262.68,508.36c-.24.06-.47.08-.69.15a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1262.68,508.36Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1277,523.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1277,523.76Z"
              fill="#2f6840"
            />
            <path
              d="M1276.49,523.42c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.68,14.68,0,0,1,1276.49,523.42Z"
              fill="#3ba525"
            />
            <path
              d="M1277.24,523.39a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1277.24,523.39Z"
              fill="#2f6840"
            />
            <path
              d="M1280.72,522.59c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1280.72,522.59Z"
              fill="#2f6840"
            />
            <path
              d="M1279.35,525.8a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1279.35,525.8Z"
              fill="#2f6840"
            />
            <path
              d="M1277.39,523.85a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1277.39,523.85Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1263.53,518.19c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1263.53,518.19Z"
              fill="#2f6840"
            />
            <path
              d="M1263,517.85c4.42-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1263,517.85Z"
              fill="#3ba525"
            />
            <path
              d="M1263.78,517.82a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1263.78,517.82Z"
              fill="#2f6840"
            />
            <path
              d="M1267.26,517c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1267.26,517Z"
              fill="#2f6840"
            />
            <path
              d="M1265.89,520.23a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1265.89,520.23Z"
              fill="#2f6840"
            />
            <path
              d="M1263.93,518.28c-.24.06-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1263.93,518.28Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1291.25,484.24c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1291.25,484.24Z"
              fill="#2f6840"
            />
            <path
              d="M1290.75,483.89c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S1286,485,1286.2,485A14.56,14.56,0,0,1,1290.75,483.89Z"
              fill="#3ba525"
            />
            <path
              d="M1291.5,483.86a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.48.53A1,1,0,0,1,1291.5,483.86Z"
              fill="#2f6840"
            />
            <path
              d="M1295,483.07c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1295,483.07Z"
              fill="#2f6840"
            />
            <path
              d="M1293.61,486.28a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1293.61,486.28Z"
              fill="#2f6840"
            />
            <path
              d="M1291.65,484.32c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1291.65,484.32Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1288.59,493c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1288.59,493Z"
              fill="#2f6840"
            />
            <path
              d="M1288.09,492.62c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1288.09,492.62Z"
              fill="#3ba525"
            />
            <path
              d="M1288.84,492.59a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1288.84,492.59Z"
              fill="#2f6840"
            />
            <path
              d="M1292.32,491.8a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1292.32,491.8Z"
              fill="#2f6840"
            />
            <path
              d="M1291,495a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1291,495Z"
              fill="#2f6840"
            />
            <path
              d="M1289,493.05c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1289,493.05Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1283.24,488c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1283.24,488Z"
              fill="#2f6840"
            />
            <path
              d="M1282.73,487.66c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1282.73,487.66Z"
              fill="#3ba525"
            />
            <path
              d="M1283.49,487.64a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1283.49,487.64Z"
              fill="#2f6840"
            />
            <path
              d="M1287,486.84c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1287,486.84Z"
              fill="#2f6840"
            />
            <path
              d="M1285.6,490.05a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1285.6,490.05Z"
              fill="#2f6840"
            />
            <path
              d="M1283.64,488.1a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1283.64,488.1Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1274.9,484.64c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1274.9,484.64Z"
              fill="#2f6840"
            />
            <path
              d="M1274.39,484.29c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1274.39,484.29Z"
              fill="#3ba525"
            />
            <path
              d="M1275.14,484.26a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1275.14,484.26Z"
              fill="#2f6840"
            />
            <path
              d="M1278.62,483.47c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1278.62,483.47Z"
              fill="#2f6840"
            />
            <path
              d="M1277.25,486.68a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1277.25,486.68Z"
              fill="#2f6840"
            />
            <path
              d="M1275.3,484.72c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1275.3,484.72Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1289.6,500.13c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1289.6,500.13Z"
              fill="#2f6840"
            />
            <path
              d="M1289.1,499.78c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1289.1,499.78Z"
              fill="#3ba525"
            />
            <path
              d="M1289.85,499.75a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1289.85,499.75Z"
              fill="#2f6840"
            />
            <path
              d="M1293.33,499a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1293.33,499Z"
              fill="#2f6840"
            />
            <path
              d="M1292,502.17a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1292,502.17Z"
              fill="#2f6840"
            />
            <path
              d="M1290,500.21c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1290,500.21Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1276.14,494.56c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1276.14,494.56Z"
              fill="#2f6840"
            />
            <path
              d="M1275.64,494.21c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1275.64,494.21Z"
              fill="#3ba525"
            />
            <path
              d="M1276.39,494.18a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1276.39,494.18Z"
              fill="#2f6840"
            />
            <path
              d="M1279.87,493.39c-.26,0-.49,0-.72.1a3,3,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1279.87,493.39Z"
              fill="#2f6840"
            />
            <path
              d="M1278.5,496.6a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1278.5,496.6Z"
              fill="#2f6840"
            />
            <path
              d="M1276.54,494.64c-.24.06-.47.09-.69.16a4.54,4.54,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1276.54,494.64Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1280.86,461.15c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1280.86,461.15Z"
              fill="#2f6840"
            />
            <path
              d="M1280.35,460.8c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1280.35,460.8Z"
              fill="#3ba525"
            />
            <path
              d="M1281.11,460.78a2.12,2.12,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1281.11,460.78Z"
              fill="#2f6840"
            />
            <path
              d="M1284.58,460c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1284.58,460Z"
              fill="#2f6840"
            />
            <path
              d="M1283.22,463.19a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1283.22,463.19Z"
              fill="#2f6840"
            />
            <path
              d="M1281.26,461.24a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1281.26,461.24Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1278.2,469.88c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1278.2,469.88Z"
              fill="#2f6840"
            />
            <path
              d="M1277.69,469.53c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1277.69,469.53Z"
              fill="#3ba525"
            />
            <path
              d="M1278.45,469.5a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1278.45,469.5Z"
              fill="#2f6840"
            />
            <path
              d="M1281.92,468.71c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1281.92,468.71Z"
              fill="#2f6840"
            />
            <path
              d="M1280.56,471.92a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1280.56,471.92Z"
              fill="#2f6840"
            />
            <path
              d="M1278.6,470c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1278.6,470Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1272.85,464.92c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1272.85,464.92Z"
              fill="#2f6840"
            />
            <path
              d="M1272.34,464.57c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1272.34,464.57Z"
              fill="#3ba525"
            />
            <path
              d="M1273.09,464.55a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1273.09,464.55Z"
              fill="#2f6840"
            />
            <path
              d="M1276.57,463.75c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1276.57,463.75Z"
              fill="#2f6840"
            />
            <path
              d="M1275.2,467a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1275.2,467Z"
              fill="#2f6840"
            />
            <path
              d="M1273.25,465a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1273.25,465Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1264.5,461.55c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1264.5,461.55Z"
              fill="#2f6840"
            />
            <path
              d="M1264,461.2c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1264,461.2Z"
              fill="#3ba525"
            />
            <path
              d="M1264.75,461.17a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1264.75,461.17Z"
              fill="#2f6840"
            />
            <path
              d="M1268.23,460.38c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1268.23,460.38Z"
              fill="#2f6840"
            />
            <path
              d="M1266.86,463.59a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1266.86,463.59Z"
              fill="#2f6840"
            />
            <path
              d="M1264.9,461.63c-.24.06-.47.09-.69.16a4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1264.9,461.63Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1279.21,477c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1279.21,477Z"
              fill="#2f6840"
            />
            <path
              d="M1278.7,476.69c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1278.7,476.69Z"
              fill="#3ba525"
            />
            <path
              d="M1279.46,476.66a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1279.46,476.66Z"
              fill="#2f6840"
            />
            <path
              d="M1282.93,475.87c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1282.93,475.87Z"
              fill="#2f6840"
            />
            <path
              d="M1281.57,479.08a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1281.57,479.08Z"
              fill="#2f6840"
            />
            <path
              d="M1279.61,477.12c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1279.61,477.12Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1265.75,471.47c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1265.75,471.47Z"
              fill="#2f6840"
            />
            <path
              d="M1265.25,471.12c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1265.25,471.12Z"
              fill="#3ba525"
            />
            <path
              d="M1266,471.09a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1266,471.09Z"
              fill="#2f6840"
            />
            <path
              d="M1269.48,470.3c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1269.48,470.3Z"
              fill="#2f6840"
            />
            <path
              d="M1268.11,473.51a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1268.11,473.51Z"
              fill="#2f6840"
            />
            <path
              d="M1266.15,471.55c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1266.15,471.55Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1254.52,450.43c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1254.52,450.43Z"
              fill="#2f6840"
            />
            <path
              d="M1254,450.09c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1254,450.09Z"
              fill="#3ba525"
            />
            <path
              d="M1254.77,450.06a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1254.77,450.06Z"
              fill="#2f6840"
            />
            <path
              d="M1258.24,449.26c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1258.24,449.26Z"
              fill="#2f6840"
            />
            <path
              d="M1256.88,452.47a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1256.88,452.47Z"
              fill="#2f6840"
            />
            <path
              d="M1254.92,450.52c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1254.92,450.52Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1251.86,459.16c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1251.86,459.16Z"
              fill="#2f6840"
            />
            <path
              d="M1251.36,458.82c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1251.36,458.82Z"
              fill="#3ba525"
            />
            <path
              d="M1252.11,458.79a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1252.11,458.79Z"
              fill="#2f6840"
            />
            <path
              d="M1255.59,458c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1255.59,458Z"
              fill="#2f6840"
            />
            <path
              d="M1254.22,461.2a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1254.22,461.2Z"
              fill="#2f6840"
            />
            <path
              d="M1252.26,459.25c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1252.26,459.25Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1246.51,454.2c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1246.51,454.2Z"
              fill="#2f6840"
            />
            <path
              d="M1246,453.86c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1246,453.86Z"
              fill="#3ba525"
            />
            <path
              d="M1246.76,453.83a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1246.76,453.83Z"
              fill="#2f6840"
            />
            <path
              d="M1250.23,453c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1250.23,453Z"
              fill="#2f6840"
            />
            <path
              d="M1248.87,456.25a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1248.87,456.25Z"
              fill="#2f6840"
            />
            <path
              d="M1246.91,454.29c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1246.91,454.29Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1238.17,450.83c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1238.17,450.83Z"
              fill="#2f6840"
            />
            <path
              d="M1237.66,450.49c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1237.66,450.49Z"
              fill="#3ba525"
            />
            <path
              d="M1238.41,450.46a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1238.41,450.46Z"
              fill="#2f6840"
            />
            <path
              d="M1241.89,449.66c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1241.89,449.66Z"
              fill="#2f6840"
            />
            <path
              d="M1240.52,452.87a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1240.52,452.87Z"
              fill="#2f6840"
            />
            <path
              d="M1238.56,450.92c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1238.56,450.92Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1252.87,466.32c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1252.87,466.32Z"
              fill="#2f6840"
            />
            <path
              d="M1252.36,466c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1252.36,466Z"
              fill="#3ba525"
            />
            <path
              d="M1253.12,466a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1253.12,466Z"
              fill="#2f6840"
            />
            <path
              d="M1256.6,465.15c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1256.6,465.15Z"
              fill="#2f6840"
            />
            <path
              d="M1255.23,468.36a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1255.23,468.36Z"
              fill="#2f6840"
            />
            <path
              d="M1253.27,466.41c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,1253.27,466.41Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1239.41,460.75c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1239.41,460.75Z"
              fill="#2f6840"
            />
            <path
              d="M1238.91,460.41c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1238.91,460.41Z"
              fill="#3ba525"
            />
            <path
              d="M1239.66,460.38a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1239.66,460.38Z"
              fill="#2f6840"
            />
            <path
              d="M1243.14,459.58c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1243.14,459.58Z"
              fill="#2f6840"
            />
            <path
              d="M1241.77,462.79a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1241.77,462.79Z"
              fill="#2f6840"
            />
            <path
              d="M1239.81,460.84c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1239.81,460.84Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1231,438.41c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1231,438.41Z"
              fill="#2f6840"
            />
            <path
              d="M1230.52,438.06c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1230.52,438.06Z"
              fill="#3ba525"
            />
            <path
              d="M1231.28,438a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1231.28,438Z"
              fill="#2f6840"
            />
            <path
              d="M1234.76,437.24c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.23-.86A2.1,2.1,0,0,1,1234.76,437.24Z"
              fill="#2f6840"
            />
            <path
              d="M1233.39,440.45a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1233.39,440.45Z"
              fill="#2f6840"
            />
            <path
              d="M1231.43,438.49c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1231.43,438.49Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1228.37,447.13c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1228.37,447.13Z"
              fill="#2f6840"
            />
            <path
              d="M1227.87,446.79c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1227.87,446.79Z"
              fill="#3ba525"
            />
            <path
              d="M1228.62,446.76a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1228.62,446.76Z"
              fill="#2f6840"
            />
            <path
              d="M1232.1,446c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1232.1,446Z"
              fill="#2f6840"
            />
            <path
              d="M1230.73,449.18a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1230.73,449.18Z"
              fill="#2f6840"
            />
            <path
              d="M1228.77,447.22c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1228.77,447.22Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1223,442.18c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1223,442.18Z"
              fill="#2f6840"
            />
            <path
              d="M1222.51,441.83c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1222.51,441.83Z"
              fill="#3ba525"
            />
            <path
              d="M1223.27,441.8a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1223.27,441.8Z"
              fill="#2f6840"
            />
            <path
              d="M1226.74,441a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1226.74,441Z"
              fill="#2f6840"
            />
            <path
              d="M1225.38,444.22a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1225.38,444.22Z"
              fill="#2f6840"
            />
            <path
              d="M1223.42,442.26c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1223.42,442.26Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1214.68,438.8c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1214.68,438.8Z"
              fill="#2f6840"
            />
            <path
              d="M1214.17,438.46c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1214.17,438.46Z"
              fill="#3ba525"
            />
            <path
              d="M1214.92,438.43a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1214.92,438.43Z"
              fill="#2f6840"
            />
            <path
              d="M1218.4,437.64c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1218.4,437.64Z"
              fill="#2f6840"
            />
            <path
              d="M1217,440.85a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1217,440.85Z"
              fill="#2f6840"
            />
            <path
              d="M1215.08,438.89c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1215.08,438.89Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1229.38,454.29c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1229.38,454.29Z"
              fill="#2f6840"
            />
            <path
              d="M1228.88,454c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1228.88,454Z"
              fill="#3ba525"
            />
            <path
              d="M1229.63,453.92a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1229.63,453.92Z"
              fill="#2f6840"
            />
            <path
              d="M1233.11,453.13c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1233.11,453.13Z"
              fill="#2f6840"
            />
            <path
              d="M1231.74,456.34a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1231.74,456.34Z"
              fill="#2f6840"
            />
            <path
              d="M1229.78,454.38c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1229.78,454.38Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1215.92,448.72c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1215.92,448.72Z"
              fill="#2f6840"
            />
            <path
              d="M1215.42,448.38c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1215.42,448.38Z"
              fill="#3ba525"
            />
            <path
              d="M1216.17,448.35a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1216.17,448.35Z"
              fill="#2f6840"
            />
            <path
              d="M1219.65,447.56c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1219.65,447.56Z"
              fill="#2f6840"
            />
            <path
              d="M1218.28,450.77a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1218.28,450.77Z"
              fill="#2f6840"
            />
            <path
              d="M1216.32,448.81c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1216.32,448.81Z"
              fill="#2f6840"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="M1192,431.7c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1192,431.7Z"
              fill="#2f6840"
            />
            <path
              d="M1191.52,431.36c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1191.52,431.36Z"
              fill="#3ba525"
            />
            <path
              d="M1192.27,431.33a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1192.27,431.33Z"
              fill="#2f6840"
            />
            <path
              d="M1195.75,430.54c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1195.75,430.54Z"
              fill="#2f6840"
            />
            <path
              d="M1194.38,433.75a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1194.38,433.75Z"
              fill="#2f6840"
            />
            <path
              d="M1192.42,431.79c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1192.42,431.79Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1189.36,440.43c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1189.36,440.43Z"
              fill="#2f6840"
            />
            <path
              d="M1188.86,440.09c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1188.86,440.09Z"
              fill="#3ba525"
            />
            <path
              d="M1189.61,440.06a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1189.61,440.06Z"
              fill="#2f6840"
            />
            <path
              d="M1193.09,439.27c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1193.09,439.27Z"
              fill="#2f6840"
            />
            <path
              d="M1191.72,442.48a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1191.72,442.48Z"
              fill="#2f6840"
            />
            <path
              d="M1189.76,440.52c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1189.76,440.52Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1184,435.48c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1184,435.48Z"
              fill="#2f6840"
            />
            <path
              d="M1183.51,435.13c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71S1184,436,1184,436s-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1183.51,435.13Z"
              fill="#3ba525"
            />
            <path
              d="M1184.26,435.1a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1184.26,435.1Z"
              fill="#2f6840"
            />
            <path
              d="M1187.74,434.31a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1187.74,434.31Z"
              fill="#2f6840"
            />
            <path
              d="M1186.37,437.52a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1186.37,437.52Z"
              fill="#2f6840"
            />
            <path
              d="M1184.41,435.56c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1184.41,435.56Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1175.67,432.1c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1175.67,432.1Z"
              fill="#2f6840"
            />
            <path
              d="M1175.16,431.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1175.16,431.76Z"
              fill="#3ba525"
            />
            <path
              d="M1175.92,431.73a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1175.92,431.73Z"
              fill="#2f6840"
            />
            <path
              d="M1179.39,430.94c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1179.39,430.94Z"
              fill="#2f6840"
            />
            <path
              d="M1178,434.15a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1178,434.15Z"
              fill="#2f6840"
            />
            <path
              d="M1176.07,432.19c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1176.07,432.19Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1190.37,447.59c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1190.37,447.59Z"
              fill="#2f6840"
            />
            <path
              d="M1189.87,447.25c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1189.87,447.25Z"
              fill="#3ba525"
            />
            <path
              d="M1190.62,447.22a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1190.62,447.22Z"
              fill="#2f6840"
            />
            <path
              d="M1194.1,446.43c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1194.1,446.43Z"
              fill="#2f6840"
            />
            <path
              d="M1192.73,449.64a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1192.73,449.64Z"
              fill="#2f6840"
            />
            <path
              d="M1190.77,447.68c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1190.77,447.68Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1176.92,442c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1176.92,442Z"
              fill="#2f6840"
            />
            <path
              d="M1176.41,441.68c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1176.41,441.68Z"
              fill="#3ba525"
            />
            <path
              d="M1177.16,441.65a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1177.16,441.65Z"
              fill="#2f6840"
            />
            <path
              d="M1180.64,440.86c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1180.64,440.86Z"
              fill="#2f6840"
            />
            <path
              d="M1179.27,444.07a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1179.27,444.07Z"
              fill="#2f6840"
            />
            <path
              d="M1177.32,442.11c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1177.32,442.11Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1170.92,413.08c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1170.92,413.08Z"
              fill="#2f6840"
            />
            <path
              d="M1170.42,412.73c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1170.42,412.73Z"
              fill="#3ba525"
            />
            <path
              d="M1171.17,412.7a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1171.17,412.7Z"
              fill="#2f6840"
            />
            <path
              d="M1174.65,411.91c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1174.65,411.91Z"
              fill="#2f6840"
            />
            <path
              d="M1173.28,415.12a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1173.28,415.12Z"
              fill="#2f6840"
            />
            <path
              d="M1171.32,413.16c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,11.39,11.39,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1171.32,413.16Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1168.26,421.8c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1168.26,421.8Z"
              fill="#2f6840"
            />
            <path
              d="M1167.76,421.46c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1167.76,421.46Z"
              fill="#3ba525"
            />
            <path
              d="M1168.51,421.43a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1168.51,421.43Z"
              fill="#2f6840"
            />
            <path
              d="M1172,420.64c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1172,420.64Z"
              fill="#2f6840"
            />
            <path
              d="M1170.62,423.85a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1170.62,423.85Z"
              fill="#2f6840"
            />
            <path
              d="M1168.66,421.89c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1168.66,421.89Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1162.91,416.85c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1162.91,416.85Z"
              fill="#2f6840"
            />
            <path
              d="M1162.41,416.5c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1162.41,416.5Z"
              fill="#3ba525"
            />
            <path
              d="M1163.16,416.47a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1163.16,416.47Z"
              fill="#2f6840"
            />
            <path
              d="M1166.64,415.68a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1166.64,415.68Z"
              fill="#2f6840"
            />
            <path
              d="M1165.27,418.89a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1165.27,418.89Z"
              fill="#2f6840"
            />
            <path
              d="M1163.31,416.93c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1163.31,416.93Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1154.57,413.47c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1154.57,413.47Z"
              fill="#2f6840"
            />
            <path
              d="M1154.06,413.13c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1154.06,413.13Z"
              fill="#3ba525"
            />
            <path
              d="M1154.82,413.1a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1154.82,413.1Z"
              fill="#2f6840"
            />
            <path
              d="M1158.29,412.31c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1158.29,412.31Z"
              fill="#2f6840"
            />
            <path
              d="M1156.93,415.52a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1156.93,415.52Z"
              fill="#2f6840"
            />
            <path
              d="M1155,413.56c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1155,413.56Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1169.27,429c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1169.27,429Z"
              fill="#2f6840"
            />
            <path
              d="M1168.77,428.62c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1168.77,428.62Z"
              fill="#3ba525"
            />
            <path
              d="M1169.52,428.59a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1169.52,428.59Z"
              fill="#2f6840"
            />
            <path
              d="M1173,427.8c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1173,427.8Z"
              fill="#2f6840"
            />
            <path
              d="M1171.63,431a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1171.63,431Z"
              fill="#2f6840"
            />
            <path
              d="M1169.67,429.05c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1169.67,429.05Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1155.82,423.39c4.42-.25-4.33.46-4.35-.61s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1155.82,423.39Z"
              fill="#2f6840"
            />
            <path
              d="M1155.31,423.05c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1155.31,423.05Z"
              fill="#3ba525"
            />
            <path
              d="M1156.06,423a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1156.06,423Z"
              fill="#2f6840"
            />
            <path
              d="M1159.54,422.23c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1159.54,422.23Z"
              fill="#2f6840"
            />
            <path
              d="M1158.17,425.44a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1158.17,425.44Z"
              fill="#2f6840"
            />
            <path
              d="M1156.22,423.48c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1156.22,423.48Z"
              fill="#2f6840"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M1221.87,460.64l2.26,1.4a.71.71,0,0,0,.68,0l5.42-2.43a.73.73,0,0,0,.18-1.22h0a.72.72,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1221.87,460.64Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1225.88 455.03 1222.82 455.68 1220.13 457.75 1224.64 459.56 1230.16 457.3 1225.88 455.03"
            fill="#ffedc8"
          />
          <polygon
            points="1220.13 457.75 1220.13 459.56 1224.46 461.41 1230.28 459.05 1230.16 457.3 1224.64 459.56 1220.13 457.75"
            fill="#ccae79"
          />
          <polygon
            points="1224.64 459.56 1224.46 461.41 1230.28 459.05 1230.16 457.3 1224.64 459.56"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1221.42,458.27a.81.81,0,0,1,0,.92c.2-.29.25-.82.34-.79Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1223.32,459a2.57,2.57,0,0,0,1.14-1.16l-.82,1.29Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1226.92,458.62a.84.84,0,0,1,.45.73l-.14-.85Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1228.94,456.65a5.32,5.32,0,0,1-1.79,0,2.51,2.51,0,0,1-1.31.09s1-.09,1.31.24A7.66,7.66,0,0,1,1228.94,456.65Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1230.24,510.4l2.25,1.4a.74.74,0,0,0,.69.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.72.72,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1230.24,510.4Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1234.24 504.8 1231.19 505.44 1228.5 507.51 1233.01 509.32 1238.53 507.06 1234.24 504.8"
            fill="#ffedc8"
          />
          <polygon
            points="1228.5 507.51 1228.5 509.32 1232.83 511.18 1238.65 508.81 1238.53 507.06 1233.01 509.32 1228.5 507.51"
            fill="#ccae79"
          />
          <polygon
            points="1233.01 509.32 1232.83 511.18 1238.65 508.81 1238.53 507.06 1233.01 509.32"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1229.78,508a.8.8,0,0,1,0,.93c.21-.29.26-.83.35-.79Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1231.69,508.79a2.58,2.58,0,0,0,1.13-1.15l-.81,1.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1235.29,508.39a.83.83,0,0,1,.45.73l-.14-.86Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1237.31,506.41a5.37,5.37,0,0,1-1.8,0,2.47,2.47,0,0,1-1.3.09s1-.09,1.3.24A7.72,7.72,0,0,1,1237.31,506.41Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1242.16,467.21l3.89,2.41a1.27,1.27,0,0,0,1.18.08l9.34-4.17a1.27,1.27,0,0,0,.32-2.11h0a1.26,1.26,0,0,0-1-.3l-13.23,1.76A1.26,1.26,0,0,0,1242.16,467.21Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1249.06 457.54 1243.8 458.66 1239.16 462.23 1246.93 465.34 1256.45 461.44 1249.06 457.54"
            fill="#ffedc8"
          />
          <polygon
            points="1239.16 462.23 1239.16 465.34 1246.62 468.54 1256.66 464.46 1256.45 461.44 1246.93 465.34 1239.16 462.23"
            fill="#ccae79"
          />
          <polygon
            points="1246.93 465.34 1246.62 468.54 1256.66 464.46 1256.45 461.44 1246.93 465.34"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1241.38,463.12a1.4,1.4,0,0,1,0,1.6c.35-.51.43-1.43.59-1.37Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1244.66,464.43a4.48,4.48,0,0,0,2-2l-1.41,2.21Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1250.86,463.73a1.44,1.44,0,0,1,.78,1.26l-.23-1.48Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1254.34,460.33a9.1,9.1,0,0,1-3.09,0,4.52,4.52,0,0,1-2.25.16s1.65-.16,2.25.4A13.28,13.28,0,0,1,1254.34,460.33Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1289.6,482.86s-1.6,3.18-3.83,3.72-5.6-1.68-5.08.15-4.2,2.65-6.23,2.16-6.47-4.83-6.45-6.21S1289.6,482.86,1289.6,482.86Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M1289.67,480.24l-.07,2.62-3.84,2.67-5-.13-1.18,1.91s-3.44,1.6-5.73-.15a18.76,18.76,0,0,1-4-4.84l.07-2.61Z"
            fill="#ccae79"
          />
          <path
            d="M1285.67,478.44l4,1.8-4.12,2.67-4.76-.13-1.59,2s-4.68,1.26-5.25-.14-4-4.89-4-4.89l3.74-1.59Z"
            fill="#ffedc8"
          />
          <polygon
            points="1285.55 482.91 1285.76 485.53 1280.78 485.4 1280.8 482.78 1285.55 482.91"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1275.13,485.23s-.82,2.37-.07,2.54a11.47,11.47,0,0,1-5.21-5.45l.07-2.61S1274,485.21,1275.13,485.23Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1278.35,484.94l-.95.17s.59-.15.45.95A2.61,2.61,0,0,1,1278.35,484.94Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1276.19,485.27a6.13,6.13,0,0,1-1-.88,5.53,5.53,0,0,1-1.15-1.8s2,2.34,1.52,2.66Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1287.26,481.8a17.55,17.55,0,0,0,0,1.89s.11-1.42-.28-1.67Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1280,478.29l-1.89-.06c-.14,0,1.48,0,1.87.9l0-.84"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1287.66,479.34l-1-.45s.55.36.33.43-1.11.43-1.46.24a1.45,1.45,0,0,0-1,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1270.52,511.45s-1,2.07-2.5,2.42-3.65-1.09-3.31.1-2.74,1.73-4.06,1.41-4.22-3.15-4.2-4.05S1270.52,511.45,1270.52,511.45Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M1270.57,509.74l0,1.71-2.51,1.74-3.24-.09-.77,1.25s-2.24,1-3.73-.1a12.1,12.1,0,0,1-2.63-3.15l0-1.71Z"
            fill="#ccae79"
          />
          <path
            d="M1268,508.57l2.61,1.17-2.69,1.74-3.1-.09-1,1.28s-3,.82-3.43-.09a19,19,0,0,0-2.62-3.19l2.44-1Z"
            fill="#ffedc8"
          />
          <polygon
            points="1267.88 511.48 1268.02 513.19 1264.77 513.1 1264.78 511.39 1267.88 511.48"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1261.09,513s-.54,1.55,0,1.66a7.49,7.49,0,0,1-3.4-3.55l0-1.71S1260.37,513,1261.09,513Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1263.18,512.8l-.61.11s.38-.1.29.62A1.7,1.7,0,0,1,1263.18,512.8Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1261.77,513c.07,0-.12,0-.67-.57a3.67,3.67,0,0,1-.75-1.17s1.31,1.52,1,1.73Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1269,510.76a10.65,10.65,0,0,0,0,1.23s.07-.93-.19-1.09Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1264.23,508.47l-1.24,0c-.09,0,1,0,1.22.58v-.54"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1269.25,509.15l-.65-.29s.37.23.22.28-.72.28-1,.16a.91.91,0,0,0-.62,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
    </g>
  );
};

export default Trope3;
